import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { MapControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import gsap from 'gsap'
import * as dat from 'lil-gui'
import { color } from 'three/examples/jsm/nodes/Nodes.js'

/**
 * Loaders
 */
let sceneReady = false
const loadingBarElement = document.querySelector('.loading-bar')
const loadingManager = new THREE.LoadingManager(
    // Loaded
    () =>
    {
        window.setTimeout(() =>
        {
            gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0, delay: 1 })

            loadingBarElement.classList.add('ended')
            loadingBarElement.style.transform = ''
        }, 500)

        window.setTimeout(() =>
        {
            sceneReady = true
        }, 3000)
    },
    // Progress
    (itemUrl, itemsLoaded, itemsTotal) =>
    {
        const progressRatio = itemsLoaded / itemsTotal
        loadingBarElement.style.transform = `scaleX(${progressRatio})`
    }
)
// const loader = new GLTFLoader(loadingManager)
const textureLoader = new THREE.TextureLoader(loadingManager)
const cubeTextureLoader = new THREE.CubeTextureLoader()

/**
 * Texture
 */
const colorTexture = textureLoader.load('./textures/map1.jpg')

colorTexture.wrapS = THREE.MirroredRepeatWrapping
colorTexture.wrapT = THREE.MirroredRepeatWrapping

colorTexture.generateMipmaps = false
colorTexture.minFilter = THREE.NearestFilter
colorTexture.magFilter = THREE.NearestFilter


/**
 * Наименования магазинов
 */

const fontLoader_x_ray = new FontLoader()
fontLoader_x_ray.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'X-Ray', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(11.85, 2, 2.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_snowimage = new FontLoader()
fontLoader_snowimage.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Snowimage', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(16.5, 2, 6.1)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_dimanche_lingerie = new FontLoader()
fontLoader_dimanche_lingerie.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Dimanche', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(19.88, 2, 5.9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_dimanche_lingerie1 = new FontLoader()
fontLoader_dimanche_lingerie1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Lingerie', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(19.88, 2, 6.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
// DNS Технопоинт
const fontLoader_dnstehno = new FontLoader()
fontLoader_dnstehno.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'DNS Технопоинт ', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(11.86, 2, 22)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_smart = new FontLoader()
fontLoader_smart.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Smart ', { font: font, size: 1.2, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-2, 2, 20.85)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_joss_1 = new FontLoader()
fontLoader_joss_1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Joss', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-42.07, 2, 10.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_breeze = new FontLoader()
fontLoader_breeze.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Breeze', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-39.2, 2, 10)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_new_lok = new FontLoader()
fontLoader_new_lok.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'New Lok', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-49.85, 2, 8.55)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_givoy_mir = new FontLoader()
fontLoader_givoy_mir.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Живой мир', { font: font, size: 0.7, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-52.9, 2, 8.55)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_studvozdgimnast = new FontLoader()
fontLoader_studvozdgimnast.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Студия', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-55.7, 2, 8.56)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_studvozdgimnast1 = new FontLoader()
fontLoader_studvozdgimnast1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'воздушной гимнастики', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-55, 2, 8.56)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_viktoriya = new FontLoader()
fontLoader_viktoriya.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Виктория', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-57.55, 2, 10.1)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sfera_dyma = new FontLoader()
fontLoader_sfera_dyma.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Сфера дыма', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-61.15, 2, 10.1)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_cyber_service = new FontLoader()
fontLoader_cyber_service.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Cyber', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-62.27, 2, 15.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_cyber_service1 = new FontLoader()
fontLoader_cyber_service1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Service', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-62.27, 2, 16.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_umka = new FontLoader()
fontLoader_umka.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Умка', { font: font, size: 0.35, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-64.7, 2, 16.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ivprint = new FontLoader()
fontLoader_ivprint.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ивпринт', { font: font, size: 0.35, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-65.2, 2, 18.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kolyasochka37 = new FontLoader()
fontLoader_kolyasochka37.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Колясочка37', { font: font, size: 0.35, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-65.7, 2, 21)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_dom_posudy = new FontLoader()
fontLoader_dom_posudy.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Дом посуды', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-66.3, 2, 23.68)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_moloko = new FontLoader()
fontLoader_moloko.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Moloko', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-71.7, 2, 31.27)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_hali_gali = new FontLoader()
fontLoader_hali_gali.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Хали Гали', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-66.64, 2, 32.2)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_detskiy_mir = new FontLoader()
fontLoader_detskiy_mir.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Детский', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-81.45, 2, 16.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_detskiy_mir1 = new FontLoader()
fontLoader_detskiy_mir1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'мир', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-81.45, 2, 18.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_padel = new FontLoader()
fontLoader_padel.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Padel Place', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-73.6, 2, 16.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kort = new FontLoader()
fontLoader_kort.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'теннисный корт', { font: font, size: 0.7, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-73.6, 2, 18.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_horoshie_novosti = new FontLoader()
fontLoader_horoshie_novosti.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '   ', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-80.2, 2, 31.18)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_horoshie_novosti1 = new FontLoader()
fontLoader_horoshie_novosti1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '   ', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-80.2, 2, 31.78)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ferma = new FontLoader()
fontLoader_ferma.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Фермерские', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-83.3, 2, 44)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ferma1 = new FontLoader()
fontLoader_ferma1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'продукты', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-82.3, 2, 44)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lavka = new FontLoader()
fontLoader_lavka.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Церковная', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-83.15, 2, 31.18)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lavka1 = new FontLoader()
fontLoader_lavka1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'лавка', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-83.15, 2, 31.78)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_turagent = new FontLoader()
fontLoader_turagent.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Тур.', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-86.5, 2, 31.18)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_turagent1 = new FontLoader()
fontLoader_turagent1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'агентство', { font: font, size: 0.28, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-85.98, 2, 31.78)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_bazar = new FontLoader()
fontLoader_bazar.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Bazar', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-93, 2, 28.71)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kartridg = new FontLoader()
fontLoader_kartridg.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Картридж', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-58.9, 2, 16.07)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_operativka = new FontLoader()
fontLoader_operativka.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Оперативка', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-44.53, 2, 16.58)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_you_style = new FontLoader()
fontLoader_you_style.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'You Style', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-41.04, 2, 16.58)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_masis = new FontLoader()
fontLoader_masis.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Masis', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-39.37, 2, 16.48)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_joss = new FontLoader()
fontLoader_joss.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Joss', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-37.61, 2, 16.58)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lovemoda = new FontLoader()
fontLoader_lovemoda.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Lovemoda', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-35.06, 2, 16.28)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_biznes_lend = new FontLoader()
fontLoader_biznes_lend.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Бизнес-Лэнд', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-47.57, 2, 33.18)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_dom_odegda = new FontLoader()
fontLoader_dom_odegda.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Дом одежда обувь', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-50.37, 2, 24.73)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_remkomplekt = new FontLoader()
fontLoader_remkomplekt.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'РемКомплект', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-73.35, 2, 33.85)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_pryaga = new FontLoader()
fontLoader_pryaga.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Пряжа', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(2.62, 2, 1.05)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lider = new FontLoader()
fontLoader_lider.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Лидер', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(2.62, 2, 2.15)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_dgins_miks = new FontLoader()
fontLoader_dgins_miks.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Джинсовый микс', { font: font, size: 0.27, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(2.62, 2, 4.35)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_vesel_assortiment = new FontLoader()
fontLoader_vesel_assortiment.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Весёленький', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(2.62, 2, 5.54)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_vesel_assortiment1 = new FontLoader()
fontLoader_vesel_assortiment1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'ассортимент', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(2.62, 2, 6.2)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_miss_poem = new FontLoader()
fontLoader_miss_poem.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Miss Poem', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(5.14, 2, 6.31)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_huligan = new FontLoader()
fontLoader_huligan.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ещё', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-4.8, 2, 0.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
/*
const fontLoader_ilady = new FontLoader()
fontLoader_ilady.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '   ', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-4.13, 2, -18.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
) **/
const fontLoader_rospromobuv = new FontLoader()
fontLoader_rospromobuv.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'РосПромОбувь', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-17.15, 2, -15.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kapika = new FontLoader()
fontLoader_kapika.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Kapika', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-11.5, 2, 5.25)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_tekbir = new FontLoader()
fontLoader_tekbir.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Tekbir', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-24.45, 2, 4.6)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_salsa = new FontLoader()
fontLoader_salsa.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Salsa', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-22, 2, 4.15)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_millioner = new FontLoader()
fontLoader_millioner.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Millioner', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-28.8, 2, 3)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ekonom = new FontLoader()
fontLoader_ekonom.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Аптека', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-6.5, 2, 13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ekonom1 = new FontLoader()
fontLoader_ekonom1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Эконом', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-5.7, 2, 13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_bagira = new FontLoader()
fontLoader_bagira.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Bagira', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-8.35, 2, 13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kotofey = new FontLoader()
fontLoader_kotofey.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Котофей', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-10.6, 2, 13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_manstyle = new FontLoader()
fontLoader_manstyle.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Man Style', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-15.6, 2, 14.65)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lavita = new FontLoader()
fontLoader_lavita.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Студия', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-32.45, 2, -12.05)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lavita1 = new FontLoader()
fontLoader_lavita1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'растяжки', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-32.45, 2, -11.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lavita2 = new FontLoader()
fontLoader_lavita2.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Lavita', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-32.45, 2, -11.05)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_anturag = new FontLoader()
fontLoader_anturag.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Антураж', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-32, 2, -13.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_studia_lak = new FontLoader()
fontLoader_studia_lak.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Студия лак', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-32.45, 2, -9.55)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_molkova_dress = new FontLoader()
fontLoader_molkova_dress.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Molkova', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-32.2, 2, -1.2)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_molkova_dress1 = new FontLoader()
fontLoader_molkova_dress1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Dress', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-32.2, 2, -0.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_stilyagi = new FontLoader()
fontLoader_stilyagi.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Стиляги', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-32.5, 2, 6.36)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_familiya = new FontLoader()
fontLoader_familiya.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Фамилия', { font: font, size: 1.2, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-21.8, 2, 20.85)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_access = new FontLoader()
fontLoader_access.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Access', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(15.5, 2, 13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_medeya = new FontLoader()
fontLoader_medeya.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Медея', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-27, 2, 13.7)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_scorpion = new FontLoader()
fontLoader_scorpion.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Scorpion', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(9.72, 2, 6.25)
                text.rotation.x = -Math.PI/2
                text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_scorpion2 = new FontLoader()
fontLoader_scorpion2.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Scorpion', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(17.1, 2, 3.2)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_rascheska = new FontLoader()
fontLoader_rascheska.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Расчёска', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(16.9, 2, 0.62)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_veste = new FontLoader()
fontLoader_veste.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Veste', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(13.4, 2, 13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ballare = new FontLoader()
fontLoader_ballare.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ballare', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(11.2, 2, 13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_obuv = new FontLoader()
fontLoader_obuv.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '   ', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(13.45,2,-2.25)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_planeta_d = new FontLoader()
fontLoader_planeta_d.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Планета джинсов', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(13.45, 2, -5.4)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_industr_krasoty = new FontLoader()
fontLoader_industr_krasoty.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Хулиган', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(15, 2, -8.06)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_magiya_mody = new FontLoader()
fontLoader_magiya_mody.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Магия моды', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(15, 2, -10.28)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_garnet = new FontLoader()
fontLoader_garnet.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Garnet', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(17.3, 2, -12.93)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sakvoyag = new FontLoader()
fontLoader_sakvoyag.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Саквояж', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(19.4, 2, -17.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_meh_dlya_vseh = new FontLoader()
fontLoader_meh_dlya_vseh.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Мех для всех', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(3.3, 2, -16)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_leonardo = new FontLoader()
fontLoader_leonardo.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Леонардо', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(19.2, 2, 16.5)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ostrov_sokolov = new FontLoader()
fontLoader_ostrov_sokolov.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Sokolov', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(32.7, 2, 19.5)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_slavdom = new FontLoader()
fontLoader_slavdom.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Слав.', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(29.9, 2, 11.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_slavdom1 = new FontLoader()
fontLoader_slavdom1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'дом', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(29.9, 2, 12.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_gelezdoroga = new FontLoader()
fontLoader_gelezdoroga.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Аттракцион', { font: font, size: 0.2, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(54.36, 2, 11.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_gelezdoroga1 = new FontLoader()
fontLoader_gelezdoroga1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Железная', { font: font, size: 0.25, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(54.36, 2, 11.9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_gelezdoroga2 = new FontLoader()
fontLoader_gelezdoroga2.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'дорога', { font: font, size: 0.25, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(54.36, 2, 12.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_modi = new FontLoader()
fontLoader_modi.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Modi', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(25.4, 2, 18.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sweet_cat = new FontLoader()
fontLoader_sweet_cat.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Sweet Cat', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(25.4, 2, 21.1)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_svyaz = new FontLoader()
fontLoader_svyaz.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            ' ', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(27.7, 2, 25.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_aikraft = new FontLoader()
fontLoader_aikraft.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Айкрафт', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(27.75, 2, 15.3)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_585_zolotoy = new FontLoader()
fontLoader_585_zolotoy.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '585 Золотой', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(37.64, 2, 23.35)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_megafon = new FontLoader()
fontLoader_megafon.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Мегафон', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(39.01, 2, 18.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kosmetichka = new FontLoader()
fontLoader_kosmetichka.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Косметичка', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(39.5, 2, 15.1)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_beelain = new FontLoader()
fontLoader_beelain.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Билайн', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(41.7, 2, 15.13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_podrugka = new FontLoader()
fontLoader_podrugka.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Подружка', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(45.05, 2, 15.13)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sotiks = new FontLoader()
fontLoader_sotiks.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Sotiks', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(52.15, 2, 15.13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_diamant = new FontLoader()
fontLoader_diamant.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Diamant', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(54.36, 2, 15.13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_fabrika_kostuma = new FontLoader()
fontLoader_fabrika_kostuma.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Фабрика', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(56.0, 2, 15.13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_fabrika_kostuma1 = new FontLoader()
fontLoader_fabrika_kostuma1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'костюма', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(56.8, 2, 15.13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mts = new FontLoader()
fontLoader_mts.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'МТС', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(58.3, 2, 15.13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_angel = new FontLoader()
fontLoader_angel.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ангел', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(60, 2, 15.13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_zdorovie = new FontLoader()
fontLoader_zdorovie.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Здоровье', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(67.3, 2, 16.13)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mir_obivi = new FontLoader()
fontLoader_mir_obivi.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Мир', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(82, 2, 25)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mir_obivi1 = new FontLoader()
fontLoader_mir_obivi1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'обуви', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(82, 2, 26)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_s_holmes = new FontLoader()
fontLoader_s_holmes.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'S. Holmes', { font: font, size: 0.23, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(84.5, 2, 25.8)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_chitay_gorod = new FontLoader()
fontLoader_chitay_gorod.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Читай город', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(21.8, 2, 24.0)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ulybka_radugi = new FontLoader()
fontLoader_ulybka_radugi.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Улыбка радуги', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(22.1, 2, 27.91)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_chigik = new FontLoader()
fontLoader_chigik.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Чижик', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(22.1, 2, 33.91)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_riv_gosh = new FontLoader()
fontLoader_riv_gosh.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Рив Гош', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(24.1, 2, 14.56)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kari_giper = new FontLoader()
fontLoader_kari_giper.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Kari ГИПЕР', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(30.55, 2, -8.28)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_rossini = new FontLoader()
fontLoader_rossini.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Rossini', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(36.4, 2, -15.9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mobshtuki = new FontLoader()
fontLoader_mobshtuki.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Мобильные', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(38.68, 2, -17.62)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mobshtuki1 = new FontLoader()
fontLoader_mobshtuki1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'штучки', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(39.16, 2, -17.15)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_km = new FontLoader()
fontLoader_km.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'K&M', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(39.6, 2, -13)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_savari = new FontLoader()
fontLoader_savari.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Savari', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(38.6, 2, -3.88)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_barhat_shev = new FontLoader()
fontLoader_barhat_shev.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Barhat Shev', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(38.4, 2, -0.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_xiaomi = new FontLoader()
fontLoader_xiaomi.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Xiaomi', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(37.2, 2, 5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_yves_rocher_france = new FontLoader()
fontLoader_yves_rocher_france.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Аптека', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(28.8, 2, 5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_yves_rocher_france1 = new FontLoader()
fontLoader_yves_rocher_france1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Антей', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(28.8, 2, 5.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ukrasim = new FontLoader()
fontLoader_ukrasim.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Украсим', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(25.45, 2, 5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_metelica = new FontLoader()
fontLoader_metelica.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Метелица', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(24.4, 2, 1.45)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sofiya = new FontLoader()
fontLoader_sofiya.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'София', { font: font, size: 0.7, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(23.8, 2, -3.45)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_francesco_donni = new FontLoader()
fontLoader_francesco_donni.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Francesco Donni', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(48.5, 2, 5)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
/*
const fontLoader_rancesco_donni = new FontLoader()
fontLoader_rancesco_donni.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '   ', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(23.9, 2, -9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_rancesco_donni1 = new FontLoader()
fontLoader_rancesco_donni1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '   ', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(23.9, 2, -8.1)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
  **/
const fontLoader_kovry_ = new FontLoader()
fontLoader_kovry_.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ковры', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(25.1, 2, -16.62)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_fashion_shoes = new FontLoader()
fontLoader_fashion_shoes.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Fashion', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(6.8, 2, 3.0)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_fashion_shoes1 = new FontLoader()
fontLoader_fashion_shoes1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Shoes', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(6.8, 2, 3.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ashan = new FontLoader()
fontLoader_ashan.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'АШАН', { font: font, size: 2, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(94, 2, -9.4)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ozon = new FontLoader()
fontLoader_ozon.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ozon', { font: font, size: 0.35, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(81.1, 2, 17.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kancpark = new FontLoader()
fontLoader_kancpark.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'КанцПарк', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(83.92, 2, 18.4)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_krasota = new FontLoader()
fontLoader_krasota.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Салон красоты', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(0.36, 2, -35.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_krasota1 = new FontLoader()
fontLoader_krasota1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '@M&M@', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(0.36, 2, -34.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_futbolis = new FontLoader()
fontLoader_futbolis.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Футболис', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-1, 2, -30.6)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_scarlet = new FontLoader()
fontLoader_scarlet.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Scarlet', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(3.65, 2, -24.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_taxi = new FontLoader()
fontLoader_taxi.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Такси', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(3.65, 2, -26.9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_stirka = new FontLoader()
fontLoader_stirka.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Прачечная', { font: font, size: 0.26, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(3.65, 2, -28.77)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_logoped = new FontLoader()
fontLoader_logoped.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Логопед', { font: font, size: 0.36, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(3.65, 2, -30.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_zoozavr = new FontLoader()
fontLoader_zoozavr.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Зоозавр', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(6.45, 2, -24.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_best = new FontLoader()
fontLoader_best.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Best', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(11.65, 2, -24.85)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ilady = new FontLoader()
fontLoader_ilady.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'I.Lady', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(40.4, 2, -25.32)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_stockburg = new FontLoader()
fontLoader_stockburg.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Stockburg', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(52.8, 2, -29.8)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kristi = new FontLoader()
fontLoader_kristi.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Кристи', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(56.8, 2, -26.6)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_gloria_jeans = new FontLoader()
fontLoader_gloria_jeans.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Gloria Jeans', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(70.25, 2, -31.58)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_diskont_centr = new FontLoader()
fontLoader_diskont_centr.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Дисконт-центр', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(70.25, 2, -25.2)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_himdiana = new FontLoader()
fontLoader_himdiana.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Химчистка', { font: font, size: 0.15, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(67.7, 2, -23.1)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_himdiana1 = new FontLoader()
fontLoader_himdiana1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Диана', { font: font, size: 0.15, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(67.9, 2, -22.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lombard = new FontLoader()
fontLoader_lombard.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ломбард', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(72, 2, -22.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_egoiste = new FontLoader()
fontLoader_egoiste.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Egoiste', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(66.54, 2, -14.48)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sabra = new FontLoader()
fontLoader_sabra.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Sabra', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(69.35, 2, -14.48)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_antey2 = new FontLoader()
fontLoader_antey2.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Антей', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(72.15, 2, -17.79)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kosmedel = new FontLoader()
fontLoader_kosmedel.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Космедэль', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(72.15, 2, -15)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_med_mir = new FontLoader()
fontLoader_med_mir.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Медицинский', { font: font, size: 0.28, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(72.15, 2, -12.1)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_med_mir1 = new FontLoader()
fontLoader_med_mir1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'мир', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(72.15, 2, -11.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_capsula_my = new FontLoader()
fontLoader_capsula_my.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Capsula. My', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(69.35, 2, -8.53)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_1001_sumka = new FontLoader()
fontLoader_1001_sumka.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '1000 и одна сумка', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(69.35, 2, 1.78)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_barselona = new FontLoader()
fontLoader_barselona.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Barselona', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(67.4, 2, 6.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kredo = new FontLoader()
fontLoader_kredo.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Кредо', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(67.4, 2, 7.65)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
// Время стрижки
const fontLoader_vremya_strigki = new FontLoader()
fontLoader_vremya_strigki.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Время', { font: font, size: 0.36, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(69.65, 2, 9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_vremya_strigki1 = new FontLoader()
fontLoader_vremya_strigki1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'стрижки', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(69.65, 2, 9.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mts1 = new FontLoader()
fontLoader_mts1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'МТС', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(74.5, 2, -16.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_johnsons = new FontLoader()
fontLoader_johnsons.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Johnsons', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(75, 2, -14.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_bravo_optika = new FontLoader()
fontLoader_bravo_optika.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Браво', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(75, 2, -12)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_bravo_optika1 = new FontLoader()
fontLoader_bravo_optika1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'оптика', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(75, 2, -11.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_gipfel = new FontLoader()
fontLoader_gipfel.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Gipfel', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(75, 2, -2.9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_rigla = new FontLoader()
fontLoader_rigla.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ригла', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(75, 2, 0)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kofe_chay = new FontLoader()
fontLoader_kofe_chay.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Кофе и чай', { font: font, size: 0.35, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(75, 2, 2.68)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_tele2 = new FontLoader()
fontLoader_tele2.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Tele2', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(75, 2, 6.9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_vost_sladosti = new FontLoader()
fontLoader_vost_sladosti.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Восточные', { font: font, size: 0.2, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(74.45, 2, 8.38)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_vost_sladosti1 = new FontLoader()
fontLoader_vost_sladosti1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'сладости', { font: font, size: 0.2, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(74.25, 2, 8.75)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_letual = new FontLoader()
fontLoader_letual.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Лэтуаль', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(88.76, 2, 19.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_tofa = new FontLoader()
fontLoader_tofa.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Тофа', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(93, 2, 19.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_alleya_mebeli = new FontLoader()
fontLoader_alleya_mebeli.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Аллея мебели', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(101.9, 2, 23.1)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_chetyre_lapy = new FontLoader()
fontLoader_chetyre_lapy.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Четыре лапы', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(99.05, 2, 31.35)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sushimania = new FontLoader()
fontLoader_sushimania.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Суши', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(93.13, 2, 31.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sushimania1 = new FontLoader()
fontLoader_sushimania1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'мания', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(93.13, 2, 32.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_tvoy_bayk = new FontLoader()
fontLoader_tvoy_bayk.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Твой байк', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(58.45, 2, 33.25)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_fix_price = new FontLoader()
fontLoader_fix_price.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Fix Price', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(45.24, 2, 32.85)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoade_uzbegim = new FontLoader()
fontLoade_uzbegim.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Узбегим', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(49.03, 2, 34.78)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mvideo = new FontLoader()
fontLoader_mvideo.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'М.Видео', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(60, 2, 24)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_estet = new FontLoader()
fontLoader_estet.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Эстет', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(39.05, 2, 20.96)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_dns = new FontLoader()
fontLoader_dns.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'DNS', { font: font, size: 1.2, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(46.9, 2, 23.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_corona_store2 = new FontLoader()
fontLoader_corona_store2.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            't2', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(36.8, 2, 15.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)/**
const fontLoader_corona_store21 = new FontLoader()
fontLoader_corona_store21.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Store', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(36.8, 2, 16.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
) */
const fontLoader_heart_of_vape = new FontLoader()
fontLoader_heart_of_vape.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ш.Холмс', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(39.33, 2, 31.31)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_vostok_sladosti1 = new FontLoader()
fontLoader_vostok_sladosti1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Восточные сладости', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(39.33, 2, 33.61)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_rostics = new FontLoader()
fontLoader_rostics.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Rostics', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(38.8, 2, 36.94)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_vseinstrumenty = new FontLoader()
fontLoader_vseinstrumenty.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'ВсеИнструменты.ру', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(14.5, 2, 34)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_meredian1 = new FontLoader()
fontLoader_meredian1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Мерердиан-1', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-17.55, 2, 32.235)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_vkussvil = new FontLoader()
fontLoader_vkussvil.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Склад ВкуссВил', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-2, 2, 32.235)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_fermstore = new FontLoader()
fontLoader_fermstore.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            ' ', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(28.4, 2, 34.4)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_gee_jay = new FontLoader()
fontLoader_gee_jay.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Gee Jay', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-30.48, 2, 13.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_vita = new FontLoader()
fontLoader_vita.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Vita', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-8.75, 2, 5.15)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_eldorado = new FontLoader()
fontLoader_eldorado.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Эльдорадо', { font: font, size: 1.2, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-16.7, 2, -5.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mebel_lend = new FontLoader()
fontLoader_mebel_lend.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Мебель-лэнд', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(30.8, 2, -29.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_best_mebel = new FontLoader()
fontLoader_best_mebel.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Best Mebel', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(10, 2, -30)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_nikol = new FontLoader()
fontLoader_nikol.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Николь', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(15, 2, -31)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ormatek_diskont_1 = new FontLoader()
fontLoader_ormatek_diskont_1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'ORMATEK', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(20, 2, -30)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ormatek_diskont_11 = new FontLoader()
fontLoader_ormatek_diskont_11.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Дисконт', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(20, 2, -29.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sonum = new FontLoader()
fontLoader_sonum.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Сонум', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(17, 2, -25.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_armos = new FontLoader()
fontLoader_armos.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Армос', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(25, 2, -34)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mnogo_mebeli = new FontLoader()
fontLoader_mnogo_mebeli.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Много мебели', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(31, 2, -32)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_versal = new FontLoader()
fontLoader_versal.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Версаль', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(35.5, 2, -34)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lazurit = new FontLoader()
fontLoader_lazurit.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Lazurit', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(36.3, 2, -25.4)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ormatek_diskont = new FontLoader()
fontLoader_ormatek_diskont.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ormatek', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(41, 2, -32)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ormatek_diskont1 = new FontLoader()
fontLoader_ormatek_diskont1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'дисконт', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(41, 2, -31.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sovremen_narod_mebel = new FontLoader()
fontLoader_sovremen_narod_mebel.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Современная', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(25, 2, -25.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sovremen_narod_mebel1 = new FontLoader()
fontLoader_sovremen_narod_mebel1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'народная мебель', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(25, 2, -25)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_indigo = new FontLoader()
fontLoader_indigo.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Модельная школа', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-11, 2, -28.35)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_indigo1 = new FontLoader()
fontLoader_indigo1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Индиго', { font: font, size: 0.8, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-10, 2, -28.35)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_skalalend = new FontLoader()
fontLoader_skalalend.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            '   ', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-17.14, 2, -29)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_warpoint = new FontLoader()
fontLoader_warpoint.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Warpoint-iv', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(-27, 2, -13.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lapotok = new FontLoader()
fontLoader_lapotok.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Лапоток', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(53.3, 2, -15.05)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_5kармаnof = new FontLoader()
fontLoader_5kармаnof.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Eva City', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(57.65, 2, -15.53)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_best_shoes = new FontLoader()
fontLoader_best_shoes.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Best', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(46.76, 2, -17.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_best_shoes1 = new FontLoader()
fontLoader_best_shoes1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Shoes', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(46.76, 2, -16.8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_diana = new FontLoader()
fontLoader_diana.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Диана', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(44.5, 2, -14.96)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_senator = new FontLoader()
fontLoader_senator.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Senator', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(47.64, 2, -12.95)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_mustang = new FontLoader()
fontLoader_mustang.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Mustang', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(47.93, 2, -1.22)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lacarino_woman = new FontLoader()
fontLoader_lacarino_woman.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Lacarino', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(45.88, 2, 3.1)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lacarino_woman1 = new FontLoader()
fontLoader_lacarino_woman1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Woman', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(45.88, 2, 2.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_lacarino = new FontLoader()
fontLoader_lacarino.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Lacarino', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(45.1, 2, 5.79)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoadere_sunlight = new FontLoader()
fontLoadere_sunlight.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Sunlight', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(44.2, 2, 8.78)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kogan_stil = new FontLoader()
fontLoader_kogan_stil.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Кожанный', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(61, 2, -18.4)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_kogan_stil1 = new FontLoader()
fontLoader_kogan_stil1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'стиль', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(61, 2, -17.9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_liza = new FontLoader()
fontLoader_liza.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'AVVA', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(60.4, 2, -12.87)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_oodji = new FontLoader()
fontLoader_oodji.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Oodji', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(58.94, 2, -8)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_sovenok = new FontLoader()
fontLoader_sovenok.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Совёнок', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(59.12, 2, 2.52)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_stil_shtory = new FontLoader()
fontLoader_stil_shtory.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Стильнные', { font: font, size: 0.38, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(60.62, 2, 4.6)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_stil_shtory1 = new FontLoader()
fontLoader_stil_shtory1.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'шторы', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(60.62, 2, 5.3)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_modnyi = new FontLoader()
fontLoader_modnyi.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Modnyi', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(60.62, 2, 6.93)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_tobacconist = new FontLoader()
fontLoader_tobacconist.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Tobacconist', { font: font, size: 0.3, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(50.34, 2, 8.94)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_valencia = new FontLoader()
fontLoader_valencia.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Valencia', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(55.97, 2, 8.435)
        text.rotation.x = -Math.PI/2
        text.rotation.z = Math.PI/2
        scene.add(text)
    }
)
const fontLoader_berkonty = new FontLoader()
fontLoader_berkonty.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Berkonty', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(53.57, 2, 4.7)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_das_gut = new FontLoader()
fontLoader_das_gut.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Das Gut', { font: font, size: 0.6, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(71.63, 2, 6.5)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_avva = new FontLoader()
fontLoader_avva.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Все оптика', { font: font, size: 0.4, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(60.62, 2, 8.9)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_ninalina = new FontLoader()
fontLoader_ninalina.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Ninalina', { font: font, size: 0.5, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(66.89, 2, 9.17)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)
const fontLoader_remoda = new FontLoader()
fontLoader_remoda.load(
    './fonts/font-roboto.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'Remoda', { font: font, size: 1, height: 0.01, curveSegments: 2 }
        )
        textGeometry.computeBoundingBox()
        textGeometry.center()
        const textMaterial = new THREE.MeshBasicMaterial({ color: '0xDEFEFF' })
        const text = new THREE.Mesh(textGeometry, textMaterial)
                text.position.set(70.03, 2, -3.535)
        text.rotation.x = -Math.PI/2
        scene.add(text)
    }
)

/**
 * Environment map
 */
const environmentMap = cubeTextureLoader.load([
    './textures/2/px.jpg',
    './textures/2/nx.jpg',
    './textures/2/py.jpg',
    './textures/2/ny.jpg',
    './textures/2/pz.jpg',
    './textures/2/nz.jpg'
])


/**
 * Base
const parameters = {цвет: 0xff0000}
const color_odegda = {цвет: 0xc4a586}
const color_genodegda = {цвет: 0xdcb9e0}
const color_belie = {цвет: 0xafd7ff}
const color_mugodegda = {цвет: 0x135002}
 */
const color_vse = {цвет: 0xa56bb9}
const color_visible = {цвет: 0x8e2db0}
const color_pusto = {цвет: 0x999999}
  
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 )

/**
 * Overlay фон при загрузки
 */
const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms:
    {
        uAlpha: { value: 1 }
    },
    vertexShader: `
        void main()
        {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;

        void main()
        {
            gl_FragColor = vec4(1.0, 1.0, 1.0, uAlpha);
        }
    `
})
const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)
/**
 * Группировка обхектов
 */
const group = new THREE.Group()
const apteki = new THREE.Group()
const gipermarket = new THREE.Group()
const accessory = new THREE.Group()
const odegda = new THREE.Group()
const mebel = new THREE.Group()
const kosmetika = new THREE.Group()
const tehnika = new THREE.Group()
const belie = new THREE.Group()
const genodegda = new THREE.Group()
const mugodegda = new THREE.Group()
const obuv = new THREE.Group()
const produkty = new THREE.Group()
const razvlechenie = new THREE.Group()
const svyaz = new THREE.Group()
const specmag = new THREE.Group()
const sport = new THREE.Group()
const dlyadetey = new THREE.Group()
const dlyagivotnyh = new THREE.Group()
const tvorchestvo = new THREE.Group()
const obschepit = new THREE.Group()
const uslugi = new THREE.Group()
const uvelir = new THREE.Group()
const obraz = new THREE.Group()
const vse = new THREE.Group()

const verticesOfCube = [ -1,-1,-1,    1,-1,1,    1, 1,1,    -1, 1,-1,    -1,-1, 1,    1,-1, 1,    1, 1, 1,    -1, 1, 1 ]
const indicesOfFaces = [ 2,1,0,  0,3,2,  0,4,7,  7,3,0,  0,1,5,  5,4,0,  1,2,6,  6,5,1,  2,3,7,  7,6,2,  4,5,6,  6,7,4 ]
//                          0              1        2              3        4           5           6               7

apteki.visible = false
gipermarket.visible = false
accessory.visible = false
odegda.visible = false
belie.visible = false
kosmetika.visible = false
tehnika.visible = false
mebel.visible = false
mugodegda.visible = false
genodegda.visible = false
obuv.visible = false
produkty.visible = false
razvlechenie.visible = false
svyaz.visible = false
specmag.visible = false
sport.visible = false
dlyadetey.visible = false
dlyagivotnyh.visible = false
tvorchestvo.visible = false
obschepit.visible = false
uslugi.visible = false
obraz.visible = false
uvelir.visible = false

const geometry = new THREE.BoxGeometry(1, 1, 1)
const geometry2 = new THREE.CylinderGeometry( 1, 1, 1, 3 )
const geometry3 = new THREE.CylinderGeometry( 1, 1, 1, 3, 1, false, 0, 1.58)
const geometry4 = new THREE.CylinderGeometry( 1, 1, 1, 3, 1, false, 0, 1)
const geometry5 = new THREE.PolyhedronGeometry( verticesOfCube, indicesOfFaces, 1, 0 )
const geometry_plane = new THREE.PlaneGeometry( 1, 1 )
// MeshPhongMaterial - свет только с одной стороны. MeshBasicMaterial - свет со всех сторон.
const material = new THREE.MeshBasicMaterial({ map: colorTexture, flatShading: true })
const mat_vse = new THREE.MeshPhongMaterial( {color: color_vse.цвет, flatShading: true} )
const material1 = new THREE.MeshPhongMaterial( {color: color_visible.цвет, flatShading: true} )
const mat_pusto = new THREE.MeshPhongMaterial( {color: color_pusto.цвет, flatShading: true} )
// flatShading затемнение к объекту

const cube0 = new THREE.Mesh(geometry, material)
cube0.position.set(-0.9, 0, 10.5)
cube0.scale.set(228.3525, 0.1, 106.2115)
// cube0.scale.set(226.73, 0.1, 83.53)
group.add(cube0)




// vse
// Пол 
const vse_pol = new THREE.Mesh(geometry, mat_vse)
vse_pol.position.set(-0.9, -6.5, 10.5)
vse_pol.scale.set(228.3525, 13, 106.2115)
// vse_pol.scale.set(226.73, 13, 83.53)
vse.add(vse_pol)
// X-Ray 
const vse_x_ray = new THREE.Mesh(geometry, mat_vse)
vse_x_ray.position.set(11.85, 1, 2.1)
vse_x_ray.scale.set(5.7, 2, 5.34)
vse.add(vse_x_ray)
const vse_x_ray1 = new THREE.Mesh(geometry, mat_vse)
vse_x_ray1.position.set(12.65, 1, 6.2)
vse_x_ray1.scale.set(4.1, 2, 2.87)
vse.add(vse_x_ray1)
// ballare 
const vse_ballare = new THREE.Mesh(geometry, mat_vse)
vse_ballare.position.set(11.2, 1, 13)
vse_ballare.scale.set(2.2, 2, 4.4)
vse.add(vse_ballare)
// DNS Технопоинт
const vse_dnstehno = new THREE.Mesh(geometry, mat_vse)
vse_dnstehno.position.set(7.34, 1, 14.7)
vse_dnstehno.scale.set(5.4, 2, 7.8)
vse.add(vse_dnstehno)
// 
const pusto16_2 = new THREE.Mesh(geometry, mat_vse)
pusto16_2.position.set(13.28, 1, 22.15)
pusto16_2.scale.set(6.74, 2, 13.82)
vse.add(pusto16_2)
const pusto16_1 = new THREE.Mesh(geometry, mat_vse)
pusto16_1.position.set(11.86, 1, 22.02)
pusto16_1.scale.set(9.16, 2, 7.12)
vse.add(pusto16_1)
const pusto16_3 = new THREE.Mesh(geometry, mat_vse)
pusto16_3.position.set(13.14, 1, 27.26)
pusto16_3.scale.set(7, 2, 3.68)
vse.add(pusto16_3)
// Smart вместо Пусто 17
const vse_pusto17 = new THREE.Mesh(geometry, mat_vse)
vse_pusto17.position.set(-0.18, 1, 19.92)
vse_pusto17.scale.set(9.52, 2, 18.22)
vse.add(vse_pusto17)
const vse_pusto17_1 = new THREE.Mesh(geometry, mat_vse)
vse_pusto17_1.position.set(-3.6, 1, 22.12)
vse_pusto17_1.scale.set(16.2, 2, 13.82)
vse.add(vse_pusto17_1)
const vse_pusto17_2 = new THREE.Mesh(geometry, mat_vse)
vse_pusto17_2.position.set(-1.08, 1, 27.36)
vse_pusto17_2.scale.set(21.28, 2, 3.46)
vse.add(vse_pusto17_2)
const vse_pusto17_4 = new THREE.Mesh(geometry, mat_vse)
vse_pusto17_4.position.set(5.91, 1, 23.85)
vse_pusto17_4.scale.set(2.66, 2, 10.36)
vse.add(vse_pusto17_4)
// Snowimage 
const vse_snowimage = new THREE.Mesh(geometry, mat_vse)
vse_snowimage.position.set(16.5, 1, 6.09)
vse_snowimage.scale.set(3.3, 2, 3.08)
vse.add(vse_snowimage)
// Dimanche Lingerie
const vse_dimanche_lingerie = new THREE.Mesh(geometry, mat_vse)
vse_dimanche_lingerie.position.set(19.35, 1, 6.09)
vse_dimanche_lingerie.scale.set(2.2, 2, 3.08)
vse.add(vse_dimanche_lingerie)
const vse_dimanche_lingerie1 = new THREE.Mesh(geometry, mat_vse)
vse_dimanche_lingerie1.position.set(19.88, 1, 6.98)
vse_dimanche_lingerie1.scale.set(3.26, 2, 1.3)
vse.add(vse_dimanche_lingerie1)
const vse_dimanche_lingerie2 = new THREE.Mesh(geometry5, mat_vse)
vse_dimanche_lingerie2.position.set(20.9805, 1, 5.442)
vse_dimanche_lingerie2.scale.set(0.919, 1.732, 1.541)
vse.add(vse_dimanche_lingerie2)
// Аптека Эконом
const vse_ekonom = new THREE.Mesh(geometry, mat_vse)
vse_ekonom.position.set(-6.1, 1, 13)
vse_ekonom.scale.set(2.2, 2, 4.3)
vse.add(vse_ekonom)
// joss
const vse_joss_1 = new THREE.Mesh(geometry, mat_vse)
vse_joss_1.position.set(-42.07, 1, 10.29)
vse_joss_1.scale.set(2.36, 2, 3.39)
vse.add(vse_joss_1)
// breeze
const vse_breeze = new THREE.Mesh(geometry, mat_vse)
vse_breeze.position.set(-40.03, 1, 10.29)
vse_breeze.scale.set(1.58, 2, 3.39)
vse.add(vse_breeze)
const vse_breeze1 = new THREE.Mesh(geometry, mat_vse)
vse_breeze1.position.set(-39.24, 1, 9.43)
vse_breeze1.scale.set(3.16, 2, 1.68)
vse.add(vse_breeze1)
const vse_breeze2 = new THREE.Mesh(geometry5, mat_vse)
vse_breeze2.position.set(-38.45, 1, 11.125)
vse_breeze2.scale.set(1.368, 1.732, -1.481)
vse.add(vse_breeze2)
// Пусто 53
const pusto53 = new THREE.Mesh(geometry, mat_pusto)
pusto53.position.set(-40.49, 1, 6.79)
pusto53.scale.set(5.66, 2, 3.46)
vse.add(pusto53)
// Mirage пусто
const vse_mirage = new THREE.Mesh(geometry, mat_pusto)
vse_mirage.position.set(-39.9, 1, 3.26)
vse_mirage.scale.set(4.48, 2, 3.46)
vse.add(vse_mirage)
// Пусто 54
const pusto54 = new THREE.Mesh(geometry, mat_pusto)
pusto54.position.set(-43.86, 1, 10.29)
pusto54.scale.set(1.08, 2, 3.39)
vse.add(pusto54)
// Пусто 55
const pusto55 = new THREE.Mesh(geometry, mat_pusto)
pusto55.position.set(-45.2, 1, 10.29)
pusto55.scale.set(1.46, 2, 3.39)
vse.add(pusto55)
// Пусто 56
const pusto56 = new THREE.Mesh(geometry, mat_pusto)
pusto56.position.set(-45.6, 1, 6.8)
pusto56.scale.set(4.42, 2, 3.44)
vse.add(pusto56)
const pusto56_1 = new THREE.Mesh(geometry, mat_pusto)
pusto56_1.position.set(-46.9, 1, 8.56)
pusto56_1.scale.set(1.82, 2, 6.9)
vse.add(pusto56_1)
// Пусто 57
const pusto57 = new THREE.Mesh(geometry, mat_pusto)
pusto57.position.set(-45.01, 1, 3.26)
pusto57.scale.set(5.58, 2, 3.46)
vse.add(pusto57)
const pusto57_1 = new THREE.Mesh(geometry, mat_pusto)
pusto57_1.position.set(-46.67, 1, 1.46)
pusto57_1.scale.set(2.26, 2, 7.06)
vse.add(pusto57_1)
// Пусто 58
const pusto58 = new THREE.Mesh(geometry, mat_pusto)
pusto58.position.set(-44.43, 1, -0.31)
pusto58.scale.set(2.08, 2, 3.52)
vse.add(pusto58)
// Пусто 59
const pusto59 = new THREE.Mesh(geometry, mat_pusto)
pusto59.position.set(-42.24, 1, -0.31)
pusto59.scale.set(2.16, 2, 3.52)
vse.add(pusto59)
// Пусто 60
const pusto60 = new THREE.Mesh(geometry, mat_pusto)
pusto60.position.set(-39.87, 1, -0.31)
pusto60.scale.set(2.44, 2, 3.52)
vse.add(pusto60)
const pusto60_1 = new THREE.Mesh(geometry, mat_pusto)
pusto60_1.position.set(-39.36, 1, 0.43)
pusto60_1.scale.set(3.46, 2, 2.04)
vse.add(pusto60_1)
const pusto60_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto60_2.position.set(-38.14, 1, -1.33)
pusto60_2.scale.set(0.883, 1.732, 1.282) 
vse.add(pusto60_2)
// Пусто 61
const pusto61 = new THREE.Mesh(geometry, mat_pusto)
pusto61.position.set(-49.9, 1, 3.26)
pusto61.scale.set(4.06, 2, 3.46)
vse.add(pusto61)
const pusto61_1 = new THREE.Mesh(geometry, mat_pusto)
pusto61_1.position.set(-50.97, 1, 2.25)
pusto61_1.scale.set(1.92, 2, 5.48)
vse.add(pusto61_1)
const pusto61_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto61_2.position.set(-50.97, 1, -0.94)
pusto61_2.scale.set(-1.663, 1.732, 0.78)
vse.add(pusto61_2)
// Пусто 62
const pusto62 = new THREE.Mesh(geometry, mat_pusto)
pusto62.position.set(-48.9, 1, 0.01)
pusto62.scale.set(2.06, 2, 2.9)
vse.add(pusto62)
const pusto62_1 = new THREE.Mesh(geometry, mat_pusto)
pusto62_1.position.set(-48.18, 1, -0.3)
pusto62_1.scale.set(0.62, 2, 3.52)
vse.add(pusto62_1)
const pusto62_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto62_2.position.set(-49.21, 1, -1.75)
pusto62_2.scale.set(-1.247, 1.732, 0.537)
vse.add(pusto62_2)
// Пусто 63
const pusto63 = new THREE.Mesh(geometry, mat_pusto)
pusto63.position.set(-53.15, 1, 2.83)
pusto63.scale.set(2.3, 2, 4.38)
vse.add(pusto63)
const pusto63_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto63_1.position.set(-53.15, 1, 0.08)
pusto63_1.scale.set(-1.992, 1.732, 0.97)
vse.add(pusto63_1)
// Пусто 64
const pusto64 = new THREE.Mesh(geometry, mat_pusto)
pusto64.position.set(-55.37, 1, 3.32)
pusto64.scale.set(1.98, 2, 3.4)
vse.add(pusto64)
const pusto64_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto64_1.position.set(-55.37, 1, 1.14)
pusto64_1.scale.set(-1.715, 1.732, 0.832)
vse.add(pusto64_1)
// Пусто 65
const pusto65 = new THREE.Mesh(geometry, mat_pusto)
pusto65.position.set(-57.55, 1, 5.43)
pusto65.scale.set(2.25, 2, 5.32)
vse.add(pusto65)
const pusto65_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto65_1.position.set(-57.55, 1, 2.22)
pusto65_1.scale.set(-1.949, 1.732, 0.953)
vse.add(pusto65_1)
// Пусто 66
const pusto66 = new THREE.Mesh(geometry, mat_pusto)
pusto66.position.set(-60.68, 1, 6.99)
pusto66.scale.set(3.88, 2, 2.2)
vse.add(pusto66)
const pusto66_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto66_1.position.set(-62.81, 1, 6.99)
pusto66_1.scale.set(-0.329, 1.732, 1.905)
vse.add(pusto66_1)
// Пусто 67
const pusto67 = new THREE.Mesh(geometry, mat_pusto)
pusto67.position.set(-60.54, 1, 5.12)
pusto67.scale.set(3.6, 2, 1.4)
vse.add(pusto67)
const pusto67_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto67_1.position.set(-62.47, 1, 5.12)
pusto67_1.scale.set(-0.225, 1.732, 1.212)
vse.add(pusto67_1)
const pusto67_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto67_2.position.set(-60.54, 1, 3.6)
pusto67_2.scale.set(-3.118, 1.732, 1.421)
vse.add(pusto67_2)


// Пусто 70
const pusto70 = new THREE.Mesh(geometry, mat_pusto)
pusto70.position.set(-42.11, 1, -6.9)
pusto70.scale.set(2.26, 2, 3.34)
vse.add(pusto70)
// Пусто 71
const pusto71 = new THREE.Mesh(geometry, mat_pusto)
pusto71.position.set(-44.36, 1, -6.9)
pusto71.scale.set(2.08, 2, 3.34)
vse.add(pusto71)
// Пусто 72
const pusto72 = new THREE.Mesh(geometry, mat_pusto)
pusto72.position.set(-46.55, 1, -6.9)
pusto72.scale.set(2.14, 2, 3.34)
vse.add(pusto72)
// Пусто 73
const pusto73 = new THREE.Mesh(geometry, mat_pusto)
pusto73.position.set(-42.11, 1, -10.57)
pusto73.scale.set(2.26, 2, 3.84)
vse.add(pusto73)
// Пусто 74
const pusto74 = new THREE.Mesh(geometry, mat_pusto)
pusto74.position.set(-44.36, 1, -10.57)
pusto74.scale.set(2.08, 2, 3.84)
vse.add(pusto74)
// Пусто 75
const pusto75 = new THREE.Mesh(geometry, mat_pusto)
pusto75.position.set(-46.55, 1, -10.57)
pusto75.scale.set(2.14, 2, 3.84)
vse.add(pusto75)
// Пусто 76
const pusto76 = new THREE.Mesh(geometry, mat_pusto)
pusto76.position.set(-39.23, 1, -10.57)
pusto76.scale.set(3.34, 2, 3.84)
vse.add(pusto76)
// Пусто 77
const pusto77 = new THREE.Mesh(geometry, mat_pusto)
pusto77.position.set(-48.75, 1, -10.57)
pusto77.scale.set(2.1, 2, 3.84)
vse.add(pusto77)
// Пусто 78
const pusto78 = new THREE.Mesh(geometry, mat_pusto)
pusto78.position.set(-50.98, 1, -10.57)
pusto78.scale.set(2.2, 2, 3.84)
vse.add(pusto78)
// Пусто 79
const pusto79 = new THREE.Mesh(geometry, mat_pusto)
pusto79.position.set(-53.24, 1, -10.57)
pusto79.scale.set(2.16, 2, 3.84)
vse.add(pusto79)
// Пусто 80
const pusto80 = new THREE.Mesh(geometry, mat_pusto)
pusto80.position.set(-55.46, 1, -10.57)
pusto80.scale.set(2.12, 2, 3.84)
vse.add(pusto80)
// Пусто 81
const pusto81 = new THREE.Mesh(geometry, mat_pusto)
pusto81.position.set(-57.62, 1, -10.57)
pusto81.scale.set(2.02, 2, 3.84)
vse.add(pusto81)
// Пусто 82
const pusto82 = new THREE.Mesh(geometry, mat_pusto)
pusto82.position.set(-59.86, 1, -10.57)
pusto82.scale.set(2.3, 2, 3.84)
vse.add(pusto82)
// Пусто 83
const pusto83 = new THREE.Mesh(geometry, mat_pusto)
pusto83.position.set(-39.23, 1, -7.65)
pusto83.scale.set(3.34, 2, 1.84)
vse.add(pusto83)
const pusto83_1 = new THREE.Mesh(geometry, mat_pusto)
pusto83_1.position.set(-39.9, 1, -6.9)
pusto83_1.scale.set(2, 2, 3.34)
vse.add(pusto83_1)
const pusto83_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto83_2.position.set(-38.23, 1, -5.98)
pusto83_2.scale.set(1.16, 1.732, -1.299)
vse.add(pusto83_2)
// Пусто 84
const pusto84 = new THREE.Mesh(geometry, mat_pusto)
pusto84.position.set(-48.75, 1, -6.9)
pusto84.scale.set(2.1, 2, 3.34)
vse.add(pusto84)
const pusto84_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto84_1.position.set(-49.14, 1, -4.9)
pusto84_1.scale.set(1.143, 1.732, -0.572)
vse.add(pusto84_1)
// Пусто 85
const pusto85 = new THREE.Mesh(geometry, mat_pusto)
pusto85.position.set(-50.98, 1, -6.57)
pusto85.scale.set(2.2, 2, 4)
vse.add(pusto85)
const pusto85_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto85_1.position.set(-50.98, 1, -4.01)
pusto85_1.scale.set(1.905, 1.732, -0.97)
vse.add(pusto85_1)
// Пусто 86
const pusto86 = new THREE.Mesh(geometry, mat_pusto)
pusto86.position.set(-53.24, 1, -6.01)
pusto86.scale.set(2.16, 2, 5.12)
vse.add(pusto86)
const pusto86_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto86_1.position.set(-53.24, 1, -2.92)
pusto86_1.scale.set(1.871, 1.732, -0.918)
vse.add(pusto86_1)
// Пусто 86
const pusto87 = new THREE.Mesh(geometry, mat_pusto)
pusto87.position.set(-55.47, 1, -5.48)
pusto87.scale.set(2.14, 2, 6.18)
vse.add(pusto87)
const pusto87_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto87_1.position.set(-55.47, 1, -1.84)
pusto87_1.scale.set(1.871, 1.732, -0.953)
vse.add(pusto87_1)
// Пусто 88
const pusto88 = new THREE.Mesh(geometry, mat_pusto)
pusto88.position.set(-59.6, 1, -6.91)
pusto88.scale.set(5.96, 2, 3.32)
vse.add(pusto88)
const pusto88_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto88_1.position.set(-63.01, 1, -6.91)
pusto88_1.scale.set(-0.745, 1.732, -2.875)
vse.add(pusto88_1)
// Пусто 89
const pusto89 = new THREE.Mesh(geometry, mat_pusto)
pusto89.position.set(-59.44, 1, -3.63)
pusto89.scale.set(5.64, 2, 3.08)
vse.add(pusto89)
const pusto89_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto89_1.position.set(-62.4, 1, -3.63)
pusto89_1.scale.set(-0.242, 1.732, -2.667)
vse.add(pusto89_1)
// Пусто 90
const pusto90 = new THREE.Mesh(geometry, mat_pusto)
pusto90.position.set(-59.43, 1, -1.65)
pusto90.scale.set(5.62, 2, 0.72)
vse.add(pusto90)
const pusto90_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto90_1.position.set(-59.43, 1, 0.11)
pusto90_1.scale.set(4.867, 1.732, -2.425)
vse.add(pusto90_1)
// Пусто 91
const pusto91 = new THREE.Mesh(geometry, mat_pusto)
pusto91.position.set(-62.27, 1, -10.57)
pusto91.scale.set(2.36, 2, 3.84)
vse.add(pusto91)
const pusto91_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto91_1.position.set(-64.25, 1, -10.57)
pusto91_1.scale.set(-1.386, 1.732, -3.325)
vse.add(pusto91_1)


// Пусто 92
const pusto92 = new THREE.Mesh(geometry, mat_pusto)
pusto92.position.set(-38.07, 1, -17.8)
pusto92.scale.set(2.74, 2, 4.76)
vse.add(pusto92)
// Пусто 93
const pusto93 = new THREE.Mesh(geometry, mat_pusto)
pusto93.position.set(-40.8, 1, -17.8)
pusto93.scale.set(2.56, 2, 4.76)
vse.add(pusto93)
// Пусто 94
const pusto94 = new THREE.Mesh(geometry, mat_pusto)
pusto94.position.set(-43.49, 1, -17.8)
pusto94.scale.set(2.66, 2, 4.76)
vse.add(pusto94)
// Пусто 95
const pusto95 = new THREE.Mesh(geometry, mat_pusto)
pusto95.position.set(-46.17, 1, -17.8)
pusto95.scale.set(2.54, 2, 4.76)
vse.add(pusto95)
// Пусто 96
const pusto96 = new THREE.Mesh(geometry, mat_pusto)
pusto96.position.set(-48.9, 1, -17.8)
pusto96.scale.set(2.76, 2, 4.76)
vse.add(pusto96)
// Пусто 97
const pusto97 = new THREE.Mesh(geometry, mat_pusto)
pusto97.position.set(-51.62, 1, -17.8)
pusto97.scale.set(2.52, 2, 4.76)
vse.add(pusto97)
// Пусто 98
const pusto98 = new THREE.Mesh(geometry, mat_pusto)
pusto98.position.set(-54.28, 1, -17.8)
pusto98.scale.set(2.64, 2, 4.76)
vse.add(pusto98)
// Пусто 99
const pusto99 = new THREE.Mesh(geometry, mat_pusto)
pusto99.position.set(-56.94, 1, -17.8)
pusto99.scale.set(2.52, 2, 4.76)
vse.add(pusto99)
// Пусто 100
const pusto100 = new THREE.Mesh(geometry, mat_pusto)
pusto100.position.set(-59.55, 1, -17.8)
pusto100.scale.set(2.54, 2, 4.76)
vse.add(pusto100)
// Пусто 101
const pusto101 = new THREE.Mesh(geometry, mat_pusto)
pusto101.position.set(-61.75, 1, -17.8)
pusto101.scale.set(1.7, 2, 4.76)
vse.add(pusto101)
const pusto101_1 = new THREE.Mesh(geometry, mat_pusto)
pusto101_1.position.set(-62.33, 1, -16.51)
pusto101_1.scale.set(2.86, 2, 2.18)
vse.add(pusto101_1)
const pusto101_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto101_2.position.set(-63.18, 1, -18.89)
pusto101_2.scale.set(-1.005, 1.732, 2.235)
vse.add(pusto101_2)
// Пусто 103
const pusto103 = new THREE.Mesh(geometry, mat_pusto)
pusto103.position.set(-59.36, 1, -22.63)
pusto103.scale.set(2.16, 2, 4.76)
vse.add(pusto103)
const pusto103_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto103_1.position.set(-61.5, 1, -22.63)
pusto103_1.scale.set(-1.836, 1.732, 4.122)
vse.add(pusto103_1)
// Пусто 104
const pusto104 = new THREE.Mesh(geometry, mat_pusto)
pusto104.position.set(-56.93, 1, -22.63)
pusto104.scale.set(2.54, 2, 4.76)
vse.add(pusto104)
// Пусто 105
const pusto105 = new THREE.Mesh(geometry, mat_pusto)
pusto105.position.set(-54.28, 1, -22.63)
pusto105.scale.set(2.6, 2, 4.76)
vse.add(pusto105)
// Пусто 106
const pusto106 = new THREE.Mesh(geometry, mat_pusto)
pusto106.position.set(-51.62, 1, -22.63)
pusto106.scale.set(2.56, 2, 4.76)
vse.add(pusto106)
// Пусто 107
const pusto107 = new THREE.Mesh(geometry, mat_pusto)
pusto107.position.set(-48.88, 1, -22.63)
pusto107.scale.set(2.76, 2, 4.76)
vse.add(pusto107)
// Пусто 108
const pusto108 = new THREE.Mesh(geometry, mat_pusto)
pusto108.position.set(-46.15, 1, -22.63)
pusto108.scale.set(2.54, 2, 4.76)
vse.add(pusto108)
// Пусто 109
const pusto109 = new THREE.Mesh(geometry, mat_pusto)
pusto109.position.set(-43.49, 1, -22.2)
pusto109.scale.set(2.66, 2, 3.9)
vse.add(pusto109)
const pusto109_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto109_1.position.set(-43.49, 1, -24.58)
pusto109_1.scale.set(2.304, 1.732, 0.745)
vse.add(pusto109_1)
// Пусто 110
const pusto110 = new THREE.Mesh(geometry, mat_pusto)
pusto110.position.set(-40.8, 1, -21.76)
pusto110.scale.set(2.56, 2, 3.02)
vse.add(pusto110)
const pusto110_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto110_1.position.set(-40.8, 1, -23.7)
pusto110_1.scale.set(2.217, 1.732, 0.745)
vse.add(pusto110_1)
// Пусто 111
const pusto111 = new THREE.Mesh(geometry, mat_pusto)
pusto111.position.set(-38.07, 1, -21.31)
pusto111.scale.set(2.74, 2, 2.12)
vse.add(pusto111)
const pusto111_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto111_1.position.set(-38.07, 1, -22.81)
pusto111_1.scale.set(2.373, 1.732, 0.762)
vse.add(pusto111_1)




// New Lok 
const vse_new_lok = new THREE.Mesh(geometry, mat_vse)
vse_new_lok.position.set(-49.85, 1, 8.56)
vse_new_lok.scale.set(3.9, 2, 6.9)
vse.add(vse_new_lok)
// Живой мир
const vse_givoy_mir = new THREE.Mesh(geometry, mat_vse)
vse_givoy_mir.position.set(-53.1, 1, 8.56)
vse_givoy_mir.scale.set(2.3, 2, 6.9)
vse.add(vse_givoy_mir)
// Студия воздушной гимнастики
const vse_studvozdgimnast = new THREE.Mesh(geometry, mat_vse)
vse_studvozdgimnast.position.set(-55.34, 1, 8.56)
vse_studvozdgimnast.scale.set(1.98, 2, 6.9)
vse.add(vse_studvozdgimnast)
// Виктория
const vse_viktoriya = new THREE.Mesh(geometry, mat_vse)
vse_viktoriya.position.set(-57.55, 1, 10.1)
vse_viktoriya.scale.set(2.25, 2, 3.87)
vse.add(vse_viktoriya)
// Сфера дыма
const vse_sfera_dyma = new THREE.Mesh(geometry, mat_vse)
vse_sfera_dyma.position.set(-60.88, 1, 10.1)
vse_sfera_dyma.scale.set(4.26, 2, 3.87)
vse.add(vse_sfera_dyma)
const vse_sfera_dyma1 = new THREE.Mesh(geometry5, mat_vse)
vse_sfera_dyma1.position.set(-63.51, 1, 10.1)
vse_sfera_dyma1.scale.set(-0.866, 1.732, 3.351)
vse.add(vse_sfera_dyma1)
// Cyber Service
const vse_cyber_service = new THREE.Mesh(geometry, mat_vse)
vse_cyber_service.position.set(-62.27, 1, 16.07)
vse_cyber_service.scale.set(3.4, 2, 2.58)
vse.add(vse_cyber_service)
// Умка
const vse_umka = new THREE.Mesh(geometry, mat_vse)
vse_umka.position.set(-64.44, 1, 16.07)
vse_umka.scale.set(0.76, 2, 2.58)
vse.add(vse_umka)
const vse_umka1 = new THREE.Mesh(geometry5, mat_vse)
vse_umka1.position.set(-65.27, 1, 16.07)
vse_umka1.scale.set(-0.779, 1.732, 2.234)
vse.add(vse_umka1)
// Ивпринт
const vse_ivprint = new THREE.Mesh(geometry, mat_vse)
vse_ivprint.position.set(-64.93, 1, 18.52)
vse_ivprint.scale.set(1.7, 2, 2.12)
vse.add(vse_ivprint)
const vse_ivprint1 = new THREE.Mesh(geometry5, mat_vse)
vse_ivprint1.position.set(-66.25, 1, 18.52)
vse_ivprint1.scale.set(-0.814, 1.732, 1.836)
vse.add(vse_ivprint1)
// Колясочка37 Пусто 45
const vse_kolyasochka37 = new THREE.Mesh(geometry, mat_vse)
vse_kolyasochka37.position.set(-65.43, 1, 20.88)
vse_kolyasochka37.scale.set(2.7, 2, 2.46)
vse.add(vse_kolyasochka37)
const vse_kolyasochka37_1 = new THREE.Mesh(geometry5, mat_vse)
vse_kolyasochka37_1.position.set(-67.41, 1, 20.88)
vse_kolyasochka37_1.scale.set(-1.091, 1.732, 2.13)
vse.add(vse_kolyasochka37_1)
// Дом посуды
const vse_dom_posudy = new THREE.Mesh(geometry, mat_vse)
vse_dom_posudy.position.set(-66.06, 1, 23.68)
vse_dom_posudy.scale.set(3.96, 2, 3)
vse.add(vse_dom_posudy)
const vse_dom_posudy1 = new THREE.Mesh(geometry5, mat_vse)
vse_dom_posudy1.position.set(-68.94, 1, 23.68)
vse_dom_posudy1.scale.set(-1.559, 1.732, 2.598)
vse.add(vse_dom_posudy1)
// Пусто 46
const pusto46 = new THREE.Mesh(geometry, mat_pusto)
pusto46.position.set(-66.98, 1, 26.2)
pusto46.scale.set(5.8, 2, 1.92)
vse.add(pusto46)
const pusto46_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto46_1.position.set(-70.58, 1, 26.2)
pusto46_1.scale.set(-1.212, 1.732, 1.663)
vse.add(pusto46_1)
const pusto46_2 = new THREE.Mesh(geometry, mat_pusto)
pusto46_2.position.set(-66.64, 1, 28.08)
pusto46_2.scale.set(5.12, 2, 1.84)
vse.add(pusto46_2)
// Пусто 47
const pusto47 = new THREE.Mesh(geometry, mat_pusto)
pusto47.position.set(-70.32, 1, 28.72)
pusto47.scale.set(2.1, 2, 2.98)
vse.add(pusto47)
const pusto47_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto47_1.position.set(-72.75, 1, 28.72)
pusto47_1.scale.set(-2.39, 1.732, 2.581)
vse.add(pusto47_1)
// Moloko
const vse_moloko = new THREE.Mesh(geometry, mat_vse)
vse_moloko.position.set(-71.7, 1, 31.27)
vse_moloko.scale.set(4.86, 2, 1.98)
vse.add(vse_moloko)
// Хали Гали
const vse_hali_gali = new THREE.Mesh(geometry, mat_vse)
vse_hali_gali.position.set(-66.64, 1, 32.2)
vse_hali_gali.scale.set(5.12, 2, 6.26)
vse.add(vse_hali_gali)
const vse_hali_gali1 = new THREE.Mesh(geometry, mat_vse)
vse_hali_gali1.position.set(-68.29, 1, 33.85)
vse_hali_gali1.scale.set(8.42, 2, 3.03)
vse.add(vse_hali_gali1)
// Картридж
const vse_kartridg = new THREE.Mesh(geometry, mat_vse)
vse_kartridg.position.set(-58.85, 1, 16.07)
vse_kartridg.scale.set(3.2, 2, 2.58)
vse.add(vse_kartridg)
// Оперативка
const vse_operativka = new THREE.Mesh(geometry, mat_vse)
vse_operativka.position.set(-44.53, 1, 16.58)
vse_operativka.scale.set(2.22, 2, 3.65)
vse.add(vse_operativka)
// Noor
const vse_noor = new THREE.Mesh(geometry, mat_pusto)
vse_noor.position.set(-42.64, 1, 16.58)
vse_noor.scale.set(1.44, 2, 3.65)
vse.add(vse_noor)
// You Style
const vse_you_style = new THREE.Mesh(geometry, mat_vse)
vse_you_style.position.set(-41.04, 1, 16.58)
vse_you_style.scale.set(1.6, 2, 3.65)
vse.add(vse_you_style)
// Masis
const vse_masis = new THREE.Mesh(geometry, mat_vse)
vse_masis.position.set(-39.39, 1, 16.58)
vse_masis.scale.set(1.54, 2, 3.65)
vse.add(vse_masis)
// Joss
const vse_joss = new THREE.Mesh(geometry, mat_vse)
vse_joss.position.set(-37.61, 1, 16.58)
vse_joss.scale.set(1.86, 2, 3.65)
vse.add(vse_joss)
const vse_joss1 = new THREE.Mesh(geometry5, mat_vse)
vse_joss1.position.set(-37.43, 1, 13.955)
vse_joss1.scale.set(-1.299, 1.732, 1.386)
vse.add(vse_joss1)
// Lovemoda
const vse_lovemoda = new THREE.Mesh(geometry, mat_vse)
vse_lovemoda.position.set(-35.06, 1, 16.28)
vse_lovemoda.scale.set(3.12, 2, 6.4)
vse.add(vse_lovemoda)
const vse_lovemoda1 = new THREE.Mesh(geometry, mat_vse)
vse_lovemoda1.position.set(-34.08, 1, 15.19)
vse_lovemoda1.scale.set(1.16, 2, 8.58)
vse.add(vse_lovemoda1)
const vse_lovemoda2 = new THREE.Mesh(geometry5, mat_vse)
vse_lovemoda2.position.set(-35.64, 1, 11.99)
vse_lovemoda2.scale.set(-1.697, 1.732, 1.888)
vse.add(vse_lovemoda2)
// Пусто 34
const pusto34 = new THREE.Mesh(geometry, mat_pusto)
pusto34.position.set(-35.06, 1, 21.32)
pusto34.scale.set(3.12, 2, 3.54)
vse.add(pusto34)
// Пусто 35
const pusto35 = new THREE.Mesh(geometry, mat_pusto)
pusto35.position.set(-35.06, 1, 24.4)
pusto35.scale.set(3.12, 2, 2.5)
vse.add(pusto35)
// Антарес
const vse_antares = new THREE.Mesh(geometry, mat_vse)
vse_antares.position.set(-35.06, 1, 27.46)
vse_antares.scale.set(3.12, 2, 3.52)
vse.add(vse_antares)
// Пусто 36
const pusto36 = new THREE.Mesh(geometry, mat_pusto)
pusto36.position.set(-35.06, 1, 32.31)
pusto36.scale.set(3.12, 2, 6.04)
vse.add(pusto36)
// Бизнес-Лэнд
const vse_biznes_lend = new THREE.Mesh(geometry, mat_vse)
vse_biznes_lend.position.set(-47.57, 1, 33.18)
vse_biznes_lend.scale.set(5.31, 2, 4.3)
vse.add(vse_biznes_lend)
// Дом одежда обувь
const vse_dom_odegda = new THREE.Mesh(geometry, mat_vse)
vse_dom_odegda.position.set(-50.37, 1, 24.73)
vse_dom_odegda.scale.set(27, 2, 12.44)
vse.add(vse_dom_odegda)
const vse_dom_odegda1 = new THREE.Mesh(geometry, mat_vse)
vse_dom_odegda1.position.set(-51.42, 1, 16.68)
vse_dom_odegda1.scale.set(11.44, 2, 3.85)
vse.add(vse_dom_odegda1)
const vse_dom_odegda2 = new THREE.Mesh(geometry, mat_vse)
vse_dom_odegda2.position.set(-57.16, 1, 26.4)
vse_dom_odegda2.scale.set(13.72, 2, 17.84)
vse.add(vse_dom_odegda2)
const vse_dom_odegda3 = new THREE.Mesh(geometry, mat_vse)
vse_dom_odegda3.position.set(-40.75, 1, 26.92)
vse_dom_odegda3.scale.set(8.12, 2, 16.78)
vse.add(vse_dom_odegda3)
// РемКомплект
const vse_remkomplekt = new THREE.Mesh(geometry, mat_vse)
vse_remkomplekt.position.set(-73.35, 1, 33.85)
vse_remkomplekt.scale.set(1.55, 2, 3.03)
vse.add(vse_remkomplekt)
// Пусто вместо Магазин ковров 
const vse_mag_kovrov = new THREE.Mesh(geometry, mat_pusto)
vse_mag_kovrov.position.set(2.62, 1, 0)
vse_mag_kovrov.scale.set(3.4, 2, 0.85)
vse.add(vse_mag_kovrov)
// Пряжа 
const vse_pryaga = new THREE.Mesh(geometry, mat_vse)
vse_pryaga.position.set(2.62, 1, 1.05)
vse_pryaga.scale.set(3.4, 2, 1.05)
vse.add(vse_pryaga)
// Лидер 
const vse_lider = new THREE.Mesh(geometry, mat_vse)
vse_lider.position.set(2.62, 1, 2.15)
vse_lider.scale.set(3.4, 2, 1.05)
vse.add(vse_lider)
// Пусто вместо Ковры
const vse_kovry = new THREE.Mesh(geometry, mat_pusto)
vse_kovry.position.set(2.62, 1, 3.25)
vse_kovry.scale.set(3.4, 2, 1.05)
vse.add(vse_kovry)
// Джинсовый микс
const vse_dgins_miks = new THREE.Mesh(geometry, mat_vse)
vse_dgins_miks.position.set(2.62, 1, 4.35)
vse_dgins_miks.scale.set(3.4, 2, 1.05)
vse.add(vse_dgins_miks)
// Весёленький ассортимент
const vse_vesel_assortiment = new THREE.Mesh(geometry, mat_vse)
vse_vesel_assortiment.position.set(2.62, 1, 5.54)
vse_vesel_assortiment.scale.set(3.4, 2, 1.18)
vse.add(vse_vesel_assortiment)
const vse_vesel_assortiment1 = new THREE.Mesh(geometry, mat_vse)
vse_vesel_assortiment1.position.set(3.31, 1, 6.91)
vse_vesel_assortiment1.scale.set(2.02, 2, 1.56)
vse.add(vse_vesel_assortiment1)
const vse_vesel_assortiment2 = new THREE.Mesh(geometry5, mat_vse)
vse_vesel_assortiment2.position.set(1.61, 1, 6.91)
vse_vesel_assortiment2.scale.set(-1.195, 1.732, -1.351)
vse.add(vse_vesel_assortiment2)
// Miss Poem
const vse_miss_poem = new THREE.Mesh(geometry, mat_vse)
vse_miss_poem.position.set(5.14, 1, 6.31)
vse_miss_poem.scale.set(1.44, 2, 2.72)
vse.add(vse_miss_poem)

// Ещё
const vse_esche = new THREE.Mesh(geometry, mat_vse)
vse_esche.position.set(-4.8, 1, -10.25)
vse_esche.scale.set(5.2, 2, 2.1)
vse.add(vse_esche)
const pusto23 = new THREE.Mesh(geometry, mat_vse)
pusto23.position.set(-4.8, 1, -8.06)
pusto23.scale.set(5.2, 2, 2.32)
vse.add(pusto23)
const pusto31 = new THREE.Mesh(geometry, mat_vse)
pusto31.position.set(-4.8, 1, -6.62)
pusto31.scale.set(5.2, 2, 0.6)
vse.add(pusto31)
const pusto31_1 = new THREE.Mesh(geometry, mat_vse)
pusto31_1.position.set(-5.44, 1, -5.72)
pusto31_1.scale.set(3.92, 2, 2.4)
vse.add(pusto31_1)
const pusto31_2 = new THREE.Mesh(geometry5, mat_vse)
pusto31_2.position.set(-3.16, 1, -5.42)
pusto31_2.scale.set(0.554, 1.732, -1.559)
vse.add(pusto31_2)
const pusto31_3 = new THREE.Mesh(geometry5, mat_vse)
pusto31_3.position.set(-2.84, 1, -5.87)
pusto31_3.scale.set(1.108, 1.732, -0.779)
vse.add(pusto31_3)
const pusto30 = new THREE.Mesh(geometry, mat_vse)
pusto30.position.set(-5.44, 1, -3.45)
pusto30.scale.set(3.92, 2, 2.24)
vse.add(pusto30)
const vse_mm_dekor = new THREE.Mesh(geometry, mat_vse)
vse_mm_dekor.position.set(-4.8, 1, -0.53)
vse_mm_dekor.scale.set(5.2, 2, 0.5)
vse.add(vse_mm_dekor)
const vse_mm_dekor1 = new THREE.Mesh(geometry, mat_vse)
vse_mm_dekor1.position.set(-5.44, 1, -1.32)
vse_mm_dekor1.scale.set(3.92, 2, 2.08)
vse.add(vse_mm_dekor1)
const vse_mm_dekor2 = new THREE.Mesh(geometry5, mat_vse)
vse_mm_dekor2.position.set(-3.16, 1, -1.57)
vse_mm_dekor2.scale.set(0.554, 1.732, 1.368)
vse.add(vse_mm_dekor2)
const vse_mm_dekor3 = new THREE.Mesh(geometry5, mat_vse)
vse_mm_dekor3.position.set(-2.84, 1, -1.175)
vse_mm_dekor3.scale.set(1.108, 1.732, 0.684)
vse.add(vse_mm_dekor3)
const vse_huligan = new THREE.Mesh(geometry, mat_vse)
vse_huligan.position.set(-4.8, 1, 0.6)
vse_huligan.scale.set(5.2, 2, 1.8)
vse.add(vse_huligan)
const vse_kovr_centr = new THREE.Mesh(geometry, mat_vse)
vse_kovr_centr.position.set(-4.8, 1, 3.25)
vse_kovr_centr.scale.set(5.2, 2, 3.7)
vse.add(vse_kovr_centr)
const pusto29 = new THREE.Mesh(geometry, mat_vse)
pusto29.position.set(-4.8, 1, 5.74)
pusto29.scale.set(5.2, 2, 1.32)
vse.add(pusto29)
const pusto29_1 = new THREE.Mesh(geometry, mat_vse)
pusto29_1.position.set(-5.4, 1, 6.46)
pusto29_1.scale.set(4, 2, 2.76)
vse.add(pusto29_1)
const pusto29_2 = new THREE.Mesh(geometry5, mat_vse)
pusto29_2.position.set(-2.8, 1, 7.12)
pusto29_2.scale.set(1.039, 1.732, -1.247)
vse.add(pusto29_2)



// РосПромОбувь
const vse_rospromobuv = new THREE.Mesh(geometry, mat_vse)
vse_rospromobuv.position.set(-17.15, 1, -15.8)
vse_rospromobuv.scale.set(8.5, 2, 8.8)
vse.add(vse_rospromobuv)
// Пусто 18
const pusto18 = new THREE.Mesh(geometry, mat_pusto)
pusto18.position.set(-22.64, 1, -15.79)
pusto18.scale.set(2.36, 2, 8.8)
vse.add(pusto18)
// Пусто 19
const pusto19 = new THREE.Mesh(geometry, mat_pusto)
pusto19.position.set(-11.47, 1, -15.8)
pusto19.scale.set(2.74, 2, 8.8)
vse.add(pusto19)
// Пусто 20
const pusto20 = new THREE.Mesh(geometry, mat_pusto)
pusto20.position.set(-8.09, 1, -15.8)
pusto20.scale.set(3.86, 2, 8.8)
vse.add(pusto20)
// Kapika
const vse_kapika = new THREE.Mesh(geometry, mat_vse)
vse_kapika.position.set(-11.5, 1, 5.25)
vse_kapika.scale.set(2.8, 2, 5.2)
vse.add(vse_kapika)
// Salsa
const vse_salsa = new THREE.Mesh(geometry, mat_vse)
vse_salsa.position.set(-22.1, 1, 4.15)
vse_salsa.scale.set(2.2, 2, 7.5)
vse.add(vse_salsa)
// Пусто часы
const vse_chasy = new THREE.Mesh(geometry, mat_pusto)
vse_chasy.position.set(-26.4, 1, 4.8)
vse_chasy.scale.set(1.4, 2, 6.2)
vse.add(vse_chasy)
// Tekbir
const vse_tekbir = new THREE.Mesh(geometry, mat_vse)
vse_tekbir.position.set(-24.45, 1, 4.8)
vse_tekbir.scale.set(2.32, 2, 6.2)
vse.add(vse_tekbir)
// Millioner
const vse_millioner = new THREE.Mesh(geometry, mat_vse)
vse_millioner.position.set(-28.8, 1, 3)
vse_millioner.scale.set(3.1, 2, 9.8)
vse.add(vse_millioner)
// Bagira 
const vse_bagira = new THREE.Mesh(geometry, mat_vse)
vse_bagira.position.set(-8.35, 1, 13)
vse_bagira.scale.set(2.2, 2, 4.3)
vse.add(vse_bagira)
// Котофей
const vse_kotofey = new THREE.Mesh(geometry, mat_vse)
vse_kotofey.position.set(-10.6, 1, 13)
vse_kotofey.scale.set(2.2, 2, 4.3)
vse.add(vse_kotofey)
// Man Style
const vse_manstyle = new THREE.Mesh(geometry, mat_vse)
vse_manstyle.position.set(-15.6, 1, 14.65)
vse_manstyle.scale.set(5.5, 2, 7.6)
vse.add(vse_manstyle)
// Lavita
const vse_lavita = new THREE.Mesh(geometry, mat_vse)
vse_lavita.position.set(-32.45, 1, -11.55)
vse_lavita.scale.set(4.3, 2, 1.9)
vse.add(vse_lavita)
// Антураж
const vse_anturag = new THREE.Mesh(geometry, mat_vse)
vse_anturag.position.set(-31.51, 1, -13.71)
vse_anturag.scale.set(2.42, 2, 2.26)
vse.add(vse_anturag)
const vse_anturag1 = new THREE.Mesh(geometry5, mat_vse)
vse_anturag1.position.set(-33.66, 1, -13.71)
vse_anturag1.scale.set(-1.628, 1.732, 1.957)
vse.add(vse_anturag1)
// Пусто 25
const pusto25 = new THREE.Mesh(geometry5, mat_pusto)
pusto25.position.set(-31.48, 1, -15.8)
pusto25.scale.set(-2.078, 1.732, 1.58)
vse.add(pusto25)
// Molkova Dress
const vse_molkova_dress = new THREE.Mesh(geometry, mat_vse)
vse_molkova_dress.position.set(-32.5, 1, -0.32)
vse_molkova_dress.scale.set(4.15, 2, 0.44)
vse.add(vse_molkova_dress)
const vse_molkova_dress1 = new THREE.Mesh(geometry, mat_vse)
vse_molkova_dress1.position.set(-31.91, 1, -1)
vse_molkova_dress1.scale.set(2.97, 2, 1.8)
vse.add(vse_molkova_dress1)
const vse_molkova_dress2 = new THREE.Mesh(geometry5, mat_vse)
vse_molkova_dress2.position.set(-33.985, 1, -1.22)
vse_molkova_dress2.scale.set(-1.022, 1.732, 1.178)
vse.add(vse_molkova_dress2)
// Пусто 26
const pusto26 = new THREE.Mesh(geometry, mat_pusto)
pusto26.position.set(-32.5, 1, 1.17)
pusto26.scale.set(4.15, 2, 2.38)
vse.add(pusto26)
// Пусто 27
const pusto27 = new THREE.Mesh(geometry, mat_pusto)
pusto27.position.set(-32.5, 1, 3.78)
pusto27.scale.set(4.15, 2, 2.64)
vse.add(pusto27)
// Стиляги
const vse_stilyagi = new THREE.Mesh(geometry, mat_vse)
vse_stilyagi.position.set(-32.5, 1, 5.86)
vse_stilyagi.scale.set(4.15, 2, 1.36)
vse.add(vse_stilyagi)
const vse_stilyagi_1 = new THREE.Mesh(geometry, mat_vse)
vse_stilyagi_1.position.set(-31.94, 1, 6.56)
vse_stilyagi_1.scale.set(3.03, 2, 2.72)
vse.add(vse_stilyagi_1)
const vse_stilyagi_2 = new THREE.Mesh(geometry5, mat_vse)
vse_stilyagi_2.position.set(-34.015, 1, 7.229)
vse_stilyagi_2.scale.set(-0.97, 1.732, -1.195)
vse.add(vse_stilyagi_2)
// Студия лак
const vse_studia_lak = new THREE.Mesh(geometry, mat_vse)
vse_studia_lak.position.set(-32.45, 1, -9.55)
vse_studia_lak.scale.set(4.3, 2, 1.9)
vse.add(vse_studia_lak)
// Фамилия
const vse_familiya1 = new THREE.Mesh(geometry, mat_vse)
vse_familiya1.position.set(-15.8, 1, 23.85)
vse_familiya1.scale.set(5.8, 2, 10.6)
vse.add(vse_familiya1)
const vse_familiya2 = new THREE.Mesh(geometry, mat_vse)
vse_familiya2.position.set(-22.1, 1, 13.75)
vse_familiya2.scale.set(7.3, 2, 5.8)
vse.add(vse_familiya2)
const vse_familiya3 = new THREE.Mesh(geometry, mat_vse)
vse_familiya3.position.set(-24.3, 1, 22.9)
vse_familiya3.scale.set(11.65, 2, 12.5)
vse.add(vse_familiya3)
// Access
const vse_access = new THREE.Mesh(geometry, mat_vse)
vse_access.position.set(15.56, 1, 13)
vse_access.scale.set(2.14, 2, 4.4)
vse.add(vse_access)
// Медея
const vse_medeya = new THREE.Mesh(geometry, mat_vse)
vse_medeya.position.set(-27, 1, 13.7)
vse_medeya.scale.set(2.3, 2, 5.7)
vse.add(vse_medeya)
// Пусто Онлайнтрейд
const vse_onlinetreid = new THREE.Mesh(geometry, mat_pusto)
vse_onlinetreid.position.set(-4.13, 1, -13.4)
vse_onlinetreid.scale.set(3.78, 2, 1.3)
vse.add(vse_onlinetreid)
// Пусо 21
const pusto21 = new THREE.Mesh(geometry, mat_pusto)
pusto21.position.set(-4.13, 1, -15.65)
pusto21.scale.set(3.78, 2, 3.04)
vse.add(pusto21)
// Пусо 22
const pusto22 = new THREE.Mesh(geometry, mat_pusto)
pusto22.position.set(-4.13, 1, -12.02)
pusto22.scale.set(3.78, 2, 1.3)
vse.add(pusto22)
// был I.Lady
const vse_ilady_pusto = new THREE.Mesh(geometry, mat_pusto)
vse_ilady_pusto.position.set(-4.13, 1, -17.88)
vse_ilady_pusto.scale.set(3.78, 2, 1.26)
vse.add(vse_ilady_pusto)
const vse_ilady1_pusto = new THREE.Mesh(geometry, mat_pusto)
vse_ilady1_pusto.position.set(-5.04, 1, -18.75)
vse_ilady1_pusto.scale.set(2.04, 2, 3)
vse.add(vse_ilady1_pusto)
const vse_ilady2_pusto = new THREE.Mesh(geometry5, mat_pusto)
vse_ilady2_pusto.position.set(-3.131, 1, -19.38)
vse_ilady2_pusto.scale.set(1.541, 1.732, 1.507)
vse.add(vse_ilady2_pusto)
// scorpion 
const vse_scorpion = new THREE.Mesh(geometry, mat_vse)
vse_scorpion.position.set(9.72, 1, 6.25)
vse_scorpion.scale.set(1.55, 2, 2.8)
vse.add(vse_scorpion)
// scorpion 2
const vse_scorpion2 = new THREE.Mesh(geometry, mat_vse)
vse_scorpion2.position.set(17.1, 1, 3.2)
vse_scorpion2.scale.set(4.55, 2, 2.5)
vse.add(vse_scorpion2)
const vse_scorpion2_1 = new THREE.Mesh(geometry5, mat_vse)
vse_scorpion2_1.position.set(19.88, 1, 3.2)
vse_scorpion2_1.scale.set(0.9, 1.732, 2.1649)
vse.add(vse_scorpion2_1)
// Расчёска
const vse_rascheska = new THREE.Mesh(geometry, mat_vse)
vse_rascheska.position.set(16.675, 1, 0.62)
vse_rascheska.scale.set(3.7, 2, 2.46)
vse.add(vse_rascheska)
const vse_rascheska1 = new THREE.Mesh(geometry5, mat_vse)
vse_rascheska1.position.set(18.945, 1, 0.62)
vse_rascheska1.scale.set(0.73, 1.732, 2.128)
vse.add(vse_rascheska1)
// veste
const vse_veste = new THREE.Mesh(geometry, mat_vse)
vse_veste.position.set(13.4, 1, 13)
vse_veste.scale.set(1.9, 2, 4.4)
vse.add(vse_veste)
// Планета джинсов 
const vse_planeta_d = new THREE.Mesh(geometry, mat_vse)
vse_planeta_d.position.set(13.45, 1, -5.4)
vse_planeta_d.scale.set(8.9, 2, 3)
vse.add(vse_planeta_d)
// Был Индустрия красоты Теперь Хулиган
const vse_huligan_ = new THREE.Mesh(geometry, mat_vse)
vse_huligan_.position.set(14.88, 1, -8.06)
vse_huligan_.scale.set(6.04, 2, 2.12)
vse.add(vse_huligan_)
// Магия моды 
const vse_magiya_mody = new THREE.Mesh(geometry, mat_vse)
vse_magiya_mody.position.set(14.88, 1, -10.28)
vse_magiya_mody.scale.set(6.04, 2, 2.12)
vse.add(vse_magiya_mody)
const vse_magiya_mody1 = new THREE.Mesh(geometry5, mat_vse)
vse_magiya_mody1.position.set(18.1, 1, -10.28)
vse_magiya_mody1.scale.set(0.347, 1.732, -1.836)
vse.add(vse_magiya_mody1)
// Garnet
const vse_garnet = new THREE.Mesh(geometry, mat_vse)
vse_garnet.position.set(16.94, 1, -12.93)
vse_garnet.scale.set(2.72, 2, 2.98)
vse.add(vse_garnet)
const vse_garnet1 = new THREE.Mesh(geometry5, mat_vse)
vse_garnet1.position.set(18.75, 1, -12.93)
vse_garnet1.scale.set(0.78, 1.732, -2.5805)
vse.add(vse_garnet1)
// Саквояж
const vse_sakvoyag = new THREE.Mesh(geometry, mat_vse)
vse_sakvoyag.position.set(18.58, 1, -17.24)
vse_sakvoyag.scale.set(1.24, 2, 5.52)
vse.add(vse_sakvoyag)
const vse_sakvoyag1 = new THREE.Mesh(geometry, mat_vse)
vse_sakvoyag1.position.set(19.58, 1, -19.23)
vse_sakvoyag1.scale.set(3.24, 2, 1.542)
vse.add(vse_sakvoyag1)
const vse_sakvoyag2 = new THREE.Mesh(geometry5, mat_vse)
vse_sakvoyag2.position.set(20.2, 1, -16.471)
vse_sakvoyag2.scale.set(1.732, 1.732, -3.4445)
vse.add(vse_sakvoyag2)
// Мех для всех
const vse_meh_dlya_vseh = new THREE.Mesh(geometry, mat_vse)
vse_meh_dlya_vseh.position.set(4, 1, -16)
vse_meh_dlya_vseh.scale.set(3.5, 2, 8)
vse.add(vse_meh_dlya_vseh)
const vse_meh_dlya_vseh1 = new THREE.Mesh(geometry, mat_vse)
vse_meh_dlya_vseh1.position.set(1.64, 1, -15.2)
vse_meh_dlya_vseh1.scale.set(1.22, 2, 6.4)
vse.add(vse_meh_dlya_vseh1)
const vse_meh_dlya_vseh2 = new THREE.Mesh(geometry5, mat_vse)
vse_meh_dlya_vseh2.position.set(1.641, 1, -19.2)
vse_meh_dlya_vseh2.scale.set(-1.056, 1.732, 1.386)
vse.add(vse_meh_dlya_vseh2)
// Обувной квартал 
const vse_ob_kvartal = new THREE.Mesh(geometry, mat_vse)
vse_ob_kvartal.position.set(13.45, 1, -2.25)
vse_ob_kvartal.scale.set(8.9, 2, 3)
vse.add(vse_ob_kvartal)
const vse_cylinder = new THREE.Mesh(geometry2, mat_vse)
vse_cylinder.position.set(17.8, 1, -1.75)
vse_cylinder.scale.set(0.7, 2, 2)
vse_cylinder.rotation.set(0, 3.1, 0)
vse.add(vse_cylinder)
// Леонардо
const vse_leonardo = new THREE.Mesh(geometry, mat_vse)
vse_leonardo.position.set(19.2, 1, 16.5)
vse_leonardo.scale.set(4.9, 2, 11.4)
vse.add(vse_leonardo)
// Modi
const vse_modi = new THREE.Mesh(geometry, mat_vse)
vse_modi.position.set(25.4, 1, 18.8)
vse_modi.scale.set(7.3, 2, 2.2)
vse.add(vse_modi)
// остров Соколов
const vse_ostrov_sokolov = new THREE.Mesh(geometry, mat_vse)
vse_ostrov_sokolov.position.set(32.7, 1, 19.5)
vse_ostrov_sokolov.scale.set(1.75, 2, 3.5)
vse.add(vse_ostrov_sokolov)
// остров Славянский дом
const vse_slavdom = new THREE.Mesh(geometry, mat_vse)
vse_slavdom.position.set(29.9, 1, 12)
vse_slavdom.scale.set(1.6, 2, 1.5)
vse.add(vse_slavdom)
// остров детская железная дорога - аттракцион детский
const vse_gelezdoroga = new THREE.Mesh(geometry, mat_vse)
vse_gelezdoroga.position.set(54.36, 1, 11.85)
vse_gelezdoroga.scale.set(1.7, 2, 1.5)
vse.add(vse_gelezdoroga)
// Sweet Cat
const vse_sweet_cat = new THREE.Mesh(geometry, mat_vse)
vse_sweet_cat.position.set(25.4, 1, 21.1)
vse_sweet_cat.scale.set(7.3, 2, 2.2)
vse.add(vse_sweet_cat)
// On-связь
const vse_svyaz = new THREE.Mesh(geometry, mat_vse)
vse_svyaz.position.set(27.75, 1, 25.65)
vse_svyaz.scale.set(2.58, 2, 2.63)
vse.add(vse_svyaz)
// 585 Золотой
const vse_585_zolotoy = new THREE.Mesh(geometry, mat_vse)
vse_585_zolotoy.position.set(37.64, 1, 23.35)
vse_585_zolotoy.scale.set(4.5, 2, 2.4)
vse.add(vse_585_zolotoy)
// Мегафон
const vse_megafon = new THREE.Mesh(geometry, mat_vse)
vse_megafon.position.set(39.05, 1, 18.5)
vse_megafon.scale.set(7.4, 2, 2.6)
vse.add(vse_megafon)
// Косметичка
const vse_kosmetichka = new THREE.Mesh(geometry, mat_vse)
vse_kosmetichka.position.set(39.45, 1, 15.13)
vse_kosmetichka.scale.set(2.2, 2, 3.91)
vse.add(vse_kosmetichka)
// Билайн
const vse_beelain = new THREE.Mesh(geometry, mat_vse)
vse_beelain.position.set(41.7, 1, 15.13)
vse_beelain.scale.set(2.15, 2, 3.91)
vse.add(vse_beelain)
// Подружка
const vse_podrugka = new THREE.Mesh(geometry, mat_vse)
vse_podrugka.position.set(45.07, 1, 15.13)
vse_podrugka.scale.set(4.45, 2, 3.91)
vse.add(vse_podrugka)
// Sotiks
const vse_sotiks = new THREE.Mesh(geometry, mat_vse)
vse_sotiks.position.set(52.15, 1, 15.13)
vse_sotiks.scale.set(2.21, 2, 3.91)
vse.add(vse_sotiks)
// Diamant
const vse_diamant = new THREE.Mesh(geometry, mat_vse)
vse_diamant.position.set(54.36, 1, 15.13)
vse_diamant.scale.set(1.91, 2, 3.91)
vse.add(vse_diamant)
// Фабрика костюма
const vse_fabrika_kostuma = new THREE.Mesh(geometry, mat_vse)
vse_fabrika_kostuma.position.set(56.4, 1, 15.13)
vse_fabrika_kostuma.scale.set(1.91, 2, 3.91)
vse.add(vse_fabrika_kostuma)
// МТС
const vse_mts = new THREE.Mesh(geometry, mat_vse)
vse_mts.position.set(58.3, 1, 15.13)
vse_mts.scale.set(1.6, 2, 3.91)
vse.add(vse_mts)
// Ангел
const vse_angel = new THREE.Mesh(geometry, mat_vse)
vse_angel.position.set(60, 1, 15.13)
vse_angel.scale.set(1.6, 2, 3.91)
vse.add(vse_angel)
// Здоровье
const vse_zdorovie = new THREE.Mesh(geometry, mat_vse)
vse_zdorovie.position.set(67.2, 1, 16.22)
vse_zdorovie.scale.set(2.6, 2, 6.08)
vse.add(vse_zdorovie)
// Ariya Shop
const vse_ariya_shop = new THREE.Mesh(geometry, mat_vse)
vse_ariya_shop.position.set(70.41, 1, 20.49)
vse_ariya_shop.scale.set(3.66, 2, 14.62)
vse.add(vse_ariya_shop)
const vse_ariya_shop1 = new THREE.Mesh(geometry, mat_vse)
vse_ariya_shop1.position.set(71.11, 1, 21.15)
vse_ariya_shop1.scale.set(5.06, 2, 13.3)
vse.add(vse_ariya_shop1)
const vse_ariya_shop2 = new THREE.Mesh(geometry5, mat_vse)
vse_ariya_shop2.position.set(72.94, 1, 13.84)
vse_ariya_shop2.scale.set(1.212, 1.732, 1.143)
vse.add(vse_ariya_shop2)
// Холодильник.ру
const vse_holodilnik_ru = new THREE.Mesh(geometry, mat_vse)
vse_holodilnik_ru.position.set(76.12, 1, 24.08)
vse_holodilnik_ru.scale.set(4.8, 2, 9.78)
vse.add(vse_holodilnik_ru)
const vse_holodilnik_ru1 = new THREE.Mesh(geometry, mat_vse)
vse_holodilnik_ru1.position.set(76.7, 1, 27.08)
vse_holodilnik_ru1.scale.set(5.96, 2, 3.78)
vse.add(vse_holodilnik_ru1)
const vse_holodilnik_ru2 = new THREE.Mesh(geometry, mat_vse)
vse_holodilnik_ru2.position.set(75.81, 1, 28.43)
vse_holodilnik_ru2.scale.set(7.74, 2, 1.08)
vse.add(vse_holodilnik_ru2)
const vse_holodilnik_ru3 = new THREE.Mesh(geometry5, mat_vse)
vse_holodilnik_ru3.position.set(76.12, 1, 16.89)
vse_holodilnik_ru3.scale.set(4.157, 1.732, 3.984)
vse.add(vse_holodilnik_ru3)
// Мир обуви
const vse_mir_obivi = new THREE.Mesh(geometry, mat_vse)
vse_mir_obivi.position.set(82.24, 1, 27.83)
vse_mir_obivi.scale.set(4.98, 2, 2.28)
vse.add(vse_mir_obivi)
const vse_mir_obivi1 = new THREE.Mesh(geometry, mat_vse)
vse_mir_obivi1.position.set(81.92, 1, 25.6)
vse_mir_obivi1.scale.set(4.34, 2, 2.24)
vse.add(vse_mir_obivi1)
const vse_mir_obivi2 = new THREE.Mesh(geometry5, mat_vse)
vse_mir_obivi2.position.set(81.34, 1, 21.86)
vse_mir_obivi2.scale.set(4.763, 1.732, 4.538)
vse.add(vse_mir_obivi2)
const vse_mir_obivi3 = new THREE.Mesh(geometry, mat_vse)
vse_mir_obivi3.position.set(79.23, 1, 24.48)
vse_mir_obivi3.scale.set(1.28, 2, 1.28)
vse.add(vse_mir_obivi3)
// S. Holmes
const vse_s_holmes = new THREE.Mesh(geometry, mat_vse)
vse_s_holmes.position.set(84.63, 1, 26.11)
vse_s_holmes.scale.set(1, 2, 1.06)
vse.add(vse_s_holmes)
const vse_s_holmes1 = new THREE.Mesh(geometry5, mat_vse)
vse_s_holmes1.position.set(84.63, 1, 25.05)
vse_s_holmes1.scale.set(0.866, 1.732, 0.918)
vse.add(vse_s_holmes1)
// Пусто 43
const pusto43 = new THREE.Mesh(geometry, mat_pusto)
pusto43.position.set(74.38, 1, 33.55)
pusto43.scale.set(4.88, 2, 8.98)
vse.add(pusto43)
// Zenden
const vse_zenden = new THREE.Mesh(geometry, mat_vse)
vse_zenden.position.set(81.83, 1, 33.55)
vse_zenden.scale.set(9.86, 2, 8.98)
vse.add(vse_zenden)
const vse_zenden_1 = new THREE.Mesh(geometry, mat_vse)
vse_zenden_1.position.set(85.78, 1, 32.6)
vse_zenden_1.scale.set(1.96, 2, 10.88)
vse.add(vse_zenden_1)
const vse_zenden_2 = new THREE.Mesh(geometry5, mat_vse)
vse_zenden_2.position.set(85.97, 1, 26.4)
vse_zenden_2.scale.set(1.368, 1.732, 1.318)
vse.add(vse_zenden_2)
const vse_zenden_3 = new THREE.Mesh(geometry, mat_vse)
vse_zenden_3.position.set(85.05, 1, 26.93)
vse_zenden_3.scale.set(0.5, 2, 0.5)
vse.add(vse_zenden_3)
// Читай город
const vse_chitay_gorod = new THREE.Mesh(geometry, mat_vse)
vse_chitay_gorod.position.set(21.58, 1, 23.98)
vse_chitay_gorod.scale.set(9.6, 2, 3.4)
vse.add(vse_chitay_gorod)
const vse_chitay_gorod1 = new THREE.Mesh(geometry, mat_vse)
vse_chitay_gorod1.position.set(27.7, 1, 23.27)
vse_chitay_gorod1.scale.set(2.7, 2, 2)
vse.add(vse_chitay_gorod1)
// Улыбка радуги
const vse_ulybka_radugi = new THREE.Mesh(geometry, mat_vse)
vse_ulybka_radugi.position.set(21.58, 1, 27.91)
vse_ulybka_radugi.scale.set(9.6, 2, 4.35)
vse.add(vse_ulybka_radugi)
const vse_ulybka_radugi1 = new THREE.Mesh(geometry, mat_vse)
vse_ulybka_radugi1.position.set(27.7, 1, 28.55)
vse_ulybka_radugi1.scale.set(2.7, 2, 3.07)
vse.add(vse_ulybka_radugi1)
// Антей
// const vse_cyl_antey = new THREE.Mesh(geometry2, mat_vse)
// vse_cyl_antey.position.set(27.4, 1, 14.42)
// vse_cyl_antey.scale.set(2.2, 2, 1.3)
// vse_cyl_antey.rotation.y = -Math.PI/4
// vse.add(vse_cyl_antey)
// Айкрафт
const vse_aikraft1 = new THREE.Mesh(geometry3, mat_vse)
vse_aikraft1.position.set(26.5, 1, 15.35)
vse_aikraft1.scale.set(2.85, 2, 2.5)
vse_aikraft1.rotation.y = Math.PI/2
vse.add(vse_aikraft1)
const vse_cyl_aikraft2 = new THREE.Mesh(geometry_plane, mat_vse)
vse_cyl_aikraft2.position.set(27.75, 1, 15.35)
vse_cyl_aikraft2.scale.set(2, 2.495, 2)
vse_cyl_aikraft2.rotation.z = -Math.PI/2
vse.add(vse_cyl_aikraft2)
const vse_cyl_aikraft3 = new THREE.Mesh(geometry_plane, mat_vse)
vse_cyl_aikraft3.position.set(26.5, 1, 13.93)
vse_cyl_aikraft3.scale.set(2.84, 2, 2)
vse_cyl_aikraft3.rotation.y = -Math.PI/2
vse.add(vse_cyl_aikraft3)
const vse_aikraft = new THREE.Mesh(geometry, mat_vse)
vse_aikraft.position.set(27.75, 1, 16.47)
vse_aikraft.scale.set(2.495, 2, 2.24)
vse.add(vse_aikraft)
// Рив Гош
const vse_riv_gosh = new THREE.Mesh(geometry, mat_vse)
vse_riv_gosh.position.set(24.1, 1, 15.06)
vse_riv_gosh.scale.set(4.65, 2, 5.1)
vse.add(vse_riv_gosh)
const vse_cyl_riv_gosh = new THREE.Mesh(geometry2, mat_vse)
vse_cyl_riv_gosh.position.set(23.1, 1, 13.4)
vse_cyl_riv_gosh.scale.set(3.2, 2, 1.8)
vse_cyl_riv_gosh.rotation.y = -Math.PI/4
vse.add(vse_cyl_riv_gosh)
const vse_cyl_riv_gosh1 = new THREE.Mesh(geometry4, mat_vse)
vse_cyl_riv_gosh1.position.set(21.75, 1, 16.15)
vse_cyl_riv_gosh1.scale.set(5, 2, 5.95)
vse_cyl_riv_gosh1.rotation.y = Math.PI/1.41
vse.add(vse_cyl_riv_gosh1)
// Кари гипер
const vse_kari_giper = new THREE.Mesh(geometry, mat_vse)
vse_kari_giper.position.set(30.55, 1, -8.32)
vse_kari_giper.scale.set(7.6, 2, 23.25)
vse.add(vse_kari_giper)
const vse_kari_giper1 = new THREE.Mesh(geometry, mat_vse)
vse_kari_giper1.position.set(33.12, 1, 1.15)
vse_kari_giper1.scale.set(4.22, 2, 13.6)
vse.add(vse_kari_giper1)
// Rossini
const vse_rossini = new THREE.Mesh(geometry, mat_vse)
vse_rossini.position.set(36.4, 1, -15.86)
vse_rossini.scale.set(3.85, 2, 8.2)
vse.add(vse_rossini)
//Мобильные штучки
const vse_mobshtuki = new THREE.Mesh(geometry5, mat_vse)
vse_mobshtuki.position.set(39.13, 1, -18.16)
vse_mobshtuki.scale.set(1.22, 1.74, 3.2)
vse.add(vse_mobshtuki)
// Пусто Женские штучки
const vse_genskie_shtuki = new THREE.Mesh(geometry, mat_pusto)
vse_genskie_shtuki.position.set(39.14, 1, -15.27)
vse_genskie_shtuki.scale.set(1.45, 2, 1.96)
vse.add(vse_genskie_shtuki)
const vse_genskie_shtuki1 = new THREE.Mesh(geometry5, mat_pusto)
vse_genskie_shtuki1.position.set(40.195, 1, -15.27)
vse_genskie_shtuki1.scale.set(0.572, 1.732, 1.697)
vse.add(vse_genskie_shtuki1)
// K&M
const vse_km = new THREE.Mesh(geometry, mat_vse)
vse_km.position.set(39.5, 1, -13)
vse_km.scale.set(2.15, 2, 2.46)
vse.add(vse_km)
const vse_km1 = new THREE.Mesh(geometry5, mat_vse)
vse_km1.position.set(40.92, 1, -13)
vse_km1.scale.set(0.598, 1.732, 2.13)
vse.add(vse_km1)
// Пусто вместо ПаниЯна
const vse_paniyana = new THREE.Mesh(geometry, mat_pusto)
vse_paniyana.position.set(39.22, 1, -7.22)
vse_paniyana.scale.set(4.8, 2, 2.96)
vse.add(vse_paniyana)
const vse_paniyana1 = new THREE.Mesh(geometry5, mat_pusto)
vse_paniyana1.position.set(41.72, 1, -7.22)
vse_paniyana1.scale.set(0.173, 1.732, 2.5633)
vse.add(vse_paniyana1)
// Savari
const vse_savari = new THREE.Mesh(geometry, mat_vse)
vse_savari.position.set(38.46, 1, -3.88)
vse_savari.scale.set(6.28, 2, 3.56)
vse.add(vse_savari)
const vse_savari1 = new THREE.Mesh(geometry5, mat_vse)
vse_savari1.position.set(41.7, 1, -3.88)
vse_savari1.scale.set(0.1732, 1.732, -3.083)
vse.add(vse_savari1)
// Barhat Shev
const vse_barhat_shev = new THREE.Mesh(geometry, mat_vse)
vse_barhat_shev.position.set(38.18, 1, -0.8)
vse_barhat_shev.scale.set(5.72, 2, 2.46)
vse.add(vse_barhat_shev)
const vse_barhat_shev1 = new THREE.Mesh(geometry5, mat_vse)
vse_barhat_shev1.position.set(41.31, 1, -0.8)
vse_barhat_shev1.scale.set(0.468, 1.732, -2.13)
vse.add(vse_barhat_shev1)
// Пусто вместо Ariana
const vse_ariana = new THREE.Mesh(geometry, mat_pusto)
vse_ariana.position.set(37.74, 1, 1.7)
vse_ariana.scale.set(4.84, 2, 2.4)
vse.add(vse_ariana)
const vse_ariana1 = new THREE.Mesh(geometry5, mat_pusto)
vse_ariana1.position.set(40.59, 1, 1.7)
vse_ariana1.scale.set(0.745, 1.732, -2.078)
vse.add(vse_ariana1)
// Xiaomi
const vse_xiaomi = new THREE.Mesh(geometry, mat_vse)
vse_xiaomi.position.set(36.2, 1, 5.47)
vse_xiaomi.scale.set(1.76, 2, 5)
vse.add(vse_xiaomi)
const vse_xiaomi1 = new THREE.Mesh(geometry5, mat_vse)
vse_xiaomi1.position.set(38.61, 1, 5.47)
vse_xiaomi1.scale.set(2.65, 1.732, -4.33)
vse.add(vse_xiaomi1)
// Аптека Антей
const vse_yves_rocher_france = new THREE.Mesh(geometry, mat_vse)
vse_yves_rocher_france.position.set(28.86, 1, 5.67)
vse_yves_rocher_france.scale.set(4.12, 2, 4.56)
vse.add(vse_yves_rocher_france)
// Украсим
const vse_ukrasim = new THREE.Mesh(geometry, mat_vse)
vse_ukrasim.position.set(26.35, 1, 5.67)
vse_ukrasim.scale.set(0.7, 2, 4.56)
vse.add(vse_ukrasim)
const vse_ukrasim1 = new THREE.Mesh(geometry5, mat_vse)
vse_ukrasim1.position.set(24.52, 1, 5.67)
vse_ukrasim1.scale.set(-2.563, 1.732, -3.949)
vse.add(vse_ukrasim1)
// Метелица
const vse_metelica = new THREE.Mesh(geometry, mat_vse)
vse_metelica.position.set(24.84, 1, 1.5)
vse_metelica.scale.set(3.72, 2, 3.58)
vse.add(vse_metelica)
const vse_metelica1 = new THREE.Mesh(geometry5, mat_vse)
vse_metelica1.position.set(22.43, 1, 1.5)
vse_metelica1.scale.set(-0.953, 1.732, -3.1)
vse.add(vse_metelica1)
// София
const vse_sofiya = new THREE.Mesh(geometry, mat_vse)
vse_sofiya.position.set(24.23, 1, -3.45)
vse_sofiya.scale.set(4.94, 2, 6.12)
vse.add(vse_sofiya)
const vse_sofiya1 = new THREE.Mesh(geometry, mat_vse)
vse_sofiya1.position.set(21.43, 1, -4.83)
vse_sofiya1.scale.set(0.66, 2, 3.36)
vse.add(vse_sofiya1)
const vse_sofiya2 = new THREE.Mesh(geometry5, mat_vse)
vse_sofiya2.position.set(21.43, 1, -1.77)
vse_sofiya2.scale.set(-0.572, 1.732, -2.39)
vse.add(vse_sofiya2)
// Бывший Francesco Donni
const vse_rancesco_donni = new THREE.Mesh(geometry, mat_vse)
vse_rancesco_donni.position.set(23.9, 1, -7.94)
vse_rancesco_donni.scale.set(5.6, 2, 2.66)
vse.add(vse_rancesco_donni)
const vse_rancesco_donni1 = new THREE.Mesh(geometry, mat_vse)
vse_rancesco_donni1.position.set(24.02, 1, -8.63)
vse_rancesco_donni1.scale.set(5.36, 2, 4.04)
vse.add(vse_rancesco_donni1)
const vse_rancesco_donni2 = new THREE.Mesh(geometry5, mat_vse)
vse_rancesco_donni2.position.set(21.22, 1, -9.959)
vse_rancesco_donni2.scale.set(-0.208, 1.732, 1.195)
vse.add(vse_rancesco_donni2)
// Ковры
const vse_kovry_ = new THREE.Mesh(geometry, mat_vse)
vse_kovry_.position.set(25.56, 1, -16.62)
vse_kovry_.scale.set(2.18, 2, 6.66)
vse.add(vse_kovry_)
const vse_kovry_1 = new THREE.Mesh(geometry5, mat_vse)
vse_kovry_1.position.set(23.23, 1, -16.62)
vse_kovry_1.scale.set(-2.148, 1.732, 5.768)
vse.add(vse_kovry_1)
// Fashion Shoes
const vse_fashion_shoes = new THREE.Mesh(geometry, mat_vse)
vse_fashion_shoes.position.set(7.4, 1, 4.1)
vse_fashion_shoes.scale.set(2.95, 2, 7.1)
vse.add(vse_fashion_shoes)
const vse_fashion_shoes1 = new THREE.Mesh(geometry, mat_vse)
vse_fashion_shoes1.position.set(5.44, 1, 2.71)
vse_fashion_shoes1.scale.set(2.02, 2, 4.32)
vse.add(vse_fashion_shoes1)
// АШАН
const vse_ashan = new THREE.Mesh(geometry, mat_vse)
vse_ashan.position.set(94, 1, -9.55)
vse_ashan.scale.set(28.5, 2, 53.25)
vse.add(vse_ashan)
// Ozon
const vse_ozon = new THREE.Mesh(geometry5, mat_vse)
vse_ozon.position.set(80.77, 1, 17.92)
vse_ozon.scale.set(-1.767, 1.732, -1.334)
vse.add(vse_ozon)
// КанцПарк
const vse_kancpark = new THREE.Mesh(geometry, mat_vse)
vse_kancpark.position.set(83.92, 1, 17.92)
vse_kancpark.scale.set(4.1, 2, 1.54)
vse.add(vse_kancpark)
const vse_kancpark1 = new THREE.Mesh(geometry5, mat_vse)
vse_kancpark1.position.set(83.92, 1, 20.31)
vse_kancpark1.scale.set(-3.551, 1.732, -2.806)
vse.add(vse_kancpark1)
// Weider спорт
const vse_weider_sport = new THREE.Mesh(geometry, mat_vse)
vse_weider_sport.position.set(-4.65, 1, -29.7)
vse_weider_sport.scale.set(5.35, 2, 12.75)
vse.add(vse_weider_sport)
// Салон красоты @M&M@
const vse_krasota = new THREE.Mesh(geometry, mat_vse)
vse_krasota.position.set(0.36, 1, -35.05)
vse_krasota.scale.set(4.52, 2, 2.04)
vse.add(vse_krasota)
// Футболис
const vse_futbolis = new THREE.Mesh(geometry, mat_vse)
vse_futbolis.position.set(-1, 1, -30.6)
vse_futbolis.scale.set(1.8, 2, 6.7)
vse.add(vse_futbolis)
// Пусто 188
const pusto188 = new THREE.Mesh(geometry, mat_pusto)
pusto188.position.set(14.63, 1, -35.09)
pusto188.scale.set(10.84, 2, 2.08)
vse.add(pusto188)
const pusto188_1 = new THREE.Mesh(geometry, mat_pusto)
pusto188_1.position.set(15.8, 1, -33.6)
pusto188_1.scale.set(8.5, 2, 0.9)
vse.add(pusto188_1)
// Scarlet
const vse_scarlet = new THREE.Mesh(geometry, mat_vse)
vse_scarlet.position.set(3.65, 1, -24.7)
vse_scarlet.scale.set(2.1, 2, 2.6)
vse.add(vse_scarlet)
// Офис Такси
const vse_taxi = new THREE.Mesh(geometry, mat_vse)
vse_taxi.position.set(3.65, 1, -26.9)
vse_taxi.scale.set(2.1, 2, 1.6)
vse.add(vse_taxi)
// Стирка.com
const vse_stirka = new THREE.Mesh(geometry, mat_vse)
vse_stirka.position.set(3.65, 1, -28.77)
vse_stirka.scale.set(2.1, 2, 1.98)
vse.add(vse_stirka)
// Логопед
const vse_logoped = new THREE.Mesh(geometry, mat_vse)
vse_logoped.position.set(3.65, 1, -30.7)
vse_logoped.scale.set(2.1, 2, 1.72)
vse.add(vse_logoped)
// Пусто 187
const pusto187 = new THREE.Mesh(geometry, mat_pusto)
pusto187.position.set(3.65, 1, -32.35)
pusto187.scale.set(2.1, 2, 1.42)
vse.add(pusto187)
// Зоозавр
const pusto_zoozavr = new THREE.Mesh(geometry, mat_vse)
pusto_zoozavr.position.set(6.45, 1, -24.5)
pusto_zoozavr.scale.set(3.27, 2, 2.2)
vse.add(pusto_zoozavr)
// Пусто вместо Originals
const vse_originals = new THREE.Mesh(geometry, mat_pusto)
vse_originals.position.set(9.12, 1, -24.85)
vse_originals.scale.set(1.9, 2, 2.9)
vse.add(vse_originals)
// Best
const vse_best = new THREE.Mesh(geometry, mat_vse)
vse_best.position.set(11.65, 1, -24.85)
vse_best.scale.set(3, 2, 2.9)
vse.add(vse_best)
// был Verona стал I.Lady
const vse_ilady = new THREE.Mesh(geometry, mat_vse)
vse_ilady.position.set(40.4, 1, -25.32)
vse_ilady.scale.set(2.83, 2, 3.8)
vse.add(vse_ilady)
// пусто вместо Bolini
const vse_bolini = new THREE.Mesh(geometry, mat_pusto)
vse_bolini.position.set(43.3, 1, -25.32)
vse_bolini.scale.set(2.78, 2, 3.8)
vse.add(vse_bolini)
// Пусто вместо Модный город
const vse_modgorod = new THREE.Mesh(geometry, mat_pusto)
vse_modgorod.position.set(47.42, 1, -29.8)
vse_modgorod.scale.set(5.29, 2, 12.7)
vse.add(vse_modgorod)
// Stockburg 
const vse_stockburg = new THREE.Mesh(geometry, mat_vse)
vse_stockburg.position.set(52.83, 1, -29.8)
vse_stockburg.scale.set(5.3, 2, 12.7)
vse.add(vse_stockburg)
// kristi
const vse_kristi = new THREE.Mesh(geometry, mat_vse)
vse_kristi.position.set(56.8, 1, -26.62)
vse_kristi.scale.set(2.3, 2, 6.35)
vse.add(vse_kristi)
// Пусто 32
const pusto32 = new THREE.Mesh(geometry, mat_pusto)
pusto32.position.set(61.15, 1, -26.66)
pusto32.scale.set(6.24, 2, 6.46)
vse.add(pusto32)
const pusto32_1 = new THREE.Mesh(geometry, mat_pusto)
pusto32_1.position.set(60.97, 1, -33.01)
pusto32_1.scale.set(10.64, 2, 6.27)
vse.add(pusto32_1)
// Пусто 33
const pusto33 = new THREE.Mesh(geometry, mat_pusto)
pusto33.position.set(65.32, 1, -26.62)
pusto33.scale.set(1.94, 2, 6.35)
vse.add(pusto33)
// Gloria Jeans
const vse_gloria_jeans = new THREE.Mesh(geometry, mat_vse)
vse_gloria_jeans.position.set(70.25, 1, -31.58)
vse_gloria_jeans.scale.set(6.8, 2, 9.15)
vse.add(vse_gloria_jeans)
// Пусто 189
const pusto189 = new THREE.Mesh(geometry, mat_pusto)
pusto189.position.set(74.78, 1, -34.42)
pusto189.scale.set(0.86, 2, 3.46)
vse.add(pusto189)
// Пусто 190
const pusto190 = new THREE.Mesh(geometry, mat_pusto)
pusto190.position.set(75.9, 1, -34.42)
pusto190.scale.set(1.24, 2, 3.46)
vse.add(pusto190)
// Дисконт-центр
const vse_diskont_centr = new THREE.Mesh(geometry, mat_vse)
vse_diskont_centr.position.set(70.25, 1, -25.2)
vse_diskont_centr.scale.set(6.8, 2, 3.43)
vse.add(vse_diskont_centr)
// Химчистка Диана
const vse_himdiana = new THREE.Mesh(geometry5, mat_vse)
vse_himdiana.position.set(67.55, 1, -22.65)
vse_himdiana.scale.set(-1.23, 1.732, -1.3)
vse.add(vse_himdiana)
// Пусто
const vse_pusto18 = new THREE.Mesh(geometry, mat_pusto)
vse_pusto18.position.set(69.615, 1, -22.61)
vse_pusto18.scale.set(2.645, 2, 1.6)
vse.add(vse_pusto18)
// Ломбард
const vse_lombard = new THREE.Mesh(geometry, mat_vse)
vse_lombard.position.set(71.645, 1, -22.61)
vse_lombard.scale.set(1.35, 2, 1.6)
vse.add(vse_lombard)
const vse_lombard1 = new THREE.Mesh(geometry5, mat_vse)
vse_lombard1.position.set(73.0, 1, -22.6)
vse_lombard1.scale.set(1.2, 1.732, -1.4)
vse.add(vse_lombard1)
// Egoiste
const vse_egoiste = new THREE.Mesh(geometry, mat_vse)
vse_egoiste.position.set(66.54, 1, -14.48)
vse_egoiste.scale.set(2.7, 2, 8.55)
vse.add(vse_egoiste)
// Sabra
const vse_sabra = new THREE.Mesh(geometry, mat_vse)
vse_sabra.position.set(69.35, 1, -14.48)
vse_sabra.scale.set(2.7, 2, 8.55)
vse.add(vse_sabra)
// Антей 2
const vse_antey = new THREE.Mesh(geometry, mat_vse)
vse_antey.position.set(72.15, 1, -17.79)
vse_antey.scale.set(2.7, 2, 1.95)
vse.add(vse_antey)
// Космедэль
const vse_kosmedel = new THREE.Mesh(geometry, mat_vse)
vse_kosmedel.position.set(72.15, 1, -15)
vse_kosmedel.scale.set(2.7, 2, 3.7)
vse.add(vse_kosmedel)
// Медицинский мир
const vse_med_mir = new THREE.Mesh(geometry, mat_vse)
vse_med_mir.position.set(72.15, 1, -11.7)
vse_med_mir.scale.set(2.7, 2, 2.95)
vse.add(vse_med_mir)
// Capsula. My
const vse_capsula_my = new THREE.Mesh(geometry, mat_vse)
vse_capsula_my.position.set(69.35, 1, -8.53)
vse_capsula_my.scale.set(8.36, 2, 3.15)
vse.add(vse_capsula_my)
// Remoda
const vse_remoda = new THREE.Mesh(geometry, mat_vse)
vse_remoda.position.set(70.03, 1, -3.535)
vse_remoda.scale.set(6.96, 2, 6.71)
vse.add(vse_remoda)
const vse_remoda1 = new THREE.Mesh(geometry, mat_vse)
vse_remoda1.position.set(66.06, 1, -6.5)
vse_remoda1.scale.set(1.85, 2, 0.78)
vse.add(vse_remoda1)
const vse_remoda2 = new THREE.Mesh(geometry, mat_vse)
vse_remoda2.position.set(66.06, 1, -0.6)
vse_remoda2.scale.set(1.85, 2, 0.84)
vse.add(vse_remoda2)
const vse_remoda3 = new THREE.Mesh(geometry, mat_vse)
vse_remoda3.position.set(66.2153, 1, -5.82)
vse_remoda3.scale.set(2, 2, 1)
vse_remoda3.rotation.y = Math.PI/1.3
vse.add(vse_remoda3)
const vse_remoda4 = new THREE.Mesh(geometry, mat_vse)
vse_remoda4.position.set(66.187, 1, -1.393)
vse_remoda4.scale.set(2, 2, 1)
vse_remoda4.rotation.y = Math.PI/3.9
vse.add(vse_remoda4)
const vse_remoda5 = new THREE.Mesh(geometry, mat_vse)
vse_remoda5.position.set(66.65, 1, -5.3)
vse_remoda5.scale.set(2, 2, 1)
vse_remoda5.rotation.y = Math.PI/1.6
vse.add(vse_remoda5)
const vse_remoda6 = new THREE.Mesh(geometry, mat_vse)
vse_remoda6.position.set(66.65, 1, -2.1)
vse_remoda6.scale.set(2, 2, 1)
vse_remoda6.rotation.y = Math.PI/3.2
vse.add(vse_remoda6)
// 1000 и одна сумка
const vse_1001_sumka = new THREE.Mesh(geometry, mat_vse)
vse_1001_sumka.position.set(69.35, 1, 1.79)
vse_1001_sumka.scale.set(8.36, 2, 3.8)
vse.add(vse_1001_sumka)
// Пусто Best Shoes
const vse_best_shoes1 = new THREE.Mesh(geometry, mat_pusto)
vse_best_shoes1.position.set(67.4, 1, 4.7)
vse_best_shoes1.scale.set(4.5, 2, 1.85)
vse.add(vse_best_shoes1)
// Barselona
const vse_barselona = new THREE.Mesh(geometry, mat_vse)
vse_barselona.position.set(67.4, 1, 6.3)
vse_barselona.scale.set(4.5, 2, 1.2)
vse.add(vse_barselona)
// Кредо
const vse_kredo = new THREE.Mesh(geometry, mat_vse)
vse_kredo.position.set(67.4, 1, 7.6)
vse_kredo.scale.set(4.5, 2, 1.25)
vse.add(vse_kredo)
// Время стрижки
const vse_vremya_strigki = new THREE.Mesh(geometry, mat_vse)
vse_vremya_strigki.position.set(69.65, 1, 9.28)
vse_vremya_strigki.scale.set(1.8, 2, 1.9)
vse.add(vse_vremya_strigki)
// мтс 
const vse_mts1 = new THREE.Mesh(geometry5, mat_vse)
vse_mts1.position.set(75, 1, -17.26)
vse_mts1.scale.set(2.5, 1.74, 2.5)
vse.add(vse_mts1)
// Johnsons
const vse_johnsons = new THREE.Mesh(geometry, mat_vse)
vse_johnsons.position.set(75, 1, -14.5)
vse_johnsons.scale.set(2.8, 2, 2.45)
vse.add(vse_johnsons)
// Браво-оптика
const vse_bravo_optika = new THREE.Mesh(geometry, mat_vse)
vse_bravo_optika.position.set(75, 1, -11.7)
vse_bravo_optika.scale.set(2.8, 2, 2.95)
vse.add(vse_bravo_optika)
// Corona Store
const vse_corona_store = new THREE.Mesh(geometry, mat_vse)
vse_corona_store.position.set(75, 1, -8.55)
vse_corona_store.scale.set(2.8, 2, 3.15)
vse.add(vse_corona_store)
// Primavera
const vse_primavera = new THREE.Mesh(geometry, mat_vse)
vse_primavera.position.set(75, 1, -5.55)
vse_primavera.scale.set(2.8, 2, 2.65)
vse.add(vse_primavera)
// Gipfel
const vse_gipfel = new THREE.Mesh(geometry, mat_vse)
vse_gipfel.position.set(75, 1, -2.9)
vse_gipfel.scale.set(2.8, 2, 2.45)
vse.add(vse_gipfel)
// Ригла
const vse_rigla = new THREE.Mesh(geometry, mat_vse)
vse_rigla.position.set(75, 1, 0)
vse_rigla.scale.set(2.8, 2, 3.2)
vse.add(vse_rigla)
// Кофе и чай
const vse_kofe_chay = new THREE.Mesh(geometry, mat_vse)
vse_kofe_chay.position.set(75, 1, 2.68)
vse_kofe_chay.scale.set(2.8, 2, 2)
vse.add(vse_kofe_chay)
// Пусто Мир сумок и аксессуаров
const vse_mir_sumok = new THREE.Mesh(geometry, mat_pusto)
vse_mir_sumok.position.set(75, 1, 4.8)
vse_mir_sumok.scale.set(2.8, 2, 2.05)
vse.add(vse_mir_sumok)
// Tele2
const vse_tele2 = new THREE.Mesh(geometry, mat_vse)
vse_tele2.position.set(75, 1, 6.74)
vse_tele2.scale.set(2.8, 2, 1.68)
vse.add(vse_tele2)
const vse_tele21 = new THREE.Mesh(geometry, mat_vse)
vse_tele21.position.set(74.72, 1, 7.82)
vse_tele21.scale.set(2.24, 2, 0.5)
vse.add(vse_tele21)
const vse_tele22 = new THREE.Mesh(geometry5, mat_vse)
vse_tele22.position.set(76.12, 1, 7.824)
vse_tele22.scale.set(0.425, 1.732, 0.486)
vse_tele22.rotation.y = -Math.PI/2
vse.add(vse_tele22)
// Восточные сладости
const vse_vost_sladosti = new THREE.Mesh(geometry5, mat_vse)
vse_vost_sladosti.position.set(74.7, 1, 9.12)
vse_vost_sladosti.scale.set(1.732, 1.732, 1.9)
vse_vost_sladosti.rotation.y = -Math.PI/2
vse.add(vse_vost_sladosti)
// Лэтуаль
const vse_letual = new THREE.Mesh(geometry, mat_vse)
vse_letual.position.set(88.76, 1, 19.8)
vse_letual.scale.set(4.05, 2, 5.15)
vse.add(vse_letual)
// Тофа
const vse_tofa = new THREE.Mesh(geometry, mat_vse)
vse_tofa.position.set(93, 1, 19.8)
vse_tofa.scale.set(4.05, 2, 5.15)
vse.add(vse_tofa)
// Аллея мебели
const vse_alleya_mebeli = new THREE.Mesh(geometry, mat_vse)
vse_alleya_mebeli.position.set(101.7, 1, 22.9)
vse_alleya_mebeli.scale.set(13.1, 2, 11.4)
vse.add(vse_alleya_mebeli)
const vse_alleya_mebeli1 = new THREE.Mesh(geometry, mat_vse)
vse_alleya_mebeli1.position.set(105.65, 1, 33.2)
vse_alleya_mebeli1.scale.set(5.2, 2, 9.55)
vse.add(vse_alleya_mebeli1)
// Четыре лапы
const vse_chetyre_lapy = new THREE.Mesh(geometry, mat_vse)
vse_chetyre_lapy.position.set(99.05, 1, 31.35)
vse_chetyre_lapy.scale.set(7.8, 2, 5.3)
vse.add(vse_chetyre_lapy)
const vse_chetyre_lapy1 = new THREE.Mesh(geometry, mat_vse)
vse_chetyre_lapy1.position.set(100.05, 1, 36)
vse_chetyre_lapy1.scale.set(5.78, 2, 4)
vse.add(vse_chetyre_lapy1)
// Пусто 42
const pusto42 = new THREE.Mesh(geometry, mat_pusto)
pusto42.position.set(94.16, 1, 36.05)
pusto42.scale.set(5.84, 2, 3.94)
vse.add(pusto42)
// Суши мания
const vse_sushimania = new THREE.Mesh(geometry, mat_vse)
vse_sushimania.position.set(93.13, 1, 32.18)
vse_sushimania.scale.set(3.78, 2, 3.64)
vse.add(vse_sushimania)
// Твой байк
const vse_tvoy_bayk = new THREE.Mesh(geometry, mat_vse)
vse_tvoy_bayk.position.set(58.47, 1, 33.25)
vse_tvoy_bayk.scale.set(5, 2, 4.65)
vse.add(vse_tvoy_bayk)
// Fix Price
const vse_fix_price = new THREE.Mesh(geometry, mat_vse)
vse_fix_price.position.set(45.24, 1, 32.85)
vse_fix_price.scale.set(3.65, 2, 5.52)
vse.add(vse_fix_price)
// Пусто 40
const pusto40 = new THREE.Mesh(geometry, mat_pusto)
pusto40.position.set(49.03, 1, 30.92)
pusto40.scale.set(3.8, 2, 1.66)
vse.add(pusto40)
// Пусто 41
const pusto41 = new THREE.Mesh(geometry, mat_pusto)
pusto41.position.set(49.03, 1, 32.85)
pusto41.scale.set(3.8, 2, 2.06)
vse.add(pusto41)
// Узбегим
const vse_uzbegim = new THREE.Mesh(geometry, mat_vse)
vse_uzbegim.position.set(49.03, 1, 34.78)
vse_uzbegim.scale.set(3.8, 2, 1.66)
vse.add(vse_uzbegim)
// М.Видео
const vse_mvideo = new THREE.Mesh(geometry, mat_vse)
vse_mvideo.position.set(58.44, 1, 23.61)
vse_mvideo.scale.set(14.74, 2, 12.74)
vse.add(vse_mvideo)
const vse_mvideo1 = new THREE.Mesh(geometry, mat_vse)
vse_mvideo1.position.set(63.35, 1, 15.3)
vse_mvideo1.scale.set(4.93, 2, 4.25)
vse.add(vse_mvideo1)
const vse_mvideo2 = new THREE.Mesh(geometry, mat_vse)
vse_mvideo2.position.set(64.8, 1, 27.46)
vse_mvideo2.scale.set(7.36, 2, 16.2)
vse.add(vse_mvideo2)
const vse_mvideo3 = new THREE.Mesh(geometry, mat_vse)
vse_mvideo3.position.set(69.2, 1, 32.95)
vse_mvideo3.scale.set(5.26, 2, 10.1)
vse.add(vse_mvideo3)
const vse_mvideo4 = new THREE.Mesh(geometry, mat_vse)
vse_mvideo4.position.set(54.67, 1, 32.7)
vse_mvideo4.scale.set(2.38, 2, 5.74)
vse.add(vse_mvideo4)
const vse_mvideo5 = new THREE.Mesh(geometry, mat_vse)
vse_mvideo5.position.set(58.47, 1, 29.7)
vse_mvideo5.scale.set(5.74, 2, 2.3)
vse.add(vse_mvideo5)
// Эстет
const vse_estet = new THREE.Mesh(geometry, mat_vse)
vse_estet.position.set(39.05, 1, 20.96)
vse_estet.scale.set(7.4, 2, 2.18)
vse.add(vse_estet)
const vse_estet1 = new THREE.Mesh(geometry, mat_vse)
vse_estet1.position.set(41.37, 1, 22.64)
vse_estet1.scale.set(2.75, 2, 1.2)
vse.add(vse_estet1)
// DNS
const vse_dns = new THREE.Mesh(geometry, mat_vse)
vse_dns.position.set(46.9, 1, 23.6)
vse_dns.scale.set(8.02, 2, 12.77)
vse.add(vse_dns)
const vse_dns1 = new THREE.Mesh(geometry, mat_vse)
vse_dns1.position.set(49.145, 1, 15.36)
vse_dns1.scale.set(3.53, 2, 4.4)
vse.add(vse_dns1)
const vse_dns2 = new THREE.Mesh(geometry, mat_vse)
vse_dns2.position.set(39.17, 1, 27.3)
vse_dns2.scale.set(7.55, 2, 5.37)
vse.add(vse_dns2)
const vse_dns3 = new THREE.Mesh(geometry, mat_vse)
vse_dns3.position.set(41.5, 1, 24.1)
vse_dns3.scale.set(3, 2, 1.6)
vse.add(vse_dns3)
// t2 вместо Corona Store
const vse_corona_store1 = new THREE.Mesh(geometry5, mat_vse)
vse_corona_store1.position.set(36.765, 0.998, 14.45)
vse_corona_store1.scale.set(2.25, 1.735, 2.53)
vse_corona_store1.rotation.y = Math.PI/2
vse.add(vse_corona_store1)
const vse_corona_store2 = new THREE.Mesh(geometry, mat_vse)
vse_corona_store2.position.set(36.766, 1, 16.419)
vse_corona_store2.scale.set(2.93, 2, 1.34)
vse.add(vse_corona_store2)
// Heart of Vape
const vse_heart_of_vape = new THREE.Mesh(geometry, mat_vse)
vse_heart_of_vape.position.set(39.33, 1, 31.31)
vse_heart_of_vape.scale.set(7.96, 2, 2.48)
vse.add(vse_heart_of_vape)
// Восточные сладости
const vse_vostok_sladosti = new THREE.Mesh(geometry, mat_vse)
vse_vostok_sladosti.position.set(39.33, 1, 33.61)
vse_vostok_sladosti.scale.set(7.96, 2, 1.98)
vse.add(vse_vostok_sladosti)
const vse_vostok_sladosti1 = new THREE.Mesh(geometry, mat_vse)
vse_vostok_sladosti1.position.set(42.46, 1, 34.13)
vse_vostok_sladosti1.scale.set(1.7, 2, 3.02)
vse.add(vse_vostok_sladosti1)
// Rostics
const vse_rostics = new THREE.Mesh(geometry, mat_vse)
vse_rostics.position.set(38.8, 1, 36.94)
vse_rostics.scale.set(5.48, 2, 4.54)
vse.add(vse_rostics)
// ВсеИнструменты.ру
const vse_vseinstrumenty = new THREE.Mesh(geometry, mat_vse)
vse_vseinstrumenty.position.set(14.27, 1, 37.25)
vse_vseinstrumenty.scale.set(4.72, 2, 3.784)
vse.add(vse_vseinstrumenty)
const pusto39 = new THREE.Mesh(geometry, mat_vse)
pusto39.position.set(14.27, 1, 32.34)
pusto39.scale.set(4.72, 2, 6.15)
vse.add(pusto39)
// Пусто 37
const pusto37 = new THREE.Mesh(geometry, mat_pusto)
pusto37.position.set(-26.22, 1, 32.24)
pusto37.scale.set(7.76, 2, 6.1)
vse.add(pusto37)
// Мерердиан-1
const vse_meredian1 = new THREE.Mesh(geometry, mat_vse)
vse_meredian1.position.set(-17.55, 1, 32.24)
vse_meredian1.scale.set(9.43, 2, 6.1)
vse.add(vse_meredian1)
// Склад ВкуссВил
const vse_vkussvil = new THREE.Mesh(geometry, mat_vse)
vse_vkussvil.position.set(-0.46, 1, 32.24)
vse_vkussvil.scale.set(24.58, 2, 6.1)
vse.add(vse_vkussvil)
// Чижик
const vse_chigik = new THREE.Mesh(geometry, mat_vse)
vse_chigik.position.set(22.1, 1, 33.19)
vse_chigik.scale.set(10.6, 2, 5.92)
vse.add(vse_chigik)
const vse_chigik1 = new THREE.Mesh(geometry, mat_vse)
vse_chigik1.position.set(20.45, 1, 37.21)
vse_chigik1.scale.set(7.3, 2, 3.84)
vse.add(vse_chigik1)
// ФермStore
const vse_fermstore = new THREE.Mesh(geometry, mat_vse)
vse_fermstore.position.set(27.84, 1, 34.33)
vse_fermstore.scale.set(0.7, 2, 3.64)
vse.add(vse_fermstore)
const vse_fermstore1 = new THREE.Mesh(geometry, mat_vse)
vse_fermstore1.position.set(28.49, 1, 34.95)
vse_fermstore1.scale.set(2, 2, 2.4)
vse.add(vse_fermstore1)
const vse_fermstore2 = new THREE.Mesh(geometry5, mat_vse)
vse_fermstore2.position.set(28.84, 1, 33.13)
vse_fermstore2.scale.set(1.126, 1.732, 1.074)
vse.add(vse_fermstore2)
// Gee Jay
const vse_gee_jay = new THREE.Mesh(geometry, mat_vse)
vse_gee_jay.position.set(-30.48, 1, 13.7)
vse_gee_jay.scale.set(4.43, 2, 5.7)
vse.add(vse_gee_jay)
const vse_gee_jay1 = new THREE.Mesh(geometry, mat_vse)
vse_gee_jay1.position.set(-31.5, 1, 21.4)
vse_gee_jay1.scale.set(2.38, 2, 9.7)
vse.add(vse_gee_jay1)
// Vita
const vse_vita = new THREE.Mesh(geometry, mat_vse)
vse_vita.position.set(-8.75, 1, 5.15)
vse_vita.scale.set(2.5, 2, 5.4)
vse.add(vse_vita)
const vse_vita1 = new THREE.Mesh(geometry, mat_vse)
vse_vita1.position.set(-10.195, 1, 2.0)
vse_vita1.scale.set(5.4, 2, 1.14)
vse.add(vse_vita1)
// Эльдорадо
const vse_eldorado = new THREE.Mesh(geometry, mat_vse)
vse_eldorado.position.set(-16.7, 1, -5.5)
vse_eldorado.scale.set(18.3, 2, 11.6)
vse.add(vse_eldorado)
const vse_eldorado1 = new THREE.Mesh(geometry, mat_vse)
vse_eldorado1.position.set(-25.17, 1, -0.15)
vse_eldorado1.scale.set(3.8, 2, 3.5)
vse.add(vse_eldorado1)
const vse_eldorado2 = new THREE.Mesh(geometry, mat_vse)
vse_eldorado2.position.set(-16.9, 1, 4.05)
vse_eldorado2.scale.set(7.8, 2, 7.7)
vse.add(vse_eldorado2)
const vse_eldorado3 = new THREE.Mesh(geometry, mat_vse)
vse_eldorado3.position.set(-10.38, 1, 0.55)
vse_eldorado3.scale.set(5.65, 2, 1.6)
vse.add(vse_eldorado3)
// Мебель-лэнд
const vse_mebel_lend = new THREE.Mesh(geometry, mat_vse)
vse_mebel_lend.position.set(18.38, 1, -29.73)
vse_mebel_lend.scale.set(20.4, 2, 6.66)
vse.add(vse_mebel_lend)
const vse_mebel_lend1 = new THREE.Mesh(geometry, mat_vse)
vse_mebel_lend1.position.set(20.9, 1, -24.97)
vse_mebel_lend1.scale.set(15.36, 2, 3.1)
vse.add(vse_mebel_lend1)
const vse_mebel_lend2 = new THREE.Mesh(geometry, mat_vse)
vse_mebel_lend2.position.set(32.41, 1, -31.7)
vse_mebel_lend2.scale.set(24.54, 2, 8.9)
vse.add(vse_mebel_lend2)
const vse_mebel_lend3 = new THREE.Mesh(geometry, mat_vse)
vse_mebel_lend3.position.set(35.32, 1, -25.62)
vse_mebel_lend3.scale.set(7, 2, 4.46)
vse.add(vse_mebel_lend3)
// Скалалэнд
const vse_skalalend = new THREE.Mesh(geometry, mat_vse)
vse_skalalend.position.set(-19.47, 1, -30.08)
vse_skalalend.scale.set(12.92, 2, 6.63)
vse.add(vse_skalalend)
const vse_skalalend1 = new THREE.Mesh(geometry, mat_vse)
vse_skalalend1.position.set(-17.35, 1, -25.275)
vse_skalalend1.scale.set(8.7, 2, 3.9)
vse.add(vse_skalalend1)
const vse_skalalend2 = new THREE.Mesh(geometry, mat_vse)
vse_skalalend2.position.set(-23.72, 1, -26.14)
vse_skalalend2.scale.set(4.4, 2, 3.46)
vse.add(vse_skalalend2)
const vse_skalalend3 = new THREE.Mesh(geometry, mat_vse)
vse_skalalend3.position.set(-23.487, 1, -25.08)
vse_skalalend3.scale.set(4.355, 2, 2.5)
vse_skalalend3.rotation.y = Math.PI/1.088
vse.add(vse_skalalend3)
// модельная школа Индиго
const vse_indigo = new THREE.Mesh(geometry, mat_vse)
vse_indigo.position.set(-10.54, 1, -28.35)
vse_indigo.scale.set(4.5, 2, 10.14)
vse.add(vse_indigo)
// Warpoint
const vse_warpoint = new THREE.Mesh(geometry, mat_vse)
vse_warpoint.position.set(-29.67, 1, -5.22)
vse_warpoint.scale.set(7.46, 2, 6.55)
vse.add(vse_warpoint)
const vse_warpoint1 = new THREE.Mesh(geometry, mat_vse)
vse_warpoint1.position.set(-28.06, 1, -12.51)
vse_warpoint1.scale.set(4.21, 2, 8.4)
vse.add(vse_warpoint1)
const vse_warpoint2 = new THREE.Mesh(geometry, mat_vse)
vse_warpoint2.position.set(-24.95, 1, -15.75)
vse_warpoint2.scale.set(2.09, 2, 8.73)
vse.add(vse_warpoint2)
const vse_warpoint3 = new THREE.Mesh(geometry, mat_vse)
vse_warpoint3.position.set(-33.33, 1, -7.69)
vse_warpoint3.scale.set(2.6, 2, 1.6)
vse.add(vse_warpoint3)
const vse_warpoint4 = new THREE.Mesh(geometry5, mat_vse)
vse_warpoint4.position.set(-28.079, 1, -18.412)
vse_warpoint4.scale.set(2.95, 1.732, 3.62)
vse_warpoint4.rotation.y = Math.PI/2
vse.add(vse_warpoint4)
const vse_warpoint5 = new THREE.Mesh(geometry, mat_vse)
vse_warpoint5.position.set(-33.132, 1, -6.618)
vse_warpoint5.scale.set(2.3, 2, 2)
vse_warpoint5.rotation.y = Math.PI/1.4
vse.add(vse_warpoint5)
// Лапоток
const vse_lapotok = new THREE.Mesh(geometry, mat_vse)
vse_lapotok.position.set(52.52, 1, -16.05)
vse_lapotok.scale.set(3, 2, 8.1)
vse.add(vse_lapotok)
const vse_lapotok1 = new THREE.Mesh(geometry, mat_vse)
vse_lapotok1.position.set(54.76, 1, -14.43)
vse_lapotok1.scale.set(1.66, 2, 4.86)
vse.add(vse_lapotok1)
// Best Shoes
const vse_best_shoes = new THREE.Mesh(geometry, mat_vse)
vse_best_shoes.position.set(46.76, 1, -17.03)
vse_best_shoes.scale.set(2.44, 2, 6.14)
vse.add(vse_best_shoes)
// Пусто София 2
const vse_sofiya_2 = new THREE.Mesh(geometry, mat_pusto)
vse_sofiya_2.position.set(43.5, 1, -19.36)
vse_sofiya_2.scale.set(3.92, 2, 1.48)
vse.add(vse_sofiya_2)
const vse_sofiya_21 = new THREE.Mesh(geometry, mat_pusto)
vse_sofiya_21.position.set(44.29, 1, -18.07)
vse_sofiya_21.scale.set(2.34, 2, 4.06)
vse.add(vse_sofiya_21)
const vse_sofiya_22 = new THREE.Mesh(geometry5, mat_pusto)
vse_sofiya_22.position.set(42.33, 1, -17.331)
vse_sofiya_22.scale.set(-1.368, 1.732, -2.234)
vse.add(vse_sofiya_22)
// Диана
const vse_diana = new THREE.Mesh(geometry, mat_vse)
vse_diana.position.set(44.65, 1, -14.96)
vse_diana.scale.set(1.62, 2, 2)
vse.add(vse_diana)
const vse_diana1 = new THREE.Mesh(geometry5, mat_vse)
vse_diana1.position.set(43.5, 1, -14.96)
vse_diana1.scale.set(-0.589, 1.732, -1.732)
vse.add(vse_diana1)
// Senator
const vse_senator = new THREE.Mesh(geometry, mat_vse)
vse_senator.position.set(47.64, 1, -12.95)
vse_senator.scale.set(6.6, 2, 1.9)
vse.add(vse_senator)
const vse_senator1 = new THREE.Mesh(geometry5, mat_vse)
vse_senator1.position.set(44.1, 1, -12.95)
vse_senator1.scale.set(-0.416, 1.732, -1.645)
vse.add(vse_senator1)
// Mustang
const vse_mustang = new THREE.Mesh(geometry, mat_vse)
vse_mustang.position.set(47.93, 1, -1.22)
vse_mustang.scale.set(6.16, 2, 4.72)
vse.add(vse_mustang)
const vse_mustang1 = new THREE.Mesh(geometry5, mat_vse)
vse_mustang1.position.set(44.625, 1, -1.22)
vse_mustang1.scale.set(-0.45, 1.732, 4.088)
vse.add(vse_mustang1)
// Lacarino Woman
const vse_lacarino_woman = new THREE.Mesh(geometry, mat_vse)
vse_lacarino_woman.position.set(45.88, 1, 2.76)
vse_lacarino_woman.scale.set(3.06, 2, 3.1)
vse.add(vse_lacarino_woman)
const vse_lacarino_woman1 = new THREE.Mesh(geometry5, mat_vse)
vse_lacarino_woman1.position.set(43.91, 1, 2.76)
vse_lacarino_woman1.scale.set(-0.762, 1.732, 2.685)
vse.add(vse_lacarino_woman1)
// Lacarino
const vse_lacarino = new THREE.Mesh(geometry, mat_vse)
vse_lacarino.position.set(45.42, 1, 5.79)
vse_lacarino.scale.set(3.98, 2, 2.8)
vse.add(vse_lacarino)
const vse_lacarino1 = new THREE.Mesh(geometry5, mat_vse)
vse_lacarino1.position.set(42.82, 1, 5.79)
vse_lacarino1.scale.set(-1.057, 1.732, 2.425)
vse.add(vse_lacarino1)
// Sunlight
const vse_sunlight = new THREE.Mesh(geometry, mat_vse)
vse_sunlight.position.set(44.81, 1, 8.78)
vse_sunlight.scale.set(5.2, 2, 3.02)
vse.add(vse_sunlight)
const vse_sunlight1 = new THREE.Mesh(geometry, mat_vse)
vse_sunlight1.position.set(44.27, 1, 9.51)
vse_sunlight1.scale.set(6.28, 2, 1.56)
vse.add(vse_sunlight1)
const vse_sunlight2 = new THREE.Mesh(geometry5, mat_vse)
vse_sunlight2.position.set(41.67, 1, 8)
vse_sunlight2.scale.set(-0.935, 1.732, 1.264)
vse.add(vse_sunlight2)
// Пусто Модница
const vse_modnica = new THREE.Mesh(geometry, mat_pusto)
vse_modnica.position.set(56.44, 1, -18.5)
vse_modnica.scale.set(1.53, 2, 3.19)
vse.add(vse_modnica)
// Кожанный стиль
const vse_kogan_stil = new THREE.Mesh(geometry, mat_vse)
vse_kogan_stil.position.set(60.44, 1, -18.68)
vse_kogan_stil.scale.set(1.52, 2, 2.8)
vse.add(vse_kogan_stil)
const vse_kogan_stil1 = new THREE.Mesh(geometry, mat_vse)
vse_kogan_stil1.position.set(60.88, 1, -17.923)
vse_kogan_stil1.scale.set(2.4, 2, 1.34)
vse.add(vse_kogan_stil1)
const vse_kogan_stil2 = new THREE.Mesh(geometry5, mat_vse)
vse_kogan_stil2.position.set(61.64, 1, -19.32)
vse_kogan_stil2.scale.set(0.768, 1.732, 1.264)
vse.add(vse_kogan_stil2)
// AVVA
const vse_avva_ = new THREE.Mesh(geometry, mat_vse)
vse_avva_.position.set(60.88, 1, -14.6)
vse_avva_.scale.set(2.4, 2, 5.16)
vse.add(vse_avva_)
const vse_avva_1 = new THREE.Mesh(geometry, mat_vse)
vse_avva_1.position.set(58.89, 1, -12.87)
vse_avva_1.scale.set(6.38, 2, 1.72)
vse.add(vse_avva_1)
// Oodji
const vse_oodji = new THREE.Mesh(geometry, mat_vse)
vse_oodji.position.set(56.55, 1, -10.23)
vse_oodji.scale.set(11.04, 2, 3.4)
vse.add(vse_oodji)
const vse_oodji1 = new THREE.Mesh(geometry, mat_vse)
vse_oodji1.position.set(58.94, 1, -9.13)
vse_oodji1.scale.set(6.3, 2, 5.6)
vse.add(vse_oodji1)
const vse_oodji2 = new THREE.Mesh(geometry, mat_vse)
vse_oodji2.position.set(58.13, 1, -4.99)
vse_oodji2.scale.set(4.68, 2, 2.68)
vse.add(vse_oodji2)
const vse_oodji3 = new THREE.Mesh(geometry5, mat_vse)
vse_oodji3.position.set(61.24, 1, -5.53)
vse_oodji3.scale.set(1.472, 1.732, -1.386)
vse.add(vse_oodji3)
const vse_oodji4 = new THREE.Mesh(geometry5, mat_vse)
vse_oodji4.position.set(60.95, 1, -5.33)
vse_oodji4.scale.set(0.9, 1.732, -2.321)
vse.add(vse_oodji4)
// Пусто kasar
const vse_kasar = new THREE.Mesh(geometry, mat_pusto)
vse_kasar.position.set(56.58, 1, 0.11)
vse_kasar.scale.set(11, 2, 2.04)
vse.add(vse_kasar)
const vse_kasar1 = new THREE.Mesh(geometry, mat_pusto)
vse_kasar1.position.set(55.78, 1, -1.25)
vse_kasar1.scale.set(9.4, 2, 4.68)
vse.add(vse_kasar1)
const vse_kasar2 = new THREE.Mesh(geometry5, mat_pusto)
vse_kasar2.position.set(61.28, 1, -1.31)
vse_kasar2.scale.set(1.386, 1.732, 0.693)
vse.add(vse_kasar2)
const vse_kasar3 = new THREE.Mesh(geometry5, mat_pusto)
vse_kasar3.position.set(61, 1, -1.8)
vse_kasar3.scale.set(1.2, 1.732, 2.026)
vse.add(vse_kasar3)
// Совёнок
const vse_sovenok = new THREE.Mesh(geometry, mat_vse)
vse_sovenok.position.set(59.12, 1, 2.51)
vse_sovenok.scale.set(5.93, 2, 2.68)
vse.add(vse_sovenok)
// Стильнные шторы
const vse_stil_shtory = new THREE.Mesh(geometry, mat_vse)
vse_stil_shtory.position.set(60.62, 1, 4.91)
vse_stil_shtory.scale.set(2.93, 2, 2)
vse.add(vse_stil_shtory)
// Modnyi
const vse_modnyi = new THREE.Mesh(geometry, mat_vse)
vse_modnyi.position.set(60.62, 1, 6.93)
vse_modnyi.scale.set(2.93, 2, 1.9)
vse.add(vse_modnyi)
// Все оптика
const vse_avva = new THREE.Mesh(geometry, mat_vse)
vse_avva.position.set(60.62, 1, 8.76)
vse_avva.scale.set(2.93, 2, 1.66)
vse.add(vse_avva)
const vse_avva1 = new THREE.Mesh(geometry, mat_vse)
vse_avva1.position.set(60.107, 1, 9.76)
vse_avva1.scale.set(1.904, 2, 0.98)
vse.add(vse_avva1)
const vse_avva2 = new THREE.Mesh(geometry, mat_vse)
vse_avva2.position.set(61.243, 1, 9.407)
vse_avva2.scale.set(1.22, 2, 1.22)
vse_avva2.rotation.y = Math.PI/1.465
vse.add(vse_avva2)
// Ninalina
const vse_ninalina = new THREE.Mesh(geometry, mat_vse)
vse_ninalina.position.set(66.89, 1, 8.966)
vse_ninalina.scale.set(3.52, 2, 1.282)
vse.add(vse_ninalina)
const vse_ninalina1 = new THREE.Mesh(geometry, mat_vse)
vse_ninalina1.position.set(67.395, 1, 9.87)
vse_ninalina1.scale.set(2.505, 2, 0.76)
vse.add(vse_ninalina1)
const vse_ninalina2 = new THREE.Mesh(geometry, mat_vse)
vse_ninalina2.position.set(65.958, 1, 9.422)
vse_ninalina2.scale.set(1.2, 2, 1.2)
vse_ninalina2.rotation.y = Math.PI/1.22
vse.add(vse_ninalina2)
// Бывший Monro теперь Francesco Donni
const vse_monro = new THREE.Mesh(geometry, mat_vse)
vse_monro.position.set(49.25, 1, 4.36)
vse_monro.scale.set(3.52, 2, 6.28)
vse.add(vse_monro)
const vse_monro1 = new THREE.Mesh(geometry, mat_vse)
vse_monro1.position.set(48.54, 1, 8.79)
vse_monro1.scale.set(2.1, 2, 3)
vse.add(vse_monro1)
// Tobacconist
const vse_tobacconist = new THREE.Mesh(geometry, mat_vse)
vse_tobacconist.position.set(50.34, 1, 8.94)
vse_tobacconist.scale.set(1.31, 2, 2.7)
vse.add(vse_tobacconist)
// Valencia
const vse_valencia = new THREE.Mesh(geometry, mat_vse)
vse_valencia.position.set(55.97, 1, 8.41)
vse_valencia.scale.set(2.02, 2, 3.7)
vse.add(vse_valencia)
// Berkonty
const vse_berkonty = new THREE.Mesh(geometry, mat_vse)
vse_berkonty.position.set(53.57, 1, 3.84)
vse_berkonty.scale.set(4.99, 2, 5.26)
vse.add(vse_berkonty)
const vse_berkonty1 = new THREE.Mesh(geometry, mat_vse)
vse_berkonty1.position.set(52.98, 1, 8.34)
vse_berkonty1.scale.set(3.81, 2, 3.88)
vse.add(vse_berkonty1)
// Elis
const vse_elis = new THREE.Mesh(geometry, mat_pusto)
vse_elis.position.set(57.62, 1, 5.19)
vse_elis.scale.set(2.96, 2, 2.57)
vse.add(vse_elis)
const vse_elis1 = new THREE.Mesh(geometry, mat_pusto)
vse_elis1.position.set(58.07, 1, 8.28)
vse_elis1.scale.set(2.06, 2, 3.94)
vse.add(vse_elis1)
// Das Gut
const vse_das_gut = new THREE.Mesh(geometry, mat_vse)
vse_das_gut.position.set(71.63, 1, 6)
vse_das_gut.scale.set(3.8, 2, 4.45)
vse.add(vse_das_gut)
const vse_das_gut1 = new THREE.Mesh(geometry, mat_vse)
vse_das_gut1.position.set(72.12, 1, 9.13)
vse_das_gut1.scale.set(2.82, 2, 2.2)
vse.add(vse_das_gut1)


// Детский мир
const vse_detskiy_mir = new THREE.Mesh(geometry, mat_vse)
vse_detskiy_mir.position.set(-83.76, 1, 11.47)
vse_detskiy_mir.scale.set(10.96, 2, 8.6)
vse.add(vse_detskiy_mir)
const vse_detskiy_mir1 = new THREE.Mesh(geometry, mat_vse)
vse_detskiy_mir1.position.set(-81.45, 1, 17.69)
vse_detskiy_mir1.scale.set(6.34, 2, 21.04)
vse.add(vse_detskiy_mir1)
const vse_detskiy_mir2 = new THREE.Mesh(geometry, mat_vse)
vse_detskiy_mir2.position.set(-80.8, 1, 28.57)
vse_detskiy_mir2.scale.set(5.04, 2, 0.72)
vse.add(vse_detskiy_mir2)
const vse_detskiy_mir3 = new THREE.Mesh(geometry5, mat_vse)
vse_detskiy_mir3.position.set(-83.97, 1, 28.57)
vse_detskiy_mir3.scale.set(-1.126, 1.732, -0.624)
vse.add(vse_detskiy_mir3)
const vse_detskiy_mir4 = new THREE.Mesh(geometry5, mat_vse)
vse_detskiy_mir4.position.set(-79.54, 1, 29.13)
vse_detskiy_mir4.scale.set(2.1825, 1.732, -0.347)
vse.add(vse_detskiy_mir4)
const vse_detskiy_mir5 = new THREE.Mesh(geometry5, mat_vse)
vse_detskiy_mir5.position.set(-82.06, 1, 29.13)
vse_detskiy_mir5.scale.set(-2.1825, 1.732, -0.347)
vse.add(vse_detskiy_mir5)
// Пусто 117
const pusto117 = new THREE.Mesh(geometry, mat_pusto)
pusto117.position.set(-86.98, 1, 19.88)
pusto117.scale.set(4.52, 2, 8.06)
vse.add(pusto117)
const pusto117_1 = new THREE.Mesh(geometry, mat_pusto)
pusto117_1.position.set(-86.52, 1, 24.55)
pusto117_1.scale.set(3.6, 2, 1.28)
vse.add(pusto117_1)
const pusto117_2 = new THREE.Mesh(geometry, mat_pusto)
pusto117_2.position.set(-85.33, 1, 25.67)
pusto117_2.scale.set(1.22, 2, 3.52)
vse.add(pusto117_2)
const pusto117_3 = new THREE.Mesh(geometry5, mat_pusto)
pusto117_3.position.set(-85.33, 1, 27.78)
pusto117_3.scale.set(-1.057, 1.732, -0.6065)
vse.add(pusto117_3)
const pusto117_4 = new THREE.Mesh(geometry5, mat_pusto)
pusto117_4.position.set(-88.78, 1, 24.55)
pusto117_4.scale.set(-0.797, 1.732, -1.109)
vse.add(pusto117_4)
const pusto117_5 = new THREE.Mesh(geometry5, mat_pusto)
pusto117_5.position.set(-87.13, 1, 26.31)
pusto117_5.scale.set(-2.061, 1.732, -1.94)
vse.add(pusto117_5)
// Пусто 118
const pusto118 = new THREE.Mesh(geometry, mat_pusto)
pusto118.position.set(-89.85, 1, 20.4)
pusto118.scale.set(1.08, 2, 3.66)
vse.add(pusto118)
const pusto118_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto118_1.position.set(-89.85, 1, 23.04)
pusto118_1.scale.set(-0.935, 1.732, -1.403)
vse.add(pusto118_1)
const pusto118_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto118_2.position.set(-91.34, 1, 20.4)
pusto118_2.scale.set(-1.645, 1.732, -3.17)
vse.add(pusto118_2)
// Пусто 119
const pusto119 = new THREE.Mesh(geometry, mat_pusto)
pusto119.position.set(-90.8, 1, 17.2)
pusto119.scale.set(2.98, 2, 2.7)
vse.add(pusto119)
const pusto119_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto119_1.position.set(-92.77, 1, 17.2)
pusto119_1.scale.set(-0.831, 1.732, -2.338)
vse.add(pusto119_1)
// Пусто 120
const pusto120 = new THREE.Mesh(geometry, mat_pusto)
pusto120.position.set(-91.31, 1, 14.01)
pusto120.scale.set(4, 2, 3.52)
vse.add(pusto120)
const pusto120_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto120_1.position.set(-93.89, 1, 14.01)
pusto120_1.scale.set(-1.005, 1.732, -3.048)
vse.add(pusto120_1)
// Пусто 121
const pusto121 = new THREE.Mesh(geometry, mat_pusto)
pusto121.position.set(-90.36, 1, 10.36)
pusto121.scale.set(2.1, 2, 3.64)
vse.add(pusto121)
const pusto121_1 = new THREE.Mesh(geometry, mat_pusto)
pusto121_1.position.set(-91.91, 1, 10.83)
pusto121_1.scale.set(5.2, 2, 2.7)
vse.add(pusto121_1)
const pusto121_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto121_2.position.set(-94.91, 1, 10.83)
pusto121_2.scale.set(-0.693, 1.732, -2.338)
vse.add(pusto121_2)
// Пусто 122
const pusto122 = new THREE.Mesh(geometry, mat_pusto)
pusto122.position.set(-93.41, 1, 8.33)
pusto122.scale.set(3.84, 2, 2.14)
vse.add(pusto122)
const pusto122_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto122_1.position.set(-95.55, 1, 8.33)
pusto122_1.scale.set(-0.381, 1.732, -1.853)
vse.add(pusto122_1)
// Пусто 123
const pusto123 = new THREE.Mesh(geometry, mat_pusto)
pusto123.position.set(-93.14, 1, 6.01)
pusto123.scale.set(3.3, 2, 2.36)
vse.add(pusto123)
const pusto123_1 = new THREE.Mesh(geometry, mat_pusto)
pusto123_1.position.set(-93.64, 1, 6.54)
pusto123_1.scale.set(4.3, 2, 1.3)
vse.add(pusto123_1)
const pusto123_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto123_2.position.set(-95.93, 1, 6.54)
pusto123_2.scale.set(-0.2425, 1.732, -1.126)
vse.add(pusto123_2)
const pusto123_3 = new THREE.Mesh(geometry5, mat_pusto)
pusto123_3.position.set(-95.43, 1, 5.36)
pusto123_3.scale.set(-1.108, 1.732, 0.918)
vse.add(pusto123_3)
// Пусто 124
const pusto124 = new THREE.Mesh(geometry, mat_pusto)
pusto124.position.set(-90.36, 1, 6.65)
pusto124.scale.set(2.1, 2, 3.64)
vse.add(pusto124)
const pusto124_1 = new THREE.Mesh(geometry, mat_pusto)
pusto124_1.position.set(-82.14, 1, 5.97)
pusto124_1.scale.set(18.54, 2, 2.28)
vse.add(pusto124_1)
// Padel Place теннисный корт Пусто 125
const pusto125 = new THREE.Mesh(geometry, mat_vse)
pusto125.position.set(-77.15, 1, 17.44)
pusto125.scale.set(2.12, 2, 20.54)
vse.add(pusto125)
const pusto125_1 = new THREE.Mesh(geometry5, mat_vse)
pusto125_1.position.set(-77.15, 1, 28.31)
pusto125_1.scale.set(1.836, 1.732, -1.04)
vse.add(pusto125_1)
const pusto125_2 = new THREE.Mesh(geometry, mat_vse)
pusto125_2.position.set(-73.35, 1, 14.75)
pusto125_2.scale.set(5.48, 2, 12.64)
vse.add(pusto125_2)
const pusto125_3 = new THREE.Mesh(geometry, mat_vse)
pusto125_3.position.set(-74.75, 1, 16.91)
pusto125_3.scale.set(2.68, 2, 16.96)
vse.add(pusto125_3)
const pusto125_4 = new THREE.Mesh(geometry5, mat_vse)
pusto125_4.position.set(-74.75, 1, 26.55)
pusto125_4.scale.set(2.321, 1.732, -2.01)
vse.add(pusto125_4)
const pusto125_5 = new THREE.Mesh(geometry5, mat_vse)
pusto125_5.position.set(-72.01, 1, 23.23)
pusto125_5.scale.set(2.425, 1.732, -3.7414)
vse.add(pusto125_5)
const pusto125_6 = new THREE.Mesh(geometry, mat_vse)
pusto125_6.position.set(-69.88, 1, 14.98)
pusto125_6.scale.set(1.46, 2, -6.1)
vse.add(pusto125_6)
const pusto125_7 = new THREE.Mesh(geometry5, mat_vse)
pusto125_7.position.set(-69.88, 1, 19.55)
pusto125_7.scale.set(1.264, 1.732, -2.633)
vse.add(pusto125_7)
const pusto125_8 = new THREE.Mesh(geometry5, mat_vse)
pusto125_8.position.set(-68.095, 1, 14.98)
pusto125_8.scale.set(1.827, 1.732, -5.283)
vse.add(pusto125_8)

const pusto126 = new THREE.Mesh(geometry, mat_vse)
pusto126.position.set(-68.76, 1, 10.14)
pusto126.scale.set(3.5, 2, 3.42)
vse.add(pusto126)
const pusto126_1 = new THREE.Mesh(geometry5, mat_vse)
pusto126_1.position.set(-66.51, 1, 10.14)
pusto126_1.scale.set(0.866, 1.732, -2.962)
vse.add(pusto126_1)

const pusto124_2 = new THREE.Mesh(geometry, mat_vse)
pusto124_2.position.set(-72.15, 1, 9.6)
pusto124_2.scale.set(10.18, 2, 4.9)
vse.add(pusto124_2)
// Пусто 127
const pusto127 = new THREE.Mesh(geometry, mat_vse)
pusto127.position.set(-69.57, 1, 6.69)
pusto127.scale.set(6.4, 2, 3.72)
vse.add(pusto127)
const pusto127_1 = new THREE.Mesh(geometry, mat_vse)
pusto127_1.position.set(-66.19, 1, 7.15)
pusto127_1.scale.set(0.36, 2, 2.6)
vse.add(pusto127_1)
const pusto127_2 = new THREE.Mesh(geometry5, mat_vse)
pusto127_2.position.set(-65.73, 1, 7.1)
pusto127_2.scale.set(0.485, 1.732, -2.165)
vse.add(pusto127_2)
const pusto127_3 = new THREE.Mesh(geometry5, mat_vse)
pusto127_3.position.set(-65.91, 1, 5.34)
pusto127_3.scale.set(0.797, 1.732, 0.883)
vse.add(pusto127_3)


//  Хорошие новости
const vse_horoshie_novosti = new THREE.Mesh(geometry, mat_vse)
vse_horoshie_novosti.position.set(-80.15, 1, 31.46)
vse_horoshie_novosti.scale.set(2.58, 2, 1.32)
vse.add(vse_horoshie_novosti)
// Церковная лавка
const vse_lavka = new THREE.Mesh(geometry, mat_vse)
vse_lavka.position.set(-83.15, 1, 31.46)
vse_lavka.scale.set(2.58, 2, 1.32)
vse.add(vse_lavka)
// Пусто 48
const pusto48 = new THREE.Mesh(geometry, mat_pusto)
pusto48.position.set(-81.72, 1, 33.77)
pusto48.scale.set(5.72, 2, 3.16)
vse.add(pusto48)
// Фермерские продукты
const vse_ferma = new THREE.Mesh(geometry, mat_vse)
vse_ferma.position.set(-82.86, 1, 44)
vse_ferma.scale.set(3, 2, 6)
vse.add(vse_ferma)
// Пусто 49
const pusto49 = new THREE.Mesh(geometry, mat_pusto)
pusto49.position.set(-91.29, 1, 33.77)
pusto49.scale.set(13.28, 2, 3.16)
vse.add(pusto49)
// Пусто 50
const pusto50 = new THREE.Mesh(geometry, mat_pusto)
pusto50.position.set(-103.5, 1, 30.32)
pusto50.scale.set(10.98, 2, 10.06)
vse.add(pusto50)
// Bazar
const vse_bazar = new THREE.Mesh(geometry, mat_vse)
vse_bazar.position.set(-94.61, 1, 28.71)
vse_bazar.scale.set(6.66, 2, 6.84)
vse.add(vse_bazar)
const vse_bazar1 = new THREE.Mesh(geometry, mat_vse)
vse_bazar1.position.set(-92.5, 1, 31.13)
vse_bazar1.scale.set(10.88, 2, 2)
vse.add(vse_bazar1)
const vse_bazar2 = new THREE.Mesh(geometry5, mat_vse)
vse_bazar2.position.set(-89.17, 1, 27.71)
vse_bazar2.scale.set(3.655, 1.732, 4.192)
vse.add(vse_bazar2)
// Пусто 51
// const pusto51 = new THREE.Mesh(geometry, mat_pusto)
// pusto51.position.set(-101.08, 1, 24.13)
// pusto51.scale.set(15.82, 2, 2.16)
// vse.add(pusto51)

// Туристическое агентство
const vse_turagent = new THREE.Mesh(geometry, mat_vse)
vse_turagent.position.set(-85.98, 1, 31.94)
vse_turagent.scale.set(2, 2, 0.38)
vse.add(vse_turagent)
const vse_turagent_1 = new THREE.Mesh(geometry5, mat_vse)
vse_turagent_1.position.set(-85.98, 1, 30.98)
vse_turagent_1.scale.set(1.732, 1.732, 1.334)
vse.add(vse_turagent_1)
// Пусто 112
const pusto112 = new THREE.Mesh(geometry, mat_pusto)
pusto112.position.set(-107.71, 1, 18.4)
pusto112.scale.set(2.56, 2, 8.959)
vse.add(pusto112)
const pusto112_1 = new THREE.Mesh(geometry, mat_pusto)
pusto112_1.position.set(-101.11, 1, 19.62)
pusto112_1.scale.set(10.64, 2, 6.52)
vse.add(pusto112_1)
const pusto112_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto112_2.position.set(-94.47, 1, 20.705)
pusto112_2.scale.set(2.2865, 1.732, 3.7673)
vse.add(pusto112_2)
const pusto112_3 = new THREE.Mesh(geometry5, mat_pusto)
pusto112_3.position.set(-94.91, 1, 19.62)
pusto112_3.scale.set(1.524, 1.732, 5.644)
vse.add(pusto112_3)
const pusto112_4 = new THREE.Mesh(geometry5, mat_pusto)
pusto112_4.position.set(-94.6, 1, 20)
pusto112_4.scale.set(2.1, 1.732, 4.888)
vse.add(pusto112_4)


// Пусто 113
const pusto113 = new THREE.Mesh(geometry, mat_pusto)
pusto113.position.set(-103.1, 1, 13.56)
pusto113.scale.set(2.02, 2, 3.56)
vse.add(pusto113)
// Пусто 114
const pusto114 = new THREE.Mesh(geometry, mat_pusto)
pusto114.position.set(-101.04, 1, 13.56)
pusto114.scale.set(1.98, 2, 3.56)
vse.add(pusto114)
// Пусто 115
const pusto115 = new THREE.Mesh(geometry, mat_pusto)
pusto115.position.set(-99.02, 1, 13.56)
pusto115.scale.set(1.96, 2, 3.56)
vse.add(pusto115)
// Пусто 116
const pusto116 = new THREE.Mesh(geometry, mat_pusto)
pusto116.position.set(-97.44, 1, 13.56)
pusto116.scale.set(1.06, 2, 3.56)
vse.add(pusto116)
const pusto116_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto116_1.position.set(-96.45, 1, 13.56)
pusto116_1.scale.set(0.797, 1.732, 3.083)
vse.add(pusto116_1)


// Пусто 128
const pusto128 = new THREE.Mesh(geometry, mat_pusto)
pusto128.position.set(-107.68, 1, 9.81)
pusto128.scale.set(2.52, 2, 4.54)
vse.add(pusto128)
// Пусто 129
const pusto129 = new THREE.Mesh(geometry, mat_pusto)
pusto129.position.set(-107.68, 1, 5.27)
pusto129.scale.set(2.52, 2, 4.38)
vse.add(pusto129)
// Пусто 130
const pusto130 = new THREE.Mesh(geometry, mat_pusto)
pusto130.position.set(-107.68, 1, 1.98)
pusto130.scale.set(2.52, 2, 2.04)
vse.add(pusto130)
// Пусто 131
const pusto131 = new THREE.Mesh(geometry, mat_pusto)
pusto131.position.set(-107.68, 1, 0.01)
pusto131.scale.set(2.52, 2, 1.74)
vse.add(pusto131)
// Пусто 132
const pusto132 = new THREE.Mesh(geometry, mat_pusto)
pusto132.position.set(-107.68, 1, -1.75)
pusto132.scale.set(2.52, 2, 1.62)
vse.add(pusto132)
// Пусто 133
const pusto133 = new THREE.Mesh(geometry, mat_pusto)
pusto133.position.set(-107.68, 1, -3.51)
pusto133.scale.set(2.52, 2, 1.74)
vse.add(pusto133)


// Пусто 134
const pusto134 = new THREE.Mesh(geometry, mat_pusto)
pusto134.position.set(-107.54, 1, -10.6)
pusto134.scale.set(2.8, 2, 3.64)
vse.add(pusto134)
// Пусто 135
const pusto135 = new THREE.Mesh(geometry, mat_pusto)
pusto135.position.set(-104.81, 1, -8.85)
pusto135.scale.set(2.52, 2, 7.14)
vse.add(pusto135)
const pusto135_1 = new THREE.Mesh(geometry, mat_pusto)
pusto135_1.position.set(-107.5, 1, -6.99)
pusto135_1.scale.set(2.86, 2, 3.42)
vse.add(pusto135_1)
// Пусто 136
const pusto136 = new THREE.Mesh(geometry, mat_pusto)
pusto136.position.set(-101.3, 1, -7.73)
pusto136.scale.set(4.36, 2, 4.9)
vse.add(pusto136)
const pusto136_1 = new THREE.Mesh(geometry, mat_pusto)
pusto136_1.position.set(-103.16, 1, -8.85)
pusto136_1.scale.set(0.641, 2, 7.12)
vse.add(pusto136_1)
const pusto136_2 = new THREE.Mesh(geometry3, mat_pusto)
pusto136_2.position.set(-102.839, 1, -10.18)
pusto136_2.scale.set(2.24, 2, 3.72)
pusto136_2.rotation.y = Math.PI/2
vse.add(pusto136_2)


// Пусто 137
const pusto137 = new THREE.Mesh(geometry, mat_pusto)
pusto137.position.set(-102.69, 1, -25.65)
pusto137.scale.set(12.5, 2, 20.74)
vse.add(pusto137)
// Пусто 138
const pusto138 = new THREE.Mesh(geometry, mat_pusto)
pusto138.position.set(-82.64, 1, -25.65)
pusto138.scale.set(27.42, 2, 20.74)
vse.add(pusto138)
// Пусто 139
const pusto139 = new THREE.Mesh(geometry, mat_pusto)
pusto139.position.set(-51.75, 1, -31.55)
pusto139.scale.set(34.16, 2, 8.94)
vse.add(pusto139)
const pusto139_1 = new THREE.Mesh(geometry, mat_pusto)
pusto139_1.position.set(-36.02, 1, -30.6)
pusto139_1.scale.set(2.7, 2, 10.64)
vse.add(pusto139_1)
const pusto139_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto139_2.position.set(-40.02, 1, -26.18)
pusto139_2.scale.set(-4.59, 1.732, -1.559)
// pusto139_2.scale.set(-5.3, 2, -1.8)
vse.add(pusto139_2)
// Пусто 140
const pusto140 = new THREE.Mesh(geometry, mat_pusto)
pusto140.position.set(-32.59, 1, -30.65)
pusto140.scale.set(4, 2, 10.74)
vse.add(pusto140)
const pusto140_1 = new THREE.Mesh(geometry, mat_pusto)
pusto140_1.position.set(-30.74, 1, -29.26)
pusto140_1.scale.set(7.7, 2, 7.96)
vse.add(pusto140_1)
const pusto140_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto140_2.position.set(-28.31, 1, -24.89)
pusto140_2.scale.set(-2.459, 1.732, -0.675)
//pusto140_2.scale.set(-2.84, 2, -0.78)
vse.add(pusto140_2)
// Пусто 141
const pusto141 = new THREE.Mesh(geometry, mat_pusto)
pusto141.position.set(-18.98, 1, -35.11)
pusto141.scale.set(23.08, 2, 1.84)
vse.add(pusto141)


// Пусто 152
const pusto152 = new THREE.Mesh(geometry, mat_pusto)
pusto152.position.set(-92.34, 1, 0.05)
pusto152.scale.set(2.26, 2, 3.68)
vse.add(pusto152)
// Пусто 153
const pusto153 = new THREE.Mesh(geometry, mat_pusto)
pusto153.position.set(-90.03, 1, 0.05)
pusto153.scale.set(2.2, 2, 3.68)
vse.add(pusto153)
// Пусто 154
const pusto154 = new THREE.Mesh(geometry, mat_pusto)
pusto154.position.set(-87.9, 1, -1.8)
pusto154.scale.set(1.9, 2, 7.38)
vse.add(pusto154)
const pusto154_1 = new THREE.Mesh(geometry, mat_pusto)
pusto154_1.position.set(-89.04, 1, -3.68)
pusto154_1.scale.set(4.18, 2, 3.62)
vse.add(pusto154_1)
// Пусто 155
const pusto155 = new THREE.Mesh(geometry, mat_pusto)
pusto155.position.set(-85.77, 1, 0.05)
pusto155.scale.set(2.2, 2, 3.68)
vse.add(pusto155)
// Пусто 156
const pusto156 = new THREE.Mesh(geometry, mat_pusto)
pusto156.position.set(-83.51, 1, -1.8)
pusto156.scale.set(2.16, 2, 7.38)
vse.add(pusto156)
const pusto156_1 = new THREE.Mesh(geometry, mat_pusto)
pusto156_1.position.set(-84.65, 1, -3.68)
pusto156_1.scale.set(4.44, 2, 3.62)
vse.add(pusto156_1)
// Пусто 157
const pusto157 = new THREE.Mesh(geometry, mat_pusto)
pusto157.position.set(-81.4, 1, -1.8)
pusto157.scale.set(1.9, 2, 7.38)
vse.add(pusto157)
// Пусто 158
const pusto158 = new THREE.Mesh(geometry, mat_pusto)
pusto158.position.set(-79.21, 1, 0.05)
pusto158.scale.set(2.32, 2, 3.68)
vse.add(pusto158)
// Пусто 159
const pusto159 = new THREE.Mesh(geometry, mat_pusto)
pusto159.position.set(-76.96, 1, -1.8)
pusto159.scale.set(2.02, 2, 7.38)
vse.add(pusto159)
const pusto159_1 = new THREE.Mesh(geometry, mat_pusto)
pusto159_1.position.set(-78.16, 1, -3.68)
pusto159_1.scale.set(4.42, 2, 3.62)
vse.add(pusto159_1)
// Пусто 160
const pusto160 = new THREE.Mesh(geometry, mat_pusto)
pusto160.position.set(-74.8, 1, 0.05)
pusto160.scale.set(2.14, 2, 3.68)
vse.add(pusto160)
// Пусто 161
const pusto161 = new THREE.Mesh(geometry, mat_pusto)
pusto161.position.set(-72.54, 1, -1.8)
pusto161.scale.set(2.22, 2, 7.38)
vse.add(pusto161)
const pusto161_1 = new THREE.Mesh(geometry, mat_pusto)
pusto161_1.position.set(-73.65, 1, -3.68)
pusto161_1.scale.set(4.44, 2, 3.62)
vse.add(pusto161_1)
// Пусто 162
const pusto162 = new THREE.Mesh(geometry, mat_pusto)
pusto162.position.set(-70.3, 1, -0.03)
pusto162.scale.set(2.1, 2, 3.84)
vse.add(pusto162)
// Пусто 164
const pusto164 = new THREE.Mesh(geometry, mat_pusto)
pusto164.position.set(-93.69, 1, -3.68)
pusto164.scale.set(4.96, 2, 3.62)
vse.add(pusto164)
// Пусто 165
const pusto165 = new THREE.Mesh(geometry, mat_pusto)
pusto165.position.set(-94.39, 1, 0.05)
pusto165.scale.set(1.68, 2, 3.68)
vse.add(pusto165)
const pusto165_1 = new THREE.Mesh(geometry, mat_pusto)
pusto165_1.position.set(-94.86, 1, -0.49)
pusto165_1.scale.set(2.62, 2, 2.6)
vse.add(pusto165_1)
const pusto165_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto165_2.position.set(-95.7, 1, 1.35)
pusto165_2.scale.set(-0.814, 1.732, -0.9355)
// pusto165_2.scale.set(-0.94, 2, -1.08)
vse.add(pusto165_2)
// Пусто 166
const pusto166 = new THREE.Mesh(geometry, mat_pusto)
pusto166.position.set(-93.38, 1, -7.15)
pusto166.scale.set(4.34, 2, 3.16)
vse.add(pusto166)
const pusto166_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto166_1.position.set(-95.86, 1, -7.15)
pusto166_1.scale.set(-0.537, 1.732, 2.737)
vse.add(pusto166_1)
// Пусто 167
const pusto167 = new THREE.Mesh(geometry, mat_pusto)
pusto167.position.set(-92.51, 1, -10.65)
pusto167.scale.set(2.6, 2, 3.68)
vse.add(pusto167)
const pusto167_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto167_1.position.set(-94.67, 1, -10.65)
pusto167_1.scale.set(-1.49, 1.732, 3.187)
vse.add(pusto167_1)
// Пусто 168
const pusto168 = new THREE.Mesh(geometry, mat_pusto)
pusto168.position.set(-90.03, 1, -10.65)
pusto168.scale.set(2.2, 2, 3.68)
vse.add(pusto168)
// Пусто 169
const pusto169 = new THREE.Mesh(geometry, mat_pusto)
pusto169.position.set(-87.9, 1, -9.03)
pusto169.scale.set(1.9, 2, 6.92)
vse.add(pusto169)
const pusto169_1 = new THREE.Mesh(geometry, mat_pusto)
pusto169_1.position.set(-89.04, 1, -7.15)
pusto169_1.scale.set(4.18, 2, 3.16)
vse.add(pusto169_1)
// Пусто 170
const pusto170 = new THREE.Mesh(geometry, mat_pusto)
pusto170.position.set(-85.77, 1, -10.65)
pusto170.scale.set(2.2, 2, 3.68)
vse.add(pusto170)
// Пусто 171
const pusto171 = new THREE.Mesh(geometry, mat_pusto)
pusto171.position.set(-83.51, 1, -9.03)
pusto171.scale.set(2.16, 2, 6.92)
vse.add(pusto171)
const pusto171_1 = new THREE.Mesh(geometry, mat_pusto)
pusto171_1.position.set(-84.65, 1, -7.15)
pusto171_1.scale.set(4.44, 2, 3.16)
vse.add(pusto171_1)
// Пусто 172
const pusto172 = new THREE.Mesh(geometry, mat_pusto)
pusto172.position.set(-81.4, 1, -9.03)
pusto172.scale.set(1.9, 2, 6.92)
vse.add(pusto172)
// Пусто 173
const pusto173 = new THREE.Mesh(geometry, mat_pusto)
pusto173.position.set(-79.21, 1, -10.65)
pusto173.scale.set(2.32, 2, 3.68)
vse.add(pusto173)
// Пусто 174
const pusto174 = new THREE.Mesh(geometry, mat_pusto)
pusto174.position.set(-76.96, 1, -9.03)
pusto174.scale.set(2.02, 2, 6.92)
vse.add(pusto174)
const pusto174_1 = new THREE.Mesh(geometry, mat_pusto)
pusto174_1.position.set(-78.16, 1, -7.15)
pusto174_1.scale.set(4.42, 2, 3.16)
vse.add(pusto174_1)
// Пусто 175
const pusto175 = new THREE.Mesh(geometry, mat_pusto)
pusto175.position.set(-74.8, 1, -10.65)
pusto175.scale.set(2.14, 2, 3.68)
vse.add(pusto175)
// Пусто 176
const pusto176 = new THREE.Mesh(geometry, mat_pusto)
pusto176.position.set(-72.54, 1, -9.03)
pusto176.scale.set(2.22, 2, 6.92)
vse.add(pusto176)
const pusto176_1 = new THREE.Mesh(geometry, mat_pusto)
pusto176_1.position.set(-73.65, 1, -7.15)
pusto176_1.scale.set(4.44, 2, 3.16)
vse.add(pusto176_1)
// Пусто 177
const pusto177 = new THREE.Mesh(geometry, mat_pusto)
pusto177.position.set(-70.3, 1, -10.56)
pusto177.scale.set(2.1, 2, 3.86)
vse.add(pusto177)
// Пусто 178
const pusto178 = new THREE.Mesh(geometry, mat_pusto)
pusto178.position.set(-70.3, 1, -7.06)
pusto178.scale.set(2.1, 2, 2.98)
vse.add(pusto178)
// Пусто 179
const pusto179 = new THREE.Mesh(geometry, mat_pusto)
pusto179.position.set(-67.67, 1, -7.08)
pusto179.scale.set(3, 2, 2.94)
vse.add(pusto179)
const pusto179_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto179_1.position.set(-65.78, 1, -7.08)
pusto179_1.scale.set(0.675, 1.732, 2.546)
vse.add(pusto179_1)
// Пусто 180
const pusto180 = new THREE.Mesh(geometry, mat_pusto)
pusto180.position.set(-68.49, 1, -10.56)
pusto180.scale.set(1.36, 2, 3.86)
vse.add(pusto180)
const pusto180_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto180_1.position.set(-66.99, 1, -10.56)
pusto180_1.scale.set(1.42, 1.732, 3.343)
vse.add(pusto180_1)
// Пусто 181
const pusto181 = new THREE.Mesh(geometry, mat_pusto)
pusto181.position.set(-68.37, 1, -3.76)
pusto181.scale.set(6, 2, 3.44)
vse.add(pusto181)
const pusto181_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto181_1.position.set(-65.27, 1, -3.76)
pusto181_1.scale.set(0.173, 1.732, 2.979)
vse.add(pusto181_1)
// Пусто 182
const pusto182 = new THREE.Mesh(geometry, mat_pusto)
pusto182.position.set(-67.78, 1, -0.03)
pusto182.scale.set(2.78, 2, 3.84)
vse.add(pusto182)
const pusto182_1 = new THREE.Mesh(geometry, mat_pusto)
pusto182_1.position.set(-67.17, 1, -0.79)
pusto182_1.scale.set(4, 2, 2.32)
vse.add(pusto182_1)
const pusto182_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto182_2.position.set(-65.78, 1, 1.13)
pusto182_2.scale.set(1.057, 1.732, -1.3165)
vse.add(pusto182_2)



// Пустые
// 1 Слева от Саквояж
const pusto1 = new THREE.Mesh(geometry, mat_pusto)
pusto1.position.set(16.72, 1, -17.24)
pusto1.scale.set(2.28, 2, 5.52)
vse.add(pusto1)
// 2
const pusto2 = new THREE.Mesh(geometry, mat_pusto)
pusto2.position.set(13.66, 1, -15.72)
pusto2.scale.set(3.64, 2, 8.56)
vse.add(pusto2)
// 3
const pusto3 = new THREE.Mesh(geometry, mat_pusto)
pusto3.position.set(10.04, 1, -13.49)
pusto3.scale.set(3.4, 2, 13.02)
vse.add(pusto3)
const pusto3_1 = new THREE.Mesh(geometry, mat_pusto)
pusto3_1.position.set(7.09, 1, -12.36)
pusto3_1.scale.set(2.5, 2, 10.76)
vse.add(pusto3_1)
// 4
const pusto4 = new THREE.Mesh(geometry, mat_pusto)
pusto4.position.set(7.02, 1, -18.91)
pusto4.scale.set(2.4, 2, 2.18)
vse.add(pusto4)
// 5
const pusto5 = new THREE.Mesh(geometry, mat_pusto)
pusto5.position.set(3.38, 1, -8.21)
pusto5.scale.set(4.77, 2, 2.46)
vse.add(pusto5)
// 6
const pusto6 = new THREE.Mesh(geometry, mat_pusto)
pusto6.position.set(3.38, 1, -10.74)
pusto6.scale.set(4.77, 2, 2.4)
vse.add(pusto6)
// 7
const pusto7 = new THREE.Mesh(geometry, mat_pusto)
pusto7.position.set(4.94, 1, -6.5)
pusto7.scale.set(7.9, 2, 0.8)
vse.add(pusto7)
const pusto7_1 = new THREE.Mesh(geometry, mat_pusto)
pusto7_1.position.set(5.53, 1, -5.4)
pusto7_1.scale.set(6.72, 2, 3)
vse.add(pusto7_1)
const pusto7_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto7_2.position.set(1.58, 1, -5.51)
pusto7_2.scale.set(-1.022, 1.732, -1.022)
vse.add(pusto7_2)
const pusto7_3 = new THREE.Mesh(geometry5, mat_pusto)
pusto7_3.position.set(1.7, 1, -5.4)
pusto7_3.scale.set(-1, 1.732, -2.5)
vse.add(pusto7_3)
// 8
const pusto8 = new THREE.Mesh(geometry, mat_pusto)
pusto8.position.set(6.65, 1, -1.68)
pusto8.scale.set(4.48, 2, 4.24)
vse.add(pusto8)
const pusto8_1 = new THREE.Mesh(geometry, mat_pusto)
pusto8_1.position.set(5.53, 1, -2.15)
pusto8_1.scale.set(6.72, 2, 3.3)
vse.add(pusto8_1)
const pusto8_2 = new THREE.Mesh(geometry, mat_pusto)
pusto8_2.position.set(4.91, 1, -0.68)
pusto8_2.scale.set(7.96, 2, 0.36)
vse.add(pusto8_2)
const pusto8_3 = new THREE.Mesh(geometry5, mat_pusto)
pusto8_3.position.set(1.55, 1, -1.45)
pusto8_3.scale.set(-1.074, 1.732, 1.022)
vse.add(pusto8_3)
const pusto8_4 = new THREE.Mesh(geometry5, mat_pusto)
pusto8_4.position.set(1.85, 1, -2.15)
pusto8_4.scale.set(-0.8, 1.732, 2.5)
vse.add(pusto8_4)
// 9
const pusto9 = new THREE.Mesh(geometry, mat_pusto)
pusto9.position.set(24.3, 1, -11.98)
pusto9.scale.set(4.7, 2, 2.46)
vse.add(pusto9)
const pusto9_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto9_1.position.set(21.65, 1, -11.98)
pusto9_1.scale.set(-0.52, 1.732, 2.13)
vse.add(pusto9_1)
// 10
const pusto10 = new THREE.Mesh(geometry, mat_pusto)
pusto10.position.set(37.86, 1, -10.25)
pusto10.scale.set(6.78, 2, 2.92)
vse.add(pusto10)
const pusto10_1 = new THREE.Mesh(geometry, mat_pusto)
pusto10_1.position.set(35.61, 1, -7.29)
pusto10_1.scale.set(2.28, 2, 3.06)
vse.add(pusto10_1)
const pusto10_2 = new THREE.Mesh(geometry5, mat_pusto)
pusto10_2.position.set(41.45, 1, -10.25)
pusto10_2.scale.set(0.346, 1.732, 2.529)
vse.add(pusto10_2)
// Пусто Метелица
const vse_metelica_ = new THREE.Mesh(geometry, mat_pusto)
vse_metelica_.position.set(54.84, 1, -18.5)
vse_metelica_.scale.set(1.53, 2, 3.2)
vse.add(vse_metelica_)
// 12
const pusto12 = new THREE.Mesh(geometry, mat_pusto)
pusto12.position.set(49.5, 1, -17.03)
pusto12.scale.set(2.88, 2, 6.14)
vse.add(pusto12)
// 13
const pusto13 = new THREE.Mesh(geometry, mat_pusto)
pusto13.position.set(47.9, 1, -10.22)
pusto13.scale.set(6.08, 2, 3.4)
vse.add(pusto13)
const pusto13_1 = new THREE.Mesh(geometry5, mat_pusto)
pusto13_1.position.set(44.63, 1, -10.22)
pusto13_1.scale.set(-0.398, 1.732, -2.944)
vse.add(pusto13_1)
// 14
const pusto14 = new THREE.Mesh(geometry, mat_pusto)
pusto14.position.set(50.29, 1, -6.05)
pusto14.scale.set(10.86, 2, 4.78)
vse.add(pusto14)
// 5КармаNof
const vse_5kармаnof = new THREE.Mesh(geometry, mat_vse)
vse_5kармаnof.position.set(58.44, 1, -16.94)
vse_5kармаnof.scale.set(2.34, 2, 6.3)
vse.add(vse_5kармаnof)
const vse_5kармаnof_1 = new THREE.Mesh(geometry, mat_vse)
vse_5kармаnof_1.position.set(57.65, 1, -15.33)
vse_5kармаnof_1.scale.set(3.92, 2, 3.08)
vse.add(vse_5kармаnof_1)




// Аптеки и опптика
// Антей 2
const antey = new THREE.Mesh(geometry, material1)
antey.position.set(72.15, 1, -17.79)
antey.scale.set(2.7, 2, 1.95)
apteki.add(antey)
// Айкрафт
const apteki_aikraft1 = new THREE.Mesh(geometry3, material1)
apteki_aikraft1.position.set(26.5, 1, 15.35)
apteki_aikraft1.scale.set(2.85, 2, 2.5)
apteki_aikraft1.rotation.y = Math.PI/2
apteki.add(apteki_aikraft1)
const apteki_cyl_aikraft2 = new THREE.Mesh(geometry_plane, material1)
apteki_cyl_aikraft2.position.set(27.75, 1, 15.35)
apteki_cyl_aikraft2.scale.set(2, 2.495, 2)
apteki_cyl_aikraft2.rotation.z = -Math.PI/2
apteki.add(apteki_cyl_aikraft2)
const apteki_cyl_aikraft3 = new THREE.Mesh(geometry_plane, material1)
apteki_cyl_aikraft3.position.set(26.5, 1, 13.93)
apteki_cyl_aikraft3.scale.set(2.84, 2, 2)
apteki_cyl_aikraft3.rotation.y = -Math.PI/2
apteki.add(apteki_cyl_aikraft3)
const apteki_aikraft = new THREE.Mesh(geometry, material1)
apteki_aikraft.position.set(27.75, 1, 16.47)
apteki_aikraft.scale.set(2.495, 2, 2.24)
apteki.add(apteki_aikraft)
// Браво-оптика
const bravo_optika = new THREE.Mesh(geometry, material1)
bravo_optika.position.set(75, 1, -11.7)
bravo_optika.scale.set(2.8, 2, 2.95)
apteki.add(bravo_optika)
// Ригла
const rigla = new THREE.Mesh(geometry, material1)
rigla.position.set(75, 1, 0)
rigla.scale.set(2.8, 2, 3.2)
apteki.add(rigla)
// Vita
const vita = new THREE.Mesh(geometry, material1)
vita.position.set(-8.75, 1, 5.15)
vita.scale.set(2.5, 2, 5.4)
apteki.add(vita)
const vita1 = new THREE.Mesh(geometry, material1)
vita1.position.set(-10.195, 1, 2.0)
vita1.scale.set(5.4, 2, 1.14)
apteki.add(vita1)
// Здоровье
const apteki_zdorovie = new THREE.Mesh(geometry, material1)
apteki_zdorovie.position.set(67.2, 1, 16.22)
apteki_zdorovie.scale.set(2.6, 2, 6.08)
apteki.add(apteki_zdorovie)
// Avva
const apteki_avva = new THREE.Mesh(geometry, material1)
apteki_avva.position.set(60.62, 1, 8.76)
apteki_avva.scale.set(2.93, 2, 1.66)
apteki.add(apteki_avva)
const apteki_avva1 = new THREE.Mesh(geometry, material1)
apteki_avva1.position.set(60.107, 1, 9.76)
apteki_avva1.scale.set(1.904, 2, 0.98)
apteki.add(apteki_avva1)
const apteki_avva2 = new THREE.Mesh(geometry, material1)
apteki_avva2.position.set(61.243, 1, 9.407)
apteki_avva2.scale.set(1.22, 2, 1.22)
apteki_avva2.rotation.y = Math.PI/1.465
apteki.add(apteki_avva2)
// Аптека Антей
const apteki_yves_rocher_france = new THREE.Mesh(geometry, material1)
apteki_yves_rocher_france.position.set(28.86, 1, 5.67)
apteki_yves_rocher_france.scale.set(4.12, 2, 4.56)
apteki.add(apteki_yves_rocher_france)
// Аптека Эконом
const apteki_ekonom = new THREE.Mesh(geometry, material1)
apteki_ekonom.position.set(-6.1, 1, 13)
apteki_ekonom.scale.set(2.2, 2, 4.3)
apteki.add(apteki_ekonom)

// Верхняя одежда. Меховые салоны.
// X-Ray 
const x_ray = new THREE.Mesh(geometry, material1)
x_ray.position.set(11.85, 1, 2.1)
x_ray.scale.set(5.7, 2, 5.34)
odegda.add(x_ray)
const x_ray1 = new THREE.Mesh(geometry, material1)
x_ray1.position.set(12.65, 1, 6.2)
x_ray1.scale.set(4.1, 2, 2.87)
odegda.add(x_ray1)
// New Lok 
const new_lok = new THREE.Mesh(geometry, material1)
new_lok.position.set(-49.85, 1, 8.56)
new_lok.scale.set(3.9, 2, 6.9)
odegda.add(new_lok)
// Королева меха 
const damir = new THREE.Mesh(geometry, material1)
damir.position.set(-6.1, 1, 13)
damir.scale.set(2.2, 2, 4.3)
odegda.add(damir)
// Snowimage 
const snowimage = new THREE.Mesh(geometry, material1)
snowimage.position.set(16.5, 1, 6.09)
snowimage.scale.set(3.3, 2, 3.08)
odegda.add(snowimage)
// Stockburg 
const stockburg = new THREE.Mesh(geometry, material1)
stockburg.position.set(52.83, 1, -29.8)
stockburg.scale.set(5.3, 2, 12.7)
odegda.add(stockburg)
// Savari
const odegda_savari = new THREE.Mesh(geometry, material1)
odegda_savari.position.set(38.46, 1, -3.88)
odegda_savari.scale.set(6.28, 2, 3.56)
odegda.add(odegda_savari)
const odegda_savari1 = new THREE.Mesh(geometry5, material1)
odegda_savari1.position.set(41.7, 1, -3.88)
odegda_savari1.scale.set(0.1732, 1.732, -3.083)
odegda.add(odegda_savari1)
// veste
const odegda_veste = new THREE.Mesh(geometry, material1)
odegda_veste.position.set(13.4, 1, 13)
odegda_veste.scale.set(1.9, 2, 4.4)
odegda.add(odegda_veste)
// Диана
const odegda_diana = new THREE.Mesh(geometry, material1)
odegda_diana.position.set(44.65, 1, -14.96)
odegda_diana.scale.set(1.62, 2, 2)
odegda.add(odegda_diana)
const odegda_diana1 = new THREE.Mesh(geometry5, material1)
odegda_diana1.position.set(43.5, 1, -14.96)
odegda_diana1.scale.set(-0.589, 1.732, -1.732)
odegda.add(odegda_diana1)
// Barhat Shev
const odegda_barhat_shev = new THREE.Mesh(geometry, material1)
odegda_barhat_shev.position.set(38.18, 1, -0.8)
odegda_barhat_shev.scale.set(5.72, 2, 2.46)
odegda.add(odegda_barhat_shev)
const odegda_barhat_shev1 = new THREE.Mesh(geometry5, material1)
odegda_barhat_shev1.position.set(41.31, 1, -0.8)
odegda_barhat_shev1.scale.set(0.468, 1.732, -2.13)
odegda.add(odegda_barhat_shev1)
// Кожанный стиль
const odegda_kogan_stil = new THREE.Mesh(geometry, material1)
odegda_kogan_stil.position.set(60.44, 1, -18.68)
odegda_kogan_stil.scale.set(1.52, 2, 2.8)
odegda.add(odegda_kogan_stil)
const odegda_kogan_stil1 = new THREE.Mesh(geometry, material1)
odegda_kogan_stil1.position.set(60.88, 1, -17.923)
odegda_kogan_stil1.scale.set(2.4, 2, 1.34)
odegda.add(odegda_kogan_stil1)
const odegda_kogan_stil2 = new THREE.Mesh(geometry5, material1)
odegda_kogan_stil2.position.set(61.64, 1, -19.32)
odegda_kogan_stil2.scale.set(0.768, 1.732, 1.264)
odegda.add(odegda_kogan_stil2)
// Sabra
const odegda_sabra = new THREE.Mesh(geometry, material1)
odegda_sabra.position.set(69.35, 1, -14.48)
odegda_sabra.scale.set(2.7, 2, 8.55)
odegda.add(odegda_sabra)
// Дисконт-центр
const odegda_diskont_centr = new THREE.Mesh(geometry, material1)
odegda_diskont_centr.position.set(70.25, 1, -25.2)
odegda_diskont_centr.scale.set(6.8, 2, 3.43)
odegda.add(odegda_diskont_centr)
// Rossini
const odegda_rossini = new THREE.Mesh(geometry, material1)
odegda_rossini.position.set(36.4, 1, -15.86)
odegda_rossini.scale.set(3.85, 2, 8.2)
odegda.add(odegda_rossini)
// Scarlet
const odegda_scarlet = new THREE.Mesh(geometry, material1)
odegda_scarlet.position.set(3.65, 1, -25.55)
odegda_scarlet.scale.set(2.1, 2, 4.3)
odegda.add(odegda_scarlet)
// Мех для всех
const odegda_meh_dlya_vseh = new THREE.Mesh(geometry, material1)
odegda_meh_dlya_vseh.position.set(4, 1, -16)
odegda_meh_dlya_vseh.scale.set(3.5, 2, 8)
odegda.add(odegda_meh_dlya_vseh)
const odegda_meh_dlya_vseh1 = new THREE.Mesh(geometry, material1)
odegda_meh_dlya_vseh1.position.set(1.64, 1, -15.2)
odegda_meh_dlya_vseh1.scale.set(1.22, 2, 6.4)
odegda.add(odegda_meh_dlya_vseh1)
const odegda_meh_dlya_vseh2 = new THREE.Mesh(geometry5, material1)
odegda_meh_dlya_vseh2.position.set(1.641, 1, -19.2)
odegda_meh_dlya_vseh2.scale.set(-1.056, 1.732, 1.386)
odegda.add(odegda_meh_dlya_vseh2)
// РосПромОбувь
const odegda_rospromobuv = new THREE.Mesh(geometry, material1)
odegda_rospromobuv.position.set(-17.15, 1, -15.8)
odegda_rospromobuv.scale.set(8.5, 2, 8.8)
odegda.add(odegda_rospromobuv)
// Lovemoda
const odegda_lovemoda = new THREE.Mesh(geometry, material1)
odegda_lovemoda.position.set(-35.06, 1, 16.28)
odegda_lovemoda.scale.set(3.12, 2, 6.4)
odegda.add(odegda_lovemoda)
const odegda_lovemoda1 = new THREE.Mesh(geometry, material1)
odegda_lovemoda1.position.set(-34.08, 1, 15.19)
odegda_lovemoda1.scale.set(1.16, 2, 8.58)
odegda.add(odegda_lovemoda1)
const odegda_lovemoda2 = new THREE.Mesh(geometry5, material1)
odegda_lovemoda2.position.set(-35.64, 1, 11.99)
odegda_lovemoda2.scale.set(-1.697, 1.732, 1.888)
odegda.add(odegda_lovemoda2)
// Joss
const odegda_joss = new THREE.Mesh(geometry, material1)
odegda_joss.position.set(-37.61, 1, 16.58)
odegda_joss.scale.set(1.86, 2, 3.65)
odegda.add(odegda_joss)
const odegda_joss1 = new THREE.Mesh(geometry5, material1)
odegda_joss1.position.set(-37.43, 1, 13.955)
odegda_joss1.scale.set(-1.299, 1.732, 1.386)
odegda.add(odegda_joss1)
// Виктория
const odegda_viktoriya = new THREE.Mesh(geometry, material1)
odegda_viktoriya.position.set(-57.55, 1, 10.1)
odegda_viktoriya.scale.set(2.25, 2, 3.87)
odegda.add(odegda_viktoriya)
// Mirage пусто
const odegda_mirage = new THREE.Mesh(geometry, mat_pusto)
odegda_mirage.position.set(-39.9, 1, 3.26)
odegda_mirage.scale.set(4.48, 2, 3.46)
odegda.add(odegda_mirage)
// kristi
const odegda_kristi = new THREE.Mesh(geometry, material1)
odegda_kristi.position.set(56.8, 1, -26.62)
odegda_kristi.scale.set(2.3, 2, 6.35)
odegda.add(odegda_kristi)
// Tekbir
const odegda_tekbir = new THREE.Mesh(geometry, material1)
odegda_tekbir.position.set(-24.45, 1, 4.8)
odegda_tekbir.scale.set(2.32, 2, 6.2)
odegda.add(odegda_tekbir)
// Метелица
const odegda_metelica = new THREE.Mesh(geometry, material1)
odegda_metelica.position.set(24.84, 1, 1.5)
odegda_metelica.scale.set(3.72, 2, 3.58)
odegda.add(odegda_metelica)
const odegda_metelica1 = new THREE.Mesh(geometry5, material1)
odegda_metelica1.position.set(22.43, 1, 1.5)
odegda_metelica1.scale.set(-0.953, 1.732, -3.1)
odegda.add(odegda_metelica1)

// Гипермаркеты
// АШАН
const gipermarket_ashan = new THREE.Mesh(geometry, material1)
gipermarket_ashan.position.set(94, 1, -9.55)
gipermarket_ashan.scale.set(28.5, 2, 53.25)
gipermarket.add(gipermarket_ashan)
// Smart вместо Пусто 17
const gipermarket_pusto17 = new THREE.Mesh(geometry, material1)
gipermarket_pusto17.position.set(-0.18, 1, 19.92)
gipermarket_pusto17.scale.set(9.52, 2, 18.22)
gipermarket.add(gipermarket_pusto17)
const gipermarket_pusto17_1 = new THREE.Mesh(geometry, material1)
gipermarket_pusto17_1.position.set(-3.6, 1, 22.12)
gipermarket_pusto17_1.scale.set(16.2, 2, 13.82)
gipermarket.add(gipermarket_pusto17_1)
const gipermarket_pusto17_2 = new THREE.Mesh(geometry, material1)
gipermarket_pusto17_2.position.set(-1.08, 1, 27.36)
gipermarket_pusto17_2.scale.set(21.28, 2, 3.46)
gipermarket.add(gipermarket_pusto17_2)
const gipermarket_pusto17_4 = new THREE.Mesh(geometry, material1)
gipermarket_pusto17_4.position.set(5.91, 1, 23.85)
gipermarket_pusto17_4.scale.set(2.66, 2, 10.36)
gipermarket.add(gipermarket_pusto17_4)

// Ещё
const gipermarket_masis = new THREE.Mesh(geometry, material1)
gipermarket_masis.position.set(-4.8, 1, -10.25)
gipermarket_masis.scale.set(5.2, 2, 2.1)
gipermarket.add(gipermarket_masis)
// Пусто 23
const gipermarket_pusto23 = new THREE.Mesh(geometry, material1)
gipermarket_pusto23.position.set(-4.8, 1, -8.06)
gipermarket_pusto23.scale.set(5.2, 2, 2.32)
gipermarket.add(gipermarket_pusto23)
// Пусто 31
const gipermarket_pusto31 = new THREE.Mesh(geometry, material1)
gipermarket_pusto31.position.set(-4.8, 1, -6.62)
gipermarket_pusto31.scale.set(5.2, 2, 0.6)
gipermarket.add(gipermarket_pusto31)
const gipermarket_pusto31_1 = new THREE.Mesh(geometry, material1)
gipermarket_pusto31_1.position.set(-5.44, 1, -5.72)
gipermarket_pusto31_1.scale.set(3.92, 2, 2.4)
gipermarket.add(gipermarket_pusto31_1)
const gipermarket_pusto31_2 = new THREE.Mesh(geometry5, material1)
gipermarket_pusto31_2.position.set(-3.16, 1, -5.42)
gipermarket_pusto31_2.scale.set(0.554, 1.732, -1.559)
gipermarket.add(gipermarket_pusto31_2)
const gipermarket_pusto31_3 = new THREE.Mesh(geometry5, material1)
gipermarket_pusto31_3.position.set(-2.84, 1, -5.87)
gipermarket_pusto31_3.scale.set(1.108, 1.732, -0.779)
gipermarket.add(gipermarket_pusto31_3)
// Пусто 30
const gipermarket_pusto30 = new THREE.Mesh(geometry, material1)
gipermarket_pusto30.position.set(-5.44, 1, -3.45)
gipermarket_pusto30.scale.set(3.92, 2, 2.24)
gipermarket.add(gipermarket_pusto30)
// ММ декор
const gipermarket_mm_dekor = new THREE.Mesh(geometry, material1)
gipermarket_mm_dekor.position.set(-4.8, 1, -0.53)
gipermarket_mm_dekor.scale.set(5.2, 2, 0.5)
gipermarket.add(gipermarket_mm_dekor)
const gipermarket_mm_dekor1 = new THREE.Mesh(geometry, material1)
gipermarket_mm_dekor1.position.set(-5.44, 1, -1.32)
gipermarket_mm_dekor1.scale.set(3.92, 2, 2.08)
gipermarket.add(gipermarket_mm_dekor1)
const gipermarket_mm_dekor2 = new THREE.Mesh(geometry5, material1)
gipermarket_mm_dekor2.position.set(-3.16, 1, -1.57)
gipermarket_mm_dekor2.scale.set(0.554, 1.732, 1.368)
gipermarket.add(gipermarket_mm_dekor2)
const gipermarket_mm_dekor3 = new THREE.Mesh(geometry5, material1)
gipermarket_mm_dekor3.position.set(-2.84, 1, -1.175)
gipermarket_mm_dekor3.scale.set(1.108, 1.732, 0.684)
gipermarket.add(gipermarket_mm_dekor3)
// Хулиган
const gipermarket_huligan = new THREE.Mesh(geometry, material1)
gipermarket_huligan.position.set(-4.8, 1, 0.6)
gipermarket_huligan.scale.set(5.2, 2, 1.8)
gipermarket.add(gipermarket_huligan)
// Ковровый центр
const gipermarket_kovr_centr = new THREE.Mesh(geometry, material1)
gipermarket_kovr_centr.position.set(-4.8, 1, 3.25)
gipermarket_kovr_centr.scale.set(5.2, 2, 3.7)
gipermarket.add(gipermarket_kovr_centr)
// Пусто 29
const gipermarket_pusto29 = new THREE.Mesh(geometry, material1)
gipermarket_pusto29.position.set(-4.8, 1, 5.74)
gipermarket_pusto29.scale.set(5.2, 2, 1.32)
gipermarket.add(gipermarket_pusto29)
const gipermarket_pusto29_1 = new THREE.Mesh(geometry, material1)
gipermarket_pusto29_1.position.set(-5.4, 1, 6.46)
gipermarket_pusto29_1.scale.set(4, 2, 2.76)
gipermarket.add(gipermarket_pusto29_1)
const gipermarket_pusto29_2 = new THREE.Mesh(geometry5, material1)
gipermarket_pusto29_2.position.set(-2.8, 1, 7.12)
gipermarket_pusto29_2.scale.set(1.039, 1.732, -1.247)
gipermarket.add(gipermarket_pusto29_2)


// Магазины аксессуаров
// Bagira 
const bagira = new THREE.Mesh(geometry, material1)
bagira.position.set(-8.35, 1, 13)
bagira.scale.set(2.2, 2, 4.3)
accessory.add(bagira)
// Barselona
const barselona = new THREE.Mesh(geometry, material1)
barselona.position.set(67.4, 1, 6.3)
barselona.scale.set(4.5, 2, 1.2)
accessory.add(barselona)
// 1000 и одна сумка
const accessory_1001_sumka = new THREE.Mesh(geometry, material1)
accessory_1001_sumka.position.set(69.35, 1, 1.79)
accessory_1001_sumka.scale.set(8.36, 2, 3.8)
accessory.add(accessory_1001_sumka)
// joss
const accessory_joss_1 = new THREE.Mesh(geometry, material1)
accessory_joss_1.position.set(-42.07, 1, 10.29)
accessory_joss_1.scale.set(2.36, 2, 3.39)
accessory.add(accessory_joss_1)
// Barhat Shev
const accessory_barhat_shev = new THREE.Mesh(geometry, material1)
accessory_barhat_shev.position.set(38.18, 1, -0.8)
accessory_barhat_shev.scale.set(5.72, 2, 2.46)
accessory.add(accessory_barhat_shev)
const accessory_barhat_shev1 = new THREE.Mesh(geometry5, material1)
accessory_barhat_shev1.position.set(41.31, 1, -0.8)
accessory_barhat_shev1.scale.set(0.468, 1.732, -2.13)
accessory.add(accessory_barhat_shev1)
// Sweet Cat
const accessory_sweet_cat = new THREE.Mesh(geometry, material1)
accessory_sweet_cat.position.set(25.4, 1, 21.1)
accessory_sweet_cat.scale.set(7.3, 2, 2.2)
accessory.add(accessory_sweet_cat)
// Valencia
const accessory_valencia = new THREE.Mesh(geometry, material1)
accessory_valencia.position.set(55.97, 1, 8.41)
accessory_valencia.scale.set(2.02, 2, 3.7)
accessory.add(accessory_valencia)
//Мобильные штучки
const accessory_mobshtuki = new THREE.Mesh(geometry5, material1)
accessory_mobshtuki.position.set(39.13, 1, -18.16)
accessory_mobshtuki.scale.set(1.22, 1.74, 3.2)
accessory.add(accessory_mobshtuki)
// Саквояж
const accessory_sakvoyag = new THREE.Mesh(geometry, material1)
accessory_sakvoyag.position.set(18.58, 1, -17.24)
accessory_sakvoyag.scale.set(1.24, 2, 5.52)
accessory.add(accessory_sakvoyag)
const accessory_sakvoyag1 = new THREE.Mesh(geometry, material1)
accessory_sakvoyag1.position.set(19.58, 1, -19.23)
accessory_sakvoyag1.scale.set(3.24, 2, 1.542)
accessory.add(accessory_sakvoyag1)
const accessory_sakvoyag2 = new THREE.Mesh(geometry5, material1)
accessory_sakvoyag2.position.set(20.2, 1, -16.471)
accessory_sakvoyag2.scale.set(1.732, 1.732, -3.4445)
accessory.add(accessory_sakvoyag2)
// Access
const accessory_access = new THREE.Mesh(geometry, material1)
accessory_access.position.set(15.56, 1, 13)
accessory_access.scale.set(2.14, 2, 4.4)
accessory.add(accessory_access)
// Modi
const accessory_modi = new THREE.Mesh(geometry, material1)
accessory_modi.position.set(25.4, 1, 18.8)
accessory_modi.scale.set(7.3, 2, 2.2)
accessory.add(accessory_modi)

// Магазины белья
// Мэри
const medeya = new THREE.Mesh(geometry, material1)
medeya.position.set(-27, 1, 13.7)
medeya.scale.set(2.3, 2, 5.7)
belie.add(medeya)
// Дом одежда обувь
const belie_dom_odegda = new THREE.Mesh(geometry, material1)
belie_dom_odegda.position.set(-50.37, 1, 24.73)
belie_dom_odegda.scale.set(27, 2, 12.44)
belie.add(belie_dom_odegda)
const belie_dom_odegda1 = new THREE.Mesh(geometry, material1)
belie_dom_odegda1.position.set(-51.42, 1, 16.68)
belie_dom_odegda1.scale.set(11.44, 2, 3.85)
belie.add(belie_dom_odegda1)
const belie_dom_odegda2 = new THREE.Mesh(geometry, material1)
belie_dom_odegda2.position.set(-57.16, 1, 26.4)
belie_dom_odegda2.scale.set(13.72, 2, 17.84)
belie.add(belie_dom_odegda2)
const belie_dom_odegda3 = new THREE.Mesh(geometry, material1)
belie_dom_odegda3.position.set(-40.75, 1, 26.92)
belie_dom_odegda3.scale.set(8.12, 2, 16.78)
belie.add(belie_dom_odegda3)
// Barhat Shev
const belie_barhat_shev = new THREE.Mesh(geometry, material1)
belie_barhat_shev.position.set(38.18, 1, -0.8)
belie_barhat_shev.scale.set(5.72, 2, 2.46)
belie.add(belie_barhat_shev)
const belie_barhat_shev1 = new THREE.Mesh(geometry5, material1)
belie_barhat_shev1.position.set(41.31, 1, -0.8)
belie_barhat_shev1.scale.set(0.468, 1.732, -2.13)
belie.add(belie_barhat_shev1)
// Dimanche Lingerie
const belie_dimanche_lingerie = new THREE.Mesh(geometry, material1)
belie_dimanche_lingerie.position.set(19.35, 1, 6.09)
belie_dimanche_lingerie.scale.set(2.2, 2, 3.08)
belie.add(belie_dimanche_lingerie)
const belie_dimanche_lingerie1 = new THREE.Mesh(geometry, material1)
belie_dimanche_lingerie1.position.set(19.88, 1, 6.98)
belie_dimanche_lingerie1.scale.set(3.26, 2, 1.3)
belie.add(belie_dimanche_lingerie1)
const belie_dimanche_lingerie2 = new THREE.Mesh(geometry5, material1)
belie_dimanche_lingerie2.position.set(20.9805, 1, 5.442)
belie_dimanche_lingerie2.scale.set(0.919, 1.732, 1.541)
belie.add(belie_dimanche_lingerie2)

// Магазины косметики
// Косметичка
const kosmetichka = new THREE.Mesh(geometry, material1)
kosmetichka.position.set(39.45, 1, 15.13)
kosmetichka.scale.set(2.2, 2, 3.91)
kosmetika.add(kosmetichka)
// Космедэль
const kosmedel = new THREE.Mesh(geometry, material1)
kosmedel.position.set(72.15, 1, -15)
kosmedel.scale.set(2.7, 2, 3.7)
kosmetika.add(kosmedel)
// Фамилия
const kosmetika_familiya1 = new THREE.Mesh(geometry, material1)
kosmetika_familiya1.position.set(-15.8, 1, 23.85)
kosmetika_familiya1.scale.set(5.8, 2, 10.6)
kosmetika.add(kosmetika_familiya1)
const kosmetika_familiya2 = new THREE.Mesh(geometry, material1)
kosmetika_familiya2.position.set(-22.1, 1, 13.75)
kosmetika_familiya2.scale.set(7.3, 2, 5.8)
kosmetika.add(kosmetika_familiya2)
const kosmetika_familiya3 = new THREE.Mesh(geometry, material1)
kosmetika_familiya3.position.set(-24.3, 1, 22.9)
kosmetika_familiya3.scale.set(11.65, 2, 12.5)
kosmetika.add(kosmetika_familiya3)
// Ангел
const kosmetika_angel = new THREE.Mesh(geometry, material1)
kosmetika_angel.position.set(60, 1, 15.13)
kosmetika_angel.scale.set(1.6, 2, 3.91)
kosmetika.add(kosmetika_angel)
// Улыбка радуги
const kosmetika_ulybka_radugi = new THREE.Mesh(geometry, material1)
kosmetika_ulybka_radugi.position.set(21.58, 1, 27.91)
kosmetika_ulybka_radugi.scale.set(9.6, 2, 4.35)
kosmetika.add(kosmetika_ulybka_radugi)
const kosmetika_ulybka_radugi1 = new THREE.Mesh(geometry, material1)
kosmetika_ulybka_radugi1.position.set(27.7, 1, 28.55)
kosmetika_ulybka_radugi1.scale.set(2.7, 2, 3.07)
kosmetika.add(kosmetika_ulybka_radugi1)
// Рив Гош
const kosmetika_riv_gosh = new THREE.Mesh(geometry, material1)
kosmetika_riv_gosh.position.set(24.1, 1, 15.06)
kosmetika_riv_gosh.scale.set(4.65, 2, 5.1)
kosmetika.add(kosmetika_riv_gosh)
const kosmetika_cyl_riv_gosh = new THREE.Mesh(geometry2, material1)
kosmetika_cyl_riv_gosh.position.set(23.1, 1, 13.4)
kosmetika_cyl_riv_gosh.scale.set(3.2, 2, 1.8)
kosmetika_cyl_riv_gosh.rotation.y = -Math.PI/4
kosmetika.add(kosmetika_cyl_riv_gosh)
const kosmetika_cyl_riv_gosh1 = new THREE.Mesh(geometry4, material1)
kosmetika_cyl_riv_gosh1.position.set(21.75, 1, 16.15)
kosmetika_cyl_riv_gosh1.scale.set(5, 2, 5.95)
kosmetika_cyl_riv_gosh1.rotation.y = Math.PI/1.41
kosmetika.add(kosmetika_cyl_riv_gosh1)
// Подружка
const kosmetika_podrugka = new THREE.Mesh(geometry, material1)
kosmetika_podrugka.position.set(45.07, 1, 15.13)
kosmetika_podrugka.scale.set(4.45, 2, 3.91)
kosmetika.add(kosmetika_podrugka)
// Лэтуаль
const kosmetika_letual = new THREE.Mesh(geometry, material1)
kosmetika_letual.position.set(88.76, 1, 19.8)
kosmetika_letual.scale.set(4.05, 2, 5.15)
kosmetika.add(kosmetika_letual)
// Расчёска
const kosmetika_rascheska = new THREE.Mesh(geometry, material1)
kosmetika_rascheska.position.set(16.675, 1, 0.62)
kosmetika_rascheska.scale.set(3.7, 2, 2.46)
kosmetika.add(kosmetika_rascheska)
const kosmetika_rascheska1 = new THREE.Mesh(geometry5, material1)
kosmetika_rascheska1.position.set(18.945, 1, 0.62)
kosmetika_rascheska1.scale.set(0.73, 1.732, 2.128)
kosmetika.add(kosmetika_rascheska1)

// Магазины техники
// DNS
const dns = new THREE.Mesh(geometry, material1)
dns.position.set(46.9, 1, 23.6)
dns.scale.set(8.02, 2, 12.77)
tehnika.add(dns)
const dns1 = new THREE.Mesh(geometry, material1)
dns1.position.set(49.145, 1, 15.36)
dns1.scale.set(3.53, 2, 4.4)
tehnika.add(dns1)
const dns2 = new THREE.Mesh(geometry, material1)
dns2.position.set(39.17, 1, 27.3)
dns2.scale.set(7.55, 2, 5.37)
tehnika.add(dns2)
const dns3 = new THREE.Mesh(geometry, material1)
dns3.position.set(41.5, 1, 24.1)
dns3.scale.set(3, 2, 1.6)
tehnika.add(dns3)
// Эльдорадо
const eldorado = new THREE.Mesh(geometry, material1)
eldorado.position.set(-16.7, 1, -5.5)
eldorado.scale.set(18.3, 2, 11.6)
tehnika.add(eldorado)
const eldorado1 = new THREE.Mesh(geometry, material1)
eldorado1.position.set(-25.17, 1, -0.15)
eldorado1.scale.set(3.8, 2, 3.5)
tehnika.add(eldorado1)
const eldorado2 = new THREE.Mesh(geometry, material1)
eldorado2.position.set(-16.9, 1, 4.05)
eldorado2.scale.set(7.8, 2, 7.7)
tehnika.add(eldorado2)
const eldorado3 = new THREE.Mesh(geometry, material1)
eldorado3.position.set(-10.38, 1, 0.55)
eldorado3.scale.set(5.65, 2, 1.6)
tehnika.add(eldorado3)
// М.Видео
const mvideo = new THREE.Mesh(geometry, material1)
mvideo.position.set(58.44, 1, 23.61)
mvideo.scale.set(14.74, 2, 12.74)
tehnika.add(mvideo)
const mvideo1 = new THREE.Mesh(geometry, material1)
mvideo1.position.set(63.35, 1, 15.3)
mvideo1.scale.set(4.93, 2, 4.25)
tehnika.add(mvideo1)
const mvideo2 = new THREE.Mesh(geometry, material1)
mvideo2.position.set(64.8, 1, 27.46)
mvideo2.scale.set(7.36, 2, 16.2)
tehnika.add(mvideo2)
const mvideo3 = new THREE.Mesh(geometry, material1)
mvideo3.position.set(69.2, 1, 32.95)
mvideo3.scale.set(5.26, 2, 10.1)
tehnika.add(mvideo3)
const mvideo4 = new THREE.Mesh(geometry, material1)
mvideo4.position.set(54.67, 1, 32.7)
mvideo4.scale.set(2.38, 2, 5.74)
tehnika.add(mvideo4)
const mvideo5 = new THREE.Mesh(geometry, material1)
mvideo5.position.set(58.47, 1, 29.7)
mvideo5.scale.set(5.74, 2, 2.3)
tehnika.add(mvideo5)
// Xiaomi
const tehnika_xiaomi = new THREE.Mesh(geometry, material1)
tehnika_xiaomi.position.set(36.2, 1, 5.47)
tehnika_xiaomi.scale.set(1.76, 2, 5)
tehnika.add(tehnika_xiaomi)
const tehnika_xiaomi1 = new THREE.Mesh(geometry5, material1)
tehnika_xiaomi1.position.set(38.61, 1, 5.47)
tehnika_xiaomi1.scale.set(2.65, 1.732, -4.33)
tehnika.add(tehnika_xiaomi1)
// Sotiks
const tehnika_sotiks = new THREE.Mesh(geometry, material1)
tehnika_sotiks.position.set(52.15, 1, 15.13)
tehnika_sotiks.scale.set(2.21, 2, 3.91)
tehnika.add(tehnika_sotiks)
// Ещё
// Masis
const tehnika_masis = new THREE.Mesh(geometry, material1)
tehnika_masis.position.set(-4.8, 1, -10.25)
tehnika_masis.scale.set(5.2, 2, 2.1)
tehnika.add(tehnika_masis)
// Пусто 23
const tehnika_pusto23 = new THREE.Mesh(geometry, material1)
tehnika_pusto23.position.set(-4.8, 1, -8.06)
tehnika_pusto23.scale.set(5.2, 2, 2.32)
tehnika.add(tehnika_pusto23)
// Пусто 31
const tehnika_pusto31 = new THREE.Mesh(geometry, material1)
tehnika_pusto31.position.set(-4.8, 1, -6.62)
tehnika_pusto31.scale.set(5.2, 2, 0.6)
tehnika.add(tehnika_pusto31)
const tehnika_pusto31_1 = new THREE.Mesh(geometry, material1)
tehnika_pusto31_1.position.set(-5.44, 1, -5.72)
tehnika_pusto31_1.scale.set(3.92, 2, 2.4)
tehnika.add(tehnika_pusto31_1)
const tehnika_pusto31_2 = new THREE.Mesh(geometry5, material1)
tehnika_pusto31_2.position.set(-3.16, 1, -5.42)
tehnika_pusto31_2.scale.set(0.554, 1.732, -1.559)
tehnika.add(tehnika_pusto31_2)
const tehnika_pusto31_3 = new THREE.Mesh(geometry5, material1)
tehnika_pusto31_3.position.set(-2.84, 1, -5.87)
tehnika_pusto31_3.scale.set(1.108, 1.732, -0.779)
tehnika.add(tehnika_pusto31_3)
// Пусто 30
const tehnika_pusto30 = new THREE.Mesh(geometry, material1)
tehnika_pusto30.position.set(-5.44, 1, -3.45)
tehnika_pusto30.scale.set(3.92, 2, 2.24)
tehnika.add(tehnika_pusto30)
// ММ декор
const tehnika_mm_dekor = new THREE.Mesh(geometry, material1)
tehnika_mm_dekor.position.set(-4.8, 1, -0.53)
tehnika_mm_dekor.scale.set(5.2, 2, 0.5)
tehnika.add(tehnika_mm_dekor)
const tehnika_mm_dekor1 = new THREE.Mesh(geometry, material1)
tehnika_mm_dekor1.position.set(-5.44, 1, -1.32)
tehnika_mm_dekor1.scale.set(3.92, 2, 2.08)
tehnika.add(tehnika_mm_dekor1)
const tehnika_mm_dekor2 = new THREE.Mesh(geometry5, material1)
tehnika_mm_dekor2.position.set(-3.16, 1, -1.57)
tehnika_mm_dekor2.scale.set(0.554, 1.732, 1.368)
tehnika.add(tehnika_mm_dekor2)
const tehnika_mm_dekor3 = new THREE.Mesh(geometry5, material1)
tehnika_mm_dekor3.position.set(-2.84, 1, -1.175)
tehnika_mm_dekor3.scale.set(1.108, 1.732, 0.684)
tehnika.add(tehnika_mm_dekor3)
// Хулиган
const tehnika_huligan = new THREE.Mesh(geometry, material1)
tehnika_huligan.position.set(-4.8, 1, 0.6)
tehnika_huligan.scale.set(5.2, 2, 1.8)
tehnika.add(tehnika_huligan)
// Ковровый центр
const tehnika_kovr_centr = new THREE.Mesh(geometry, material1)
tehnika_kovr_centr.position.set(-4.8, 1, 3.25)
tehnika_kovr_centr.scale.set(5.2, 2, 3.7)
tehnika.add(tehnika_kovr_centr)
// Пусто 29
const tehnika_pusto29 = new THREE.Mesh(geometry, material1)
tehnika_pusto29.position.set(-4.8, 1, 5.74)
tehnika_pusto29.scale.set(5.2, 2, 1.32)
tehnika.add(tehnika_pusto29)
const tehnika_pusto29_1 = new THREE.Mesh(geometry, material1)
tehnika_pusto29_1.position.set(-5.4, 1, 6.46)
tehnika_pusto29_1.scale.set(4, 2, 2.76)
tehnika.add(tehnika_pusto29_1)
const tehnika_pusto29_2 = new THREE.Mesh(geometry5, material1)
tehnika_pusto29_2.position.set(-2.8, 1, 7.12)
tehnika_pusto29_2.scale.set(1.039, 1.732, -1.247)
tehnika.add(tehnika_pusto29_2)
// DNS Технопоинт
const tehnika_dnstehno = new THREE.Mesh(geometry, material1)
tehnika_dnstehno.position.set(7.34, 1, 14.7)
tehnika_dnstehno.scale.set(5.4, 2, 7.8)
tehnika.add(tehnika_dnstehno)
const tehnika_dnstehno_2 = new THREE.Mesh(geometry, material1)
tehnika_dnstehno_2.position.set(13.28, 1, 22.15)
tehnika_dnstehno_2.scale.set(6.74, 2, 13.82)
tehnika.add(tehnika_dnstehno_2)
const tehnika_dnstehno_1 = new THREE.Mesh(geometry, material1)
tehnika_dnstehno_1.position.set(11.86, 1, 22.02)
tehnika_dnstehno_1.scale.set(9.16, 2, 7.12)
tehnika.add(tehnika_dnstehno_1)
const tehnika_dnstehno_3 = new THREE.Mesh(geometry, material1)
tehnika_dnstehno_3.position.set(13.14, 1, 27.26)
tehnika_dnstehno_3.scale.set(7, 2, 3.68)
tehnika.add(tehnika_dnstehno_3)



// Мебель и товары для дома
// Мебель-лэнд
const mebel_lend = new THREE.Mesh(geometry, material1)
mebel_lend.position.set(18.38, 1, -29.73)
mebel_lend.scale.set(20.4, 2, 6.66)
mebel.add(mebel_lend)
const mebel_lend1 = new THREE.Mesh(geometry, material1)
mebel_lend1.position.set(20.9, 1, -24.97)
mebel_lend1.scale.set(15.36, 2, 3.1)
mebel.add(mebel_lend1)
const mebel_lend2 = new THREE.Mesh(geometry, material1)
mebel_lend2.position.set(32.41, 1, -31.7)
mebel_lend2.scale.set(24.54, 2, 8.9)
mebel.add(mebel_lend2)
const mebel_lend3 = new THREE.Mesh(geometry, material1)
mebel_lend3.position.set(35.32, 1, -25.62)
mebel_lend3.scale.set(7, 2, 4.46)
mebel.add(mebel_lend3)
// Фамилия
const mebel_familiya1 = new THREE.Mesh(geometry, material1)
mebel_familiya1.position.set(-15.8, 1, 23.85)
mebel_familiya1.scale.set(5.8, 2, 10.6)
mebel.add(mebel_familiya1)
const mebel_familiya2 = new THREE.Mesh(geometry, material1)
mebel_familiya2.position.set(-22.1, 1, 13.75)
mebel_familiya2.scale.set(7.3, 2, 5.8)
mebel.add(mebel_familiya2)
const mebel_familiya3 = new THREE.Mesh(geometry, material1)
mebel_familiya3.position.set(-24.3, 1, 22.9)
mebel_familiya3.scale.set(11.65, 2, 12.5)
mebel.add(mebel_familiya3)
// Дом одежда обувь
const mebel_dom_odegda = new THREE.Mesh(geometry, material1)
mebel_dom_odegda.position.set(-50.37, 1, 24.73)
mebel_dom_odegda.scale.set(27, 2, 12.44)
mebel.add(mebel_dom_odegda)
const mebel_dom_odegda1 = new THREE.Mesh(geometry, material1)
mebel_dom_odegda1.position.set(-51.42, 1, 16.68)
mebel_dom_odegda1.scale.set(11.44, 2, 3.85)
mebel.add(mebel_dom_odegda1)
const mebel_dom_odegda2 = new THREE.Mesh(geometry, material1)
mebel_dom_odegda2.position.set(-57.16, 1, 26.4)
mebel_dom_odegda2.scale.set(13.72, 2, 17.84)
mebel.add(mebel_dom_odegda2)
const mebel_dom_odegda3 = new THREE.Mesh(geometry, material1)
mebel_dom_odegda3.position.set(-40.75, 1, 26.92)
mebel_dom_odegda3.scale.set(8.12, 2, 16.78)
mebel.add(mebel_dom_odegda3)
// Аллея мебели
const mebel_alleya_mebeli = new THREE.Mesh(geometry, material1)
mebel_alleya_mebeli.position.set(101.7, 1, 22.9)
mebel_alleya_mebeli.scale.set(13.1, 2, 11.4)
mebel.add(mebel_alleya_mebeli)
const mebel_alleya_mebeli1 = new THREE.Mesh(geometry, material1)
mebel_alleya_mebeli1.position.set(105.65, 1, 33.2)
mebel_alleya_mebeli1.scale.set(5.2, 2, 9.55)
mebel.add(mebel_alleya_mebeli1)
// Gipfel
const mebel_gipfel = new THREE.Mesh(geometry, material1)
mebel_gipfel.position.set(75, 1, -2.9)
mebel_gipfel.scale.set(2.8, 2, 2.45)
mebel.add(mebel_gipfel)
// Дом посуды
const mebel_dom_posudy = new THREE.Mesh(geometry, material1)
mebel_dom_posudy.position.set(-66.06, 1, 23.68)
mebel_dom_posudy.scale.set(3.96, 2, 3)
mebel.add(mebel_dom_posudy)
const mebel_dom_posudy1 = new THREE.Mesh(geometry5, material1)
mebel_dom_posudy1.position.set(-68.94, 1, 23.68)
mebel_dom_posudy1.scale.set(-1.559, 1.732, 2.598)
mebel.add(mebel_dom_posudy1)
// Ещё
// Masis
const mebel_masis = new THREE.Mesh(geometry, material1)
mebel_masis.position.set(-4.8, 1, -10.25)
mebel_masis.scale.set(5.2, 2, 2.1)
mebel.add(mebel_masis)
// Пусто 23
const mebel_pusto23 = new THREE.Mesh(geometry, material1)
mebel_pusto23.position.set(-4.8, 1, -8.06)
mebel_pusto23.scale.set(5.2, 2, 2.32)
mebel.add(mebel_pusto23)
// Пусто 31
const mebel_pusto31 = new THREE.Mesh(geometry, material1)
mebel_pusto31.position.set(-4.8, 1, -6.62)
mebel_pusto31.scale.set(5.2, 2, 0.6)
mebel.add(mebel_pusto31)
const mebel_pusto31_1 = new THREE.Mesh(geometry, material1)
mebel_pusto31_1.position.set(-5.44, 1, -5.72)
mebel_pusto31_1.scale.set(3.92, 2, 2.4)
mebel.add(mebel_pusto31_1)
const mebel_pusto31_2 = new THREE.Mesh(geometry5, material1)
mebel_pusto31_2.position.set(-3.16, 1, -5.42)
mebel_pusto31_2.scale.set(0.554, 1.732, -1.559)
mebel.add(mebel_pusto31_2)
const mebel_pusto31_3 = new THREE.Mesh(geometry5, material1)
mebel_pusto31_3.position.set(-2.84, 1, -5.87)
mebel_pusto31_3.scale.set(1.108, 1.732, -0.779)
mebel.add(mebel_pusto31_3)
// Пусто 30
const mebel_pusto30 = new THREE.Mesh(geometry, material1)
mebel_pusto30.position.set(-5.44, 1, -3.45)
mebel_pusto30.scale.set(3.92, 2, 2.24)
mebel.add(mebel_pusto30)
// ММ декор
const mebel_mm_dekor = new THREE.Mesh(geometry, material1)
mebel_mm_dekor.position.set(-4.8, 1, -0.53)
mebel_mm_dekor.scale.set(5.2, 2, 0.5)
mebel.add(mebel_mm_dekor)
const mebel_mm_dekor1 = new THREE.Mesh(geometry, material1)
mebel_mm_dekor1.position.set(-5.44, 1, -1.32)
mebel_mm_dekor1.scale.set(3.92, 2, 2.08)
mebel.add(mebel_mm_dekor1)
const mebel_mm_dekor2 = new THREE.Mesh(geometry5, material1)
mebel_mm_dekor2.position.set(-3.16, 1, -1.57)
mebel_mm_dekor2.scale.set(0.554, 1.732, 1.368)
mebel.add(mebel_mm_dekor2)
const mebel_mm_dekor3 = new THREE.Mesh(geometry5, material1)
mebel_mm_dekor3.position.set(-2.84, 1, -1.175)
mebel_mm_dekor3.scale.set(1.108, 1.732, 0.684)
mebel.add(mebel_mm_dekor3)
// Хулиган
const mebel_huligan = new THREE.Mesh(geometry, material1)
mebel_huligan.position.set(-4.8, 1, 0.6)
mebel_huligan.scale.set(5.2, 2, 1.8)
mebel.add(mebel_huligan)
// Ковровый центр
const mebel_kovr_centr = new THREE.Mesh(geometry, material1)
mebel_kovr_centr.position.set(-4.8, 1, 3.25)
mebel_kovr_centr.scale.set(5.2, 2, 3.7)
mebel.add(mebel_kovr_centr)
// Пусто 29
const mebel_pusto29 = new THREE.Mesh(geometry, material1)
mebel_pusto29.position.set(-4.8, 1, 5.74)
mebel_pusto29.scale.set(5.2, 2, 1.32)
mebel.add(mebel_pusto29)
const mebel_pusto29_1 = new THREE.Mesh(geometry, material1)
mebel_pusto29_1.position.set(-5.4, 1, 6.46)
mebel_pusto29_1.scale.set(4, 2, 2.76)
mebel.add(mebel_pusto29_1)
const mebel_pusto29_2 = new THREE.Mesh(geometry5, material1)
mebel_pusto29_2.position.set(-2.8, 1, 7.12)
mebel_pusto29_2.scale.set(1.039, 1.732, -1.247)
mebel.add(mebel_pusto29_2)


// Женская одежда
// scorpion 
const scorpion = new THREE.Mesh(geometry, material1)
scorpion.position.set(9.72, 1, 6.25)
scorpion.scale.set(1.55, 2, 2.8)
genodegda.add(scorpion)
// scorpion 2
const scorpion2 = new THREE.Mesh(geometry, material1)
scorpion2.position.set(17.1, 1, 3.2)
scorpion2.scale.set(4.55, 2, 2.5)
genodegda.add(scorpion2)
const cyl_scorpion2 = new THREE.Mesh(geometry2, material1)
cyl_scorpion2.position.set(19.3, 1, 3.65)
cyl_scorpion2.scale.set(1.4, 2, 1.7)
cyl_scorpion2.rotation.set(0, 3.1, 0)
genodegda.add(cyl_scorpion2)
// ballare 
const ballare = new THREE.Mesh(geometry, material1)
ballare.position.set(11.2, 1, 13)
ballare.scale.set(2.2, 2, 4.4)
genodegda.add(ballare)
// Планета джинсов 
const planeta_d = new THREE.Mesh(geometry, material1)
planeta_d.position.set(13.45, 1, -5.4)
planeta_d.scale.set(8.9, 2, 3)
genodegda.add(planeta_d)
// Фамилия
const familiya1 = new THREE.Mesh(geometry, material1)
familiya1.position.set(-15.8, 1, 23.85)
familiya1.scale.set(5.8, 2, 10.6)
genodegda.add(familiya1)
const familiya2 = new THREE.Mesh(geometry, material1)
familiya2.position.set(-22.1, 1, 13.75)
familiya2.scale.set(7.3, 2, 5.8)
genodegda.add(familiya2)
const familiya3 = new THREE.Mesh(geometry, material1)
familiya3.position.set(-24.3, 1, 22.9)
familiya3.scale.set(11.65, 2, 12.5)
genodegda.add(familiya3)
// Дом одежда обувь
const dom_odegda = new THREE.Mesh(geometry, material1)
dom_odegda.position.set(-50.37, 1, 24.73)
dom_odegda.scale.set(27, 2, 12.44)
genodegda.add(dom_odegda)
const dom_odegda1 = new THREE.Mesh(geometry, material1)
dom_odegda1.position.set(-51.42, 1, 16.68)
dom_odegda1.scale.set(11.44, 2, 3.85)
genodegda.add(dom_odegda1)
const dom_odegda2 = new THREE.Mesh(geometry, material1)
dom_odegda2.position.set(-57.16, 1, 26.4)
dom_odegda2.scale.set(13.72, 2, 17.84)
genodegda.add(dom_odegda2)
const dom_odegda3 = new THREE.Mesh(geometry, material1)
dom_odegda3.position.set(-40.75, 1, 26.92)
dom_odegda3.scale.set(8.12, 2, 16.78)
genodegda.add(dom_odegda3)
// Lacarino Woman
const genodegda_lacarino_woman = new THREE.Mesh(geometry, material1)
genodegda_lacarino_woman.position.set(45.88, 1, 2.76)
genodegda_lacarino_woman.scale.set(3.06, 2, 3.1)
genodegda.add(genodegda_lacarino_woman)
const genodegda_lacarino_woman1 = new THREE.Mesh(geometry5, material1)
genodegda_lacarino_woman1.position.set(43.91, 1, 2.76)
genodegda_lacarino_woman1.scale.set(-0.762, 1.732, 2.685)
genodegda.add(genodegda_lacarino_woman1)
// Savari
const genodegda_savari = new THREE.Mesh(geometry, material1)
genodegda_savari.position.set(38.46, 1, -3.88)
genodegda_savari.scale.set(6.28, 2, 3.56)
genodegda.add(genodegda_savari)
const genodegda_savari1 = new THREE.Mesh(geometry5, material1)
genodegda_savari1.position.set(41.7, 1, -3.88)
genodegda_savari1.scale.set(0.1732, 1.732, -3.083)
genodegda.add(genodegda_savari1)
// Best
const genodegda_best = new THREE.Mesh(geometry, material1)
genodegda_best.position.set(11.65, 1, -24.85)
genodegda_best.scale.set(3, 2, 2.9)
genodegda.add(genodegda_best)
// Джинсовый микс
const genodegda_dgins_miks = new THREE.Mesh(geometry, material1)
genodegda_dgins_miks.position.set(2.62, 1, 4.35)
genodegda_dgins_miks.scale.set(3.4, 2, 1.05)
genodegda.add(genodegda_dgins_miks)
// Лидер 
const genodegda_lider = new THREE.Mesh(geometry, material1)
genodegda_lider.position.set(2.62, 1, 2.15)
genodegda_lider.scale.set(3.4, 2, 1.05)
genodegda.add(genodegda_lider)
// Salsa
const genodegda_salsa = new THREE.Mesh(geometry, material1)
genodegda_salsa.position.set(-22.1, 1, 4.15)
genodegda_salsa.scale.set(2.2, 2, 7.5)
genodegda.add(genodegda_salsa)
// Man Style
const genodegda_manstyle = new THREE.Mesh(geometry, material1)
genodegda_manstyle.position.set(-15.6, 1, 14.65)
genodegda_manstyle.scale.set(5.5, 2, 7.6)
genodegda.add(genodegda_manstyle)
// K&M
const genodegda_km = new THREE.Mesh(geometry, material1)
genodegda_km.position.set(39.5, 1, -13)
genodegda_km.scale.set(2.15, 2, 2.46)
genodegda.add(genodegda_km)
const genodegda_km1 = new THREE.Mesh(geometry5, material1)
genodegda_km1.position.set(40.92, 1, -13)
genodegda_km1.scale.set(0.598, 1.732, 2.13)
genodegda.add(genodegda_km1)
// Barhat Shev
const genodegda_barhat_shev = new THREE.Mesh(geometry, material1)
genodegda_barhat_shev.position.set(38.18, 1, -0.8)
genodegda_barhat_shev.scale.set(5.72, 2, 2.46)
genodegda.add(genodegda_barhat_shev)
const genodegda_barhat_shev1 = new THREE.Mesh(geometry5, material1)
genodegda_barhat_shev1.position.set(41.31, 1, -0.8)
genodegda_barhat_shev1.scale.set(0.468, 1.732, -2.13)
genodegda.add(genodegda_barhat_shev1)
// Modnyi
const genodegda_modnyi = new THREE.Mesh(geometry, material1)
genodegda_modnyi.position.set(60.62, 1, 6.93)
genodegda_modnyi.scale.set(2.93, 2, 1.9)
genodegda.add(genodegda_modnyi)
// Фабрика костюма
const genodegda_fabrika_kostuma = new THREE.Mesh(geometry, material1)
genodegda_fabrika_kostuma.position.set(56.4, 1, 15.13)
genodegda_fabrika_kostuma.scale.set(1.91, 2, 3.91)
genodegda.add(genodegda_fabrika_kostuma)
// Кредо
const genodegda_kredo = new THREE.Mesh(geometry, material1)
genodegda_kredo.position.set(67.4, 1, 7.6)
genodegda_kredo.scale.set(4.5, 2, 1.25)
genodegda.add(genodegda_kredo)
// Ninalina
const genodegda_ninalina = new THREE.Mesh(geometry, material1)
genodegda_ninalina.position.set(66.89, 1, 8.966)
genodegda_ninalina.scale.set(3.52, 2, 1.282)
genodegda.add(genodegda_ninalina)
const genodegda_ninalina1 = new THREE.Mesh(geometry, material1)
genodegda_ninalina1.position.set(67.395, 1, 9.87)
genodegda_ninalina1.scale.set(2.505, 2, 0.76)
genodegda.add(genodegda_ninalina1)
const genodegda_ninalina2 = new THREE.Mesh(geometry, material1)
genodegda_ninalina2.position.set(65.958, 1, 9.422)
genodegda_ninalina2.scale.set(1.2, 2, 1.2)
genodegda_ninalina2.rotation.y = Math.PI/1.22
genodegda.add(genodegda_ninalina2)
// Capsula. My
const genodegda_capsula_my = new THREE.Mesh(geometry, material1)
genodegda_capsula_my.position.set(69.35, 1, -8.53)
genodegda_capsula_my.scale.set(8.36, 2, 3.15)
genodegda.add(genodegda_capsula_my)
// Oodji
const genodegda_oodji = new THREE.Mesh(geometry, material1)
genodegda_oodji.position.set(56.55, 1, -10.23)
genodegda_oodji.scale.set(11.04, 2, 3.4)
genodegda.add(genodegda_oodji)
const genodegda_oodji1 = new THREE.Mesh(geometry, material1)
genodegda_oodji1.position.set(58.94, 1, -9.13)
genodegda_oodji1.scale.set(6.3, 2, 5.6)
genodegda.add(genodegda_oodji1)
const genodegda_oodji2 = new THREE.Mesh(geometry, material1)
genodegda_oodji2.position.set(58.13, 1, -4.99)
genodegda_oodji2.scale.set(4.68, 2, 2.68)
genodegda.add(genodegda_oodji2)
const genodegda_oodji3 = new THREE.Mesh(geometry5, material1)
genodegda_oodji3.position.set(61.24, 1, -5.53)
genodegda_oodji3.scale.set(1.472, 1.732, -1.386)
genodegda.add(genodegda_oodji3)
const genodegda_oodji4 = new THREE.Mesh(geometry5, material1)
genodegda_oodji4.position.set(60.95, 1, -5.33)
genodegda_oodji4.scale.set(0.9, 1.732, -2.321)
genodegda.add(genodegda_oodji4)
// Gloria Jeans
const genodegda_gloria_jeans = new THREE.Mesh(geometry, material1)
genodegda_gloria_jeans.position.set(70.25, 1, -31.58)
genodegda_gloria_jeans.scale.set(6.8, 2, 9.15)
genodegda.add(genodegda_gloria_jeans)
// Garnet
const genodegda_garnet = new THREE.Mesh(geometry, material1)
genodegda_garnet.position.set(16.94, 1, -12.93)
genodegda_garnet.scale.set(2.72, 2, 2.98)
genodegda.add(genodegda_garnet)
const genodegda_garnet1 = new THREE.Mesh(geometry5, material1)
genodegda_garnet1.position.set(18.75, 1, -12.93)
genodegda_garnet1.scale.set(0.78, 1.732, -2.5805)
genodegda.add(genodegda_garnet1)
// Магия моды 
const genodegda_magiya_mody = new THREE.Mesh(geometry, material1)
genodegda_magiya_mody.position.set(14.88, 1, -10.28)
genodegda_magiya_mody.scale.set(6.04, 2, 2.12)
genodegda.add(genodegda_magiya_mody)
const genodegda_magiya_mody1 = new THREE.Mesh(geometry5, material1)
genodegda_magiya_mody1.position.set(18.1, 1, -10.28)
genodegda_magiya_mody1.scale.set(0.347, 1.732, -1.836)
genodegda.add(genodegda_magiya_mody1)
// Miss Poem
const genodegda_miss_poem = new THREE.Mesh(geometry, material1)
genodegda_miss_poem.position.set(5.14, 1, 6.31)
genodegda_miss_poem.scale.set(1.44, 2, 2.72)
genodegda.add(genodegda_miss_poem)
// Joss
const genodegda_joss = new THREE.Mesh(geometry, material1)
genodegda_joss.position.set(-37.61, 1, 16.58)
genodegda_joss.scale.set(1.86, 2, 3.65)
genodegda.add(genodegda_joss)
const genodegda_joss1 = new THREE.Mesh(geometry5, material1)
genodegda_joss1.position.set(-37.43, 1, 13.955)
genodegda_joss1.scale.set(-1.299, 1.732, 1.386)
genodegda.add(genodegda_joss1)
// Molkova Dress
const genodegda_molkova_dress = new THREE.Mesh(geometry, material1)
genodegda_molkova_dress.position.set(-32.5, 1, -0.32)
genodegda_molkova_dress.scale.set(4.15, 2, 0.44)
genodegda.add(genodegda_molkova_dress)
const genodegda_molkova_dress1 = new THREE.Mesh(geometry, material1)
genodegda_molkova_dress1.position.set(-31.91, 1, -1)
genodegda_molkova_dress1.scale.set(2.97, 2, 1.8)
genodegda.add(genodegda_molkova_dress1)
const genodegda_molkova_dress2 = new THREE.Mesh(geometry5, material1)
genodegda_molkova_dress2.position.set(-33.985, 1, -1.22)
genodegda_molkova_dress2.scale.set(-1.022, 1.732, 1.178)
genodegda.add(genodegda_molkova_dress2)
// You Style
const genodegda_you_style = new THREE.Mesh(geometry, material1)
genodegda_you_style.position.set(-41.04, 1, 16.58)
genodegda_you_style.scale.set(1.6, 2, 3.65)
genodegda.add(genodegda_you_style)
// Tekbir
const genodegda_tekbir = new THREE.Mesh(geometry, material1)
genodegda_tekbir.position.set(-24.45, 1, 4.8)
genodegda_tekbir.scale.set(2.32, 2, 6.2)
genodegda.add(genodegda_tekbir)
// был Verona стал I.Lady
const genodegda_ilady = new THREE.Mesh(geometry, material1)
genodegda_ilady.position.set(40.4, 1, -25.32)
genodegda_ilady.scale.set(2.83, 2, 3.8)
genodegda.add(genodegda_ilady)
/*/ I.Lady
const genodegda_ilady = new THREE.Mesh(geometry, material1)
genodegda_ilady.position.set(-4.13, 1, -17.88)
genodegda_ilady.scale.set(3.78, 2, 1.26)
genodegda.add(genodegda_ilady)
const genodegda_ilady1 = new THREE.Mesh(geometry, material1)
genodegda_ilady1.position.set(-5.04, 1, -18.75)
genodegda_ilady1.scale.set(2.04, 2, 3)
genodegda.add(genodegda_ilady1)
const genodegda_ilady2 = new THREE.Mesh(geometry5, material1)
genodegda_ilady2.position.set(-3.131, 1, -19.38)
genodegda_ilady2.scale.set(1.541, 1.732, 1.507)
genodegda.add(genodegda_ilady2) **/
// Remoda
const genodegda_remoda = new THREE.Mesh(geometry, material1)
genodegda_remoda.position.set(70.03, 1, -3.535)
genodegda_remoda.scale.set(6.96, 2, 6.71)
genodegda.add(genodegda_remoda)
const genodegda_remoda1 = new THREE.Mesh(geometry, material1)
genodegda_remoda1.position.set(66.06, 1, -6.5)
genodegda_remoda1.scale.set(1.85, 2, 0.78)
genodegda.add(genodegda_remoda1)
const genodegda_remoda2 = new THREE.Mesh(geometry, material1)
genodegda_remoda2.position.set(66.06, 1, -0.6)
genodegda_remoda2.scale.set(1.85, 2, 0.84)
genodegda.add(genodegda_remoda2)
const genodegda_remoda3 = new THREE.Mesh(geometry, material1)
genodegda_remoda3.position.set(66.2153, 1, -5.82)
genodegda_remoda3.scale.set(2, 2, 1)
genodegda_remoda3.rotation.y = Math.PI/1.3
genodegda.add(genodegda_remoda3)
const genodegda_remoda4 = new THREE.Mesh(geometry, material1)
genodegda_remoda4.position.set(66.187, 1, -1.393)
genodegda_remoda4.scale.set(2, 2, 1)
genodegda_remoda4.rotation.y = Math.PI/3.9
genodegda.add(genodegda_remoda4)
const genodegda_remoda5 = new THREE.Mesh(geometry, material1)
genodegda_remoda5.position.set(66.65, 1, -5.3)
genodegda_remoda5.scale.set(2, 2, 1)
genodegda_remoda5.rotation.y = Math.PI/1.6
genodegda.add(genodegda_remoda5)
const genodegda_remoda6 = new THREE.Mesh(geometry, material1)
genodegda_remoda6.position.set(66.65, 1, -2.1)
genodegda_remoda6.scale.set(2, 2, 1)
genodegda_remoda6.rotation.y = Math.PI/3.2
genodegda.add(genodegda_remoda6)


// Мужская одежда
// Планета джинсов 
const planeta_d_mug = new THREE.Mesh(geometry, material1)
planeta_d_mug.position.set(13.45, 1, -5.4)
planeta_d_mug.scale.set(8.9, 2, 3)
mugodegda.add(planeta_d_mug)
// Фамилия
const familiya1_mug = new THREE.Mesh(geometry, material1)
familiya1_mug.position.set(-15.8, 1, 23.85)
familiya1_mug.scale.set(5.8, 2, 10.6)
mugodegda.add(familiya1_mug)
const familiya2_mug = new THREE.Mesh(geometry, material1)
familiya2_mug.position.set(-22.1, 1, 13.75)
familiya2_mug.scale.set(7.3, 2, 5.8)
mugodegda.add(familiya2_mug)
const familiya3_mug = new THREE.Mesh(geometry, material1)
familiya3_mug.position.set(-24.3, 1, 22.9)
familiya3_mug.scale.set(11.65, 2, 12.5)
mugodegda.add(familiya3_mug)
// Дом одежда обувь
const mugodegda_dom_odegda = new THREE.Mesh(geometry, material1)
mugodegda_dom_odegda.position.set(-50.37, 1, 24.73)
mugodegda_dom_odegda.scale.set(27, 2, 12.44)
mugodegda.add(mugodegda_dom_odegda)
const mugodegda_dom_odegda1 = new THREE.Mesh(geometry, material1)
mugodegda_dom_odegda1.position.set(-51.42, 1, 16.68)
mugodegda_dom_odegda1.scale.set(11.44, 2, 3.85)
mugodegda.add(mugodegda_dom_odegda1)
const mugodegda_dom_odegda2 = new THREE.Mesh(geometry, material1)
mugodegda_dom_odegda2.position.set(-57.16, 1, 26.4)
mugodegda_dom_odegda2.scale.set(13.72, 2, 17.84)
mugodegda.add(mugodegda_dom_odegda2)
const mugodegda_dom_odegda3 = new THREE.Mesh(geometry, material1)
mugodegda_dom_odegda3.position.set(-40.75, 1, 26.92)
mugodegda_dom_odegda3.scale.set(8.12, 2, 16.78)
mugodegda.add(mugodegda_dom_odegda3)
// Senator
const mugodegda_senator = new THREE.Mesh(geometry, material1)
mugodegda_senator.position.set(47.64, 1, -12.95)
mugodegda_senator.scale.set(6.6, 2, 1.9)
mugodegda.add(mugodegda_senator)
const mugodegda_senator1 = new THREE.Mesh(geometry5, material1)
mugodegda_senator1.position.set(44.1, 1, -12.95)
mugodegda_senator1.scale.set(-0.416, 1.732, -1.645)
mugodegda.add(mugodegda_senator1)
// Lacarino
const mugodegda_lacarino = new THREE.Mesh(geometry, material1)
mugodegda_lacarino.position.set(45.42, 1, 5.79)
mugodegda_lacarino.scale.set(3.98, 2, 2.8)
mugodegda.add(mugodegda_lacarino)
const mugodegda_lacarino1 = new THREE.Mesh(geometry5, material1)
mugodegda_lacarino1.position.set(42.82, 1, 5.79)
mugodegda_lacarino1.scale.set(-1.057, 1.732, 2.425)
mugodegda.add(mugodegda_lacarino1)
// Mustang
const mugodegda_mustang = new THREE.Mesh(geometry, material1)
mugodegda_mustang.position.set(47.93, 1, -1.22)
mugodegda_mustang.scale.set(6.16, 2, 4.72)
mugodegda.add(mugodegda_mustang)
const mugodegda_mustang1 = new THREE.Mesh(geometry5, material1)
mugodegda_mustang1.position.set(44.625, 1, -1.22)
mugodegda_mustang1.scale.set(-0.45, 1.732, 4.088)
mugodegda.add(mugodegda_mustang1)
// Savari
const mugodegda_savari = new THREE.Mesh(geometry, material1)
mugodegda_savari.position.set(38.46, 1, -3.88)
mugodegda_savari.scale.set(6.28, 2, 3.56)
mugodegda.add(mugodegda_savari)
const mugodegda_savari1 = new THREE.Mesh(geometry5, material1)
mugodegda_savari1.position.set(41.7, 1, -3.88)
mugodegda_savari1.scale.set(0.1732, 1.732, -3.083)
mugodegda.add(mugodegda_savari1)
// Джинсовый микс
const mugodegda_dgins_miks = new THREE.Mesh(geometry, material1)
mugodegda_dgins_miks.position.set(2.62, 1, 4.35)
mugodegda_dgins_miks.scale.set(3.4, 2, 1.05)
mugodegda.add(mugodegda_dgins_miks)
// Лидер 
const mugodegda_lider = new THREE.Mesh(geometry, material1)
mugodegda_lider.position.set(2.62, 1, 2.15)
mugodegda_lider.scale.set(3.4, 2, 1.05)
mugodegda.add(mugodegda_lider)
// Man Style
const mugodegda_manstyle = new THREE.Mesh(geometry, material1)
mugodegda_manstyle.position.set(-15.6, 1, 14.65)
mugodegda_manstyle.scale.set(5.5, 2, 7.6)
mugodegda.add(mugodegda_manstyle)
// Millioner
const mugodegda_millioner = new THREE.Mesh(geometry, material1)
mugodegda_millioner.position.set(-28.8, 1, 3)
mugodegda_millioner.scale.set(3.1, 2, 9.8)
mugodegda.add(mugodegda_millioner)
// Фабрика костюма
const mugodegda_fabrika_kostuma = new THREE.Mesh(geometry, material1)
mugodegda_fabrika_kostuma.position.set(56.4, 1, 15.13)
mugodegda_fabrika_kostuma.scale.set(1.91, 2, 3.91)
mugodegda.add(mugodegda_fabrika_kostuma)
// Oodji
const mugodegda_oodji = new THREE.Mesh(geometry, material1)
mugodegda_oodji.position.set(56.55, 1, -10.23)
mugodegda_oodji.scale.set(11.04, 2, 3.4)
mugodegda.add(mugodegda_oodji)
const mugodegda_oodji1 = new THREE.Mesh(geometry, material1)
mugodegda_oodji1.position.set(58.94, 1, -9.13)
mugodegda_oodji1.scale.set(6.3, 2, 5.6)
mugodegda.add(mugodegda_oodji1)
const mugodegda_oodji2 = new THREE.Mesh(geometry, material1)
mugodegda_oodji2.position.set(58.13, 1, -4.99)
mugodegda_oodji2.scale.set(4.68, 2, 2.68)
mugodegda.add(mugodegda_oodji2)
const mugodegda_oodji3 = new THREE.Mesh(geometry5, material1)
mugodegda_oodji3.position.set(61.24, 1, -5.53)
mugodegda_oodji3.scale.set(1.472, 1.732, -1.386)
mugodegda.add(mugodegda_oodji3)
const mugodegda_oodji4 = new THREE.Mesh(geometry5, material1)
mugodegda_oodji4.position.set(60.95, 1, -5.33)
mugodegda_oodji4.scale.set(0.9, 1.732, -2.321)
mugodegda.add(mugodegda_oodji4)
// Egoiste
const mugodegda_egoiste = new THREE.Mesh(geometry, material1)
mugodegda_egoiste.position.set(66.54, 1, -14.48)
mugodegda_egoiste.scale.set(2.7, 2, 8.55)
mugodegda.add(mugodegda_egoiste)
// Gloria Jeans
const mugodegda_gloria_jeans = new THREE.Mesh(geometry, material1)
mugodegda_gloria_jeans.position.set(70.25, 1, -31.58)
mugodegda_gloria_jeans.scale.set(6.8, 2, 9.15)
mugodegda.add(mugodegda_gloria_jeans)
// Tekbir
const mugodegda_tekbir = new THREE.Mesh(geometry, material1)
mugodegda_tekbir.position.set(-24.45, 1, 4.8)
mugodegda_tekbir.scale.set(2.32, 2, 6.2)
mugodegda.add(mugodegda_tekbir)
// AVVA
const mugodegda_avva_ = new THREE.Mesh(geometry, material1)
mugodegda_avva_.position.set(60.88, 1, -14.6)
mugodegda_avva_.scale.set(2.4, 2, 5.16)
mugodegda.add(mugodegda_avva_)
const mugodegda_avva_1 = new THREE.Mesh(geometry, material1)
mugodegda_avva_1.position.set(58.89, 1, -12.87)
mugodegda_avva_1.scale.set(6.38, 2, 1.72)
mugodegda.add(mugodegda_avva_1)
// Remoda
const mugodegda_remoda = new THREE.Mesh(geometry, material1)
mugodegda_remoda.position.set(70.03, 1, -3.535)
mugodegda_remoda.scale.set(6.96, 2, 6.71)
mugodegda.add(mugodegda_remoda)
const mugodegda_remoda1 = new THREE.Mesh(geometry, material1)
mugodegda_remoda1.position.set(66.06, 1, -6.5)
mugodegda_remoda1.scale.set(1.85, 2, 0.78)
mugodegda.add(mugodegda_remoda1)
const mugodegda_remoda2 = new THREE.Mesh(geometry, material1)
mugodegda_remoda2.position.set(66.06, 1, -0.6)
mugodegda_remoda2.scale.set(1.85, 2, 0.84)
mugodegda.add(mugodegda_remoda2)
const mugodegda_remoda3 = new THREE.Mesh(geometry, material1)
mugodegda_remoda3.position.set(66.2153, 1, -5.82)
mugodegda_remoda3.scale.set(2, 2, 1)
mugodegda_remoda3.rotation.y = Math.PI/1.3
mugodegda.add(mugodegda_remoda3)
const mugodegda_remoda4 = new THREE.Mesh(geometry, material1)
mugodegda_remoda4.position.set(66.187, 1, -1.393)
mugodegda_remoda4.scale.set(2, 2, 1)
mugodegda_remoda4.rotation.y = Math.PI/3.9
mugodegda.add(mugodegda_remoda4)
const mugodegda_remoda5 = new THREE.Mesh(geometry, material1)
mugodegda_remoda5.position.set(66.65, 1, -5.3)
mugodegda_remoda5.scale.set(2, 2, 1)
mugodegda_remoda5.rotation.y = Math.PI/1.6
mugodegda.add(mugodegda_remoda5)
const mugodegda_remoda6 = new THREE.Mesh(geometry, material1)
mugodegda_remoda6.position.set(66.65, 1, -2.1)
mugodegda_remoda6.scale.set(2, 2, 1)
mugodegda_remoda6.rotation.y = Math.PI/3.2
mugodegda.add(mugodegda_remoda6)
// Хулиган
const mugodegda_huligan_ = new THREE.Mesh(geometry, material1)
mugodegda_huligan_.position.set(14.88, 1, -8.06)
mugodegda_huligan_.scale.set(6.04, 2, 2.12)
mugodegda.add(mugodegda_huligan_)

// Обувь
// Обувной квартал 
const kvartal_ob = new THREE.Mesh(geometry, material1)
kvartal_ob.position.set(13.45, 1, -2.25)
kvartal_ob.scale.set(8.9, 2, 3)
obuv.add(kvartal_ob)
const cylinder = new THREE.Mesh(geometry2, material1)
cylinder.position.set(17.8, 1, -1.75)
cylinder.scale.set(0.7, 2, 2)
cylinder.rotation.set(0, 3.1, 0)
obuv.add(cylinder)
// Фамилия
const familiya1_ob = new THREE.Mesh(geometry, material1)
familiya1_ob.position.set(-15.8, 1, 23.85)
familiya1_ob.scale.set(5.8, 2, 10.6)
obuv.add(familiya1_ob)
const familiya2_ob = new THREE.Mesh(geometry, material1)
familiya2_ob.position.set(-22.1, 1, 13.75)
familiya2_ob.scale.set(7.3, 2, 5.8)
obuv.add(familiya2_ob)
const familiya3_ob = new THREE.Mesh(geometry, material1)
familiya3_ob.position.set(-24.3, 1, 22.9)
familiya3_ob.scale.set(11.65, 2, 12.5)
obuv.add(familiya3_ob)
// Мир обуви
const obuv_mir_obivi = new THREE.Mesh(geometry, material1)
obuv_mir_obivi.position.set(82.24, 1, 27.83)
obuv_mir_obivi.scale.set(4.98, 2, 2.28)
obuv.add(obuv_mir_obivi)
const obuv_mir_obivi1 = new THREE.Mesh(geometry, material1)
obuv_mir_obivi1.position.set(81.92, 1, 25.6)
obuv_mir_obivi1.scale.set(4.34, 2, 2.24)
obuv.add(obuv_mir_obivi1)
const obuv_mir_obivi2 = new THREE.Mesh(geometry5, material1)
obuv_mir_obivi2.position.set(81.34, 1, 21.86)
obuv_mir_obivi2.scale.set(4.763, 1.732, 4.538)
obuv.add(obuv_mir_obivi2)
const obuv_mir_obivi3 = new THREE.Mesh(geometry, material1)
obuv_mir_obivi3.position.set(79.23, 1, 24.48)
obuv_mir_obivi3.scale.set(1.28, 2, 1.28)
obuv.add(obuv_mir_obivi3)
// Дом одежда обувь
const obuv_dom_odegda = new THREE.Mesh(geometry, material1)
obuv_dom_odegda.position.set(-50.37, 1, 24.73)
obuv_dom_odegda.scale.set(27, 2, 12.44)
obuv.add(obuv_dom_odegda)
const obuv_dom_odegda1 = new THREE.Mesh(geometry, material1)
obuv_dom_odegda1.position.set(-51.42, 1, 16.68)
obuv_dom_odegda1.scale.set(11.44, 2, 3.85)
obuv.add(obuv_dom_odegda1)
const obuv_dom_odegda2 = new THREE.Mesh(geometry, material1)
obuv_dom_odegda2.position.set(-57.16, 1, 26.4)
obuv_dom_odegda2.scale.set(13.72, 2, 17.84)
obuv.add(obuv_dom_odegda2)
const obuv_dom_odegda3 = new THREE.Mesh(geometry, material1)
obuv_dom_odegda3.position.set(-40.75, 1, 26.92)
obuv_dom_odegda3.scale.set(8.12, 2, 16.78)
obuv.add(obuv_dom_odegda3)
// Das Gut
const obuv_das_gut = new THREE.Mesh(geometry, material1)
obuv_das_gut.position.set(71.63, 1, 6)
obuv_das_gut.scale.set(3.8, 2, 4.45)
obuv.add(obuv_das_gut)
const obuv_das_gut1 = new THREE.Mesh(geometry, material1)
obuv_das_gut1.position.set(72.12, 1, 9.13)
obuv_das_gut1.scale.set(2.82, 2, 2.2)
obuv.add(obuv_das_gut1)
// Berkonty
const obuv_berkonty = new THREE.Mesh(geometry, material1)
obuv_berkonty.position.set(53.57, 1, 3.84)
obuv_berkonty.scale.set(4.99, 2, 5.26)
obuv.add(obuv_berkonty)
const obuv_berkonty1 = new THREE.Mesh(geometry, material1)
obuv_berkonty1.position.set(52.98, 1, 8.34)
obuv_berkonty1.scale.set(3.81, 2, 3.88)
obuv.add(obuv_berkonty1)
// Senator
const obuv_senator = new THREE.Mesh(geometry, material1)
obuv_senator.position.set(47.64, 1, -12.95)
obuv_senator.scale.set(6.6, 2, 1.9)
obuv.add(obuv_senator)
const obuv_senator1 = new THREE.Mesh(geometry5, material1)
obuv_senator1.position.set(44.1, 1, -12.95)
obuv_senator1.scale.set(-0.416, 1.732, -1.645)
obuv.add(obuv_senator1)
// Lacarino Woman
const obuv_lacarino_woman = new THREE.Mesh(geometry, material1)
obuv_lacarino_woman.position.set(45.88, 1, 2.76)
obuv_lacarino_woman.scale.set(3.06, 2, 3.1)
obuv.add(obuv_lacarino_woman)
const obuv_lacarino_woman1 = new THREE.Mesh(geometry5, material1)
obuv_lacarino_woman1.position.set(43.91, 1, 2.76)
obuv_lacarino_woman1.scale.set(-0.762, 1.732, 2.685)
obuv.add(obuv_lacarino_woman1)
// Lacarino
const obuv_lacarino = new THREE.Mesh(geometry, material1)
obuv_lacarino.position.set(45.42, 1, 5.79)
obuv_lacarino.scale.set(3.98, 2, 2.8)
obuv.add(obuv_lacarino)
const obuv_lacarino1 = new THREE.Mesh(geometry5, material1)
obuv_lacarino1.position.set(42.82, 1, 5.79)
obuv_lacarino1.scale.set(-1.057, 1.732, 2.425)
obuv.add(obuv_lacarino1)
// Mustang
const obuv_mustang = new THREE.Mesh(geometry, material1)
obuv_mustang.position.set(47.93, 1, -1.22)
obuv_mustang.scale.set(6.16, 2, 4.72)
obuv.add(obuv_mustang)
const obuv_mustang1 = new THREE.Mesh(geometry5, material1)
obuv_mustang1.position.set(44.625, 1, -1.22)
obuv_mustang1.scale.set(-0.45, 1.732, 4.088)
obuv.add(obuv_mustang1)
// Savari
const obuv_savari = new THREE.Mesh(geometry, material1)
obuv_savari.position.set(38.46, 1, -3.88)
obuv_savari.scale.set(6.28, 2, 3.56)
obuv.add(obuv_savari)
const obuv_savari1 = new THREE.Mesh(geometry5, material1)
obuv_savari1.position.set(41.7, 1, -3.88)
obuv_savari1.scale.set(0.1732, 1.732, -3.083)
obuv.add(obuv_savari1)
// София
const obuv_sofiya = new THREE.Mesh(geometry, material1)
obuv_sofiya.position.set(24.23, 1, -3.45)
obuv_sofiya.scale.set(4.94, 2, 6.12)
obuv.add(obuv_sofiya)
const obuv_sofiya1 = new THREE.Mesh(geometry, material1)
obuv_sofiya1.position.set(21.43, 1, -4.83)
obuv_sofiya1.scale.set(0.66, 2, 3.36)
obuv.add(obuv_sofiya1)
const obuv_sofiya2 = new THREE.Mesh(geometry5, material1)
obuv_sofiya2.position.set(21.43, 1, -1.77)
obuv_sofiya2.scale.set(-0.572, 1.732, -2.39)
obuv.add(obuv_sofiya2)
// Best
const obuv_best = new THREE.Mesh(geometry, material1)
obuv_best.position.set(11.65, 1, -24.85)
obuv_best.scale.set(3, 2, 2.9)
obuv.add(obuv_best)
// Джинсовый микс
const obuv_dgins_miks = new THREE.Mesh(geometry, material1)
obuv_dgins_miks.position.set(2.62, 1, 4.35)
obuv_dgins_miks.scale.set(3.4, 2, 1.05)
obuv.add(obuv_dgins_miks)
// Лидер 
const obuv_lider = new THREE.Mesh(geometry, material1)
obuv_lider.position.set(2.62, 1, 2.15)
obuv_lider.scale.set(3.4, 2, 1.05)
obuv.add(obuv_lider)
// Salsa
const obuv_salsa = new THREE.Mesh(geometry, material1)
obuv_salsa.position.set(-22.1, 1, 4.15)
obuv_salsa.scale.set(2.2, 2, 7.5)
obuv.add(obuv_salsa)
// Man Style
const obuv_manstyle = new THREE.Mesh(geometry, material1)
obuv_manstyle.position.set(-15.6, 1, 14.65)
obuv_manstyle.scale.set(5.5, 2, 7.6)
obuv.add(obuv_manstyle)
// Millioner
const obuv_millioner = new THREE.Mesh(geometry, material1)
obuv_millioner.position.set(-28.8, 1, 3)
obuv_millioner.scale.set(3.1, 2, 9.8)
obuv.add(obuv_millioner)
// Monro
const obuv_monro = new THREE.Mesh(geometry, material1)
obuv_monro.position.set(49.25, 1, 4.36)
obuv_monro.scale.set(3.52, 2, 6.28)
obuv.add(obuv_monro)
const obuv_monro1 = new THREE.Mesh(geometry, material1)
obuv_monro1.position.set(48.54, 1, 8.79)
obuv_monro1.scale.set(2.1, 2, 3)
obuv.add(obuv_monro1)
// Фабрика костюма
const obuv_fabrika_kostuma = new THREE.Mesh(geometry, material1)
obuv_fabrika_kostuma.position.set(56.4, 1, 15.13)
obuv_fabrika_kostuma.scale.set(1.91, 2, 3.91)
obuv.add(obuv_fabrika_kostuma)
// Кредо
const obuv_kredo = new THREE.Mesh(geometry, material1)
obuv_kredo.position.set(67.4, 1, 7.6)
obuv_kredo.scale.set(4.5, 2, 1.25)
obuv.add(obuv_kredo)
// Oodji
const obuv_oodji = new THREE.Mesh(geometry, material1)
obuv_oodji.position.set(56.55, 1, -10.23)
obuv_oodji.scale.set(11.04, 2, 3.4)
obuv.add(obuv_oodji)
const obuv_oodji1 = new THREE.Mesh(geometry, material1)
obuv_oodji1.position.set(58.94, 1, -9.13)
obuv_oodji1.scale.set(6.3, 2, 5.6)
obuv.add(obuv_oodji1)
const obuv_oodji2 = new THREE.Mesh(geometry, material1)
obuv_oodji2.position.set(58.13, 1, -4.99)
obuv_oodji2.scale.set(4.68, 2, 2.68)
obuv.add(obuv_oodji2)
const obuv_oodji3 = new THREE.Mesh(geometry5, material1)
obuv_oodji3.position.set(61.24, 1, -5.53)
obuv_oodji3.scale.set(1.472, 1.732, -1.386)
obuv.add(obuv_oodji3)
const obuv_oodji4 = new THREE.Mesh(geometry5, material1)
obuv_oodji4.position.set(60.95, 1, -5.33)
obuv_oodji4.scale.set(0.9, 1.732, -2.321)
obuv.add(obuv_oodji4)
// Egoiste
const obuv_egoiste = new THREE.Mesh(geometry, material1)
obuv_egoiste.position.set(66.54, 1, -14.48)
obuv_egoiste.scale.set(2.7, 2, 8.55)
obuv.add(obuv_egoiste)
// Best Shoes
const obuv_best_shoes = new THREE.Mesh(geometry, material1)
obuv_best_shoes.position.set(46.76, 1, -17.03)
obuv_best_shoes.scale.set(2.44, 2, 6.14)
obuv.add(obuv_best_shoes)
// Тофа
const obuv_tofa = new THREE.Mesh(geometry, material1)
obuv_tofa.position.set(93, 1, 19.8)
obuv_tofa.scale.set(4.05, 2, 5.15)
obuv.add(obuv_tofa)
// Gloria Jeans
const obuv_gloria_jeans = new THREE.Mesh(geometry, material1)
obuv_gloria_jeans.position.set(70.25, 1, -31.58)
obuv_gloria_jeans.scale.set(6.8, 2, 9.15)
obuv.add(obuv_gloria_jeans)
// Garnet
const obuv_garnet = new THREE.Mesh(geometry, material1)
obuv_garnet.position.set(16.94, 1, -12.93)
obuv_garnet.scale.set(2.72, 2, 2.98)
obuv.add(obuv_garnet)
const obuv_garnet1 = new THREE.Mesh(geometry5, material1)
obuv_garnet1.position.set(18.75, 1, -12.93)
obuv_garnet1.scale.set(0.78, 1.732, -2.5805)
obuv.add(obuv_garnet1)
// Магия моды 
const obuv_magiya_mody = new THREE.Mesh(geometry, material1)
obuv_magiya_mody.position.set(14.88, 1, -10.28)
obuv_magiya_mody.scale.set(6.04, 2, 2.12)
obuv.add(obuv_magiya_mody)
const obuv_magiya_mody1 = new THREE.Mesh(geometry5, material1)
obuv_magiya_mody1.position.set(18.1, 1, -10.28)
obuv_magiya_mody1.scale.set(0.347, 1.732, -1.836)
obuv.add(obuv_magiya_mody1)
// РосПромОбувь
const obuv_rospromobuv = new THREE.Mesh(geometry, material1)
obuv_rospromobuv.position.set(-17.15, 1, -15.8)
obuv_rospromobuv.scale.set(8.5, 2, 8.8)
obuv.add(obuv_rospromobuv)
// Masis
const obuv_masis = new THREE.Mesh(geometry, material1)
obuv_masis.position.set(-39.39, 1, 16.58)
obuv_masis.scale.set(1.54, 2, 3.65)
obuv.add(obuv_masis)
// Fashion Shoes
const obuv_fashion_shoes = new THREE.Mesh(geometry, material1)
obuv_fashion_shoes.position.set(7.4, 1, 4.1)
obuv_fashion_shoes.scale.set(2.95, 2, 7.1)
obuv.add(obuv_fashion_shoes)
const obuv_fashion_shoes1 = new THREE.Mesh(geometry, material1)
obuv_fashion_shoes1.position.set(5.44, 1, 2.71)
obuv_fashion_shoes1.scale.set(2.02, 2, 4.32)
obuv.add(obuv_fashion_shoes1)
// Joss
const obuv_joss = new THREE.Mesh(geometry, material1)
obuv_joss.position.set(-37.61, 1, 16.58)
obuv_joss.scale.set(1.86, 2, 3.65)
obuv.add(obuv_joss)
const obuv_joss1 = new THREE.Mesh(geometry5, material1)
obuv_joss1.position.set(-37.43, 1, 13.955)
obuv_joss1.scale.set(-1.299, 1.732, 1.386)
obuv.add(obuv_joss1)
// Бывший Monro теперь Francesco Donni
const vse_obuv = new THREE.Mesh(geometry, mat_vse)
vse_obuv.position.set(49.25, 1, 4.36)
vse_obuv.scale.set(3.52, 2, 6.28)
vse.add(vse_obuv)
const vse_obuv1 = new THREE.Mesh(geometry, mat_vse)
vse_obuv1.position.set(48.54, 1, 8.79)
vse_obuv1.scale.set(2.1, 2, 3)
vse.add(vse_monro1)


// Продукты питания
// Fix Price
const fix_price = new THREE.Mesh(geometry, material1)
fix_price.position.set(45.24, 1, 32.85)
fix_price.scale.set(3.65, 2, 5.52)
produkty.add(fix_price)
// АШАН
const produkty_ashan = new THREE.Mesh(geometry, material1)
produkty_ashan.position.set(94, 1, -9.55)
produkty_ashan.scale.set(28.5, 2, 53.25)
produkty.add(produkty_ashan)
// Кофе и чай
const produkty_kofe_chay = new THREE.Mesh(geometry, material1)
produkty_kofe_chay.position.set(75, 1, 2.68)
produkty_kofe_chay.scale.set(2.8, 2, 2)
produkty.add(produkty_kofe_chay)
// Восточные сладости
const produkty_vost_sladosti = new THREE.Mesh(geometry5, material1)
produkty_vost_sladosti.position.set(74.7, 1, 9.12)
produkty_vost_sladosti.scale.set(1.732, 1.732, 1.9)
produkty_vost_sladosti.rotation.y = -Math.PI/2
produkty.add(produkty_vost_sladosti)
// Восточные сладости
const produkty_vostok_sladosti = new THREE.Mesh(geometry, material1)
produkty_vostok_sladosti.position.set(39.33, 1, 33.61)
produkty_vostok_sladosti.scale.set(7.96, 2, 1.98)
produkty.add(produkty_vostok_sladosti)
const produkty_vostok_sladosti1 = new THREE.Mesh(geometry, material1)
produkty_vostok_sladosti1.position.set(42.46, 1, 34.13)
produkty_vostok_sladosti1.scale.set(1.7, 2, 3.02)
produkty.add(produkty_vostok_sladosti1)
// ФермStore
const produkty_fermstore = new THREE.Mesh(geometry, material1)
produkty_fermstore.position.set(27.84, 1, 34.33)
produkty_fermstore.scale.set(0.7, 2, 3.64)
produkty.add(produkty_fermstore)
const produkty_fermstore1 = new THREE.Mesh(geometry, material1)
produkty_fermstore1.position.set(28.49, 1, 34.95)
produkty_fermstore1.scale.set(2, 2, 2.4)
produkty.add(produkty_fermstore1)
const produkty_fermstore2 = new THREE.Mesh(geometry5, material1)
produkty_fermstore2.position.set(28.84, 1, 33.13)
produkty_fermstore2.scale.set(1.126, 1.732, 1.074)
produkty.add(produkty_fermstore2)
// Ещё
const produkty_esche = new THREE.Mesh(geometry, material1)
produkty_esche.position.set(-4.8, 1, -10.25)
produkty_esche.scale.set(5.2, 2, 2.1)
produkty.add(produkty_esche)
const produkty_pusto23 = new THREE.Mesh(geometry, material1)
produkty_pusto23.position.set(-4.8, 1, -8.06)
produkty_pusto23.scale.set(5.2, 2, 2.32)
produkty.add(produkty_pusto23)
const produkty_pusto31 = new THREE.Mesh(geometry, material1)
produkty_pusto31.position.set(-4.8, 1, -6.62)
produkty_pusto31.scale.set(5.2, 2, 0.6)
produkty.add(produkty_pusto31)
const produkty_pusto31_1 = new THREE.Mesh(geometry, material1)
produkty_pusto31_1.position.set(-5.44, 1, -5.72)
produkty_pusto31_1.scale.set(3.92, 2, 2.4)
produkty.add(produkty_pusto31_1)
const produkty_pusto31_2 = new THREE.Mesh(geometry5, material1)
produkty_pusto31_2.position.set(-3.16, 1, -5.42)
produkty_pusto31_2.scale.set(0.554, 1.732, -1.559)
produkty.add(produkty_pusto31_2)
const produkty_pusto31_3 = new THREE.Mesh(geometry5, material1)
produkty_pusto31_3.position.set(-2.84, 1, -5.87)
produkty_pusto31_3.scale.set(1.108, 1.732, -0.779)
produkty.add(produkty_pusto31_3)
const produkty_pusto30 = new THREE.Mesh(geometry, material1)
produkty_pusto30.position.set(-5.44, 1, -3.45)
produkty_pusto30.scale.set(3.92, 2, 2.24)
produkty.add(produkty_pusto30)
// ММ декор
const produkty_mm_dekor = new THREE.Mesh(geometry, material1)
produkty_mm_dekor.position.set(-4.8, 1, -0.53)
produkty_mm_dekor.scale.set(5.2, 2, 0.5)
produkty.add(produkty_mm_dekor)
const produkty_mm_dekor1 = new THREE.Mesh(geometry, material1)
produkty_mm_dekor1.position.set(-5.44, 1, -1.32)
produkty_mm_dekor1.scale.set(3.92, 2, 2.08)
produkty.add(produkty_mm_dekor1)
const produkty_mm_dekor2 = new THREE.Mesh(geometry5, material1)
produkty_mm_dekor2.position.set(-3.16, 1, -1.57)
produkty_mm_dekor2.scale.set(0.554, 1.732, 1.368)
produkty.add(produkty_mm_dekor2)
const produkty_mm_dekor3 = new THREE.Mesh(geometry5, material1)
produkty_mm_dekor3.position.set(-2.84, 1, -1.175)
produkty_mm_dekor3.scale.set(1.108, 1.732, 0.684)
produkty.add(produkty_mm_dekor3)
// Хулиган
const produkty_huligan = new THREE.Mesh(geometry, material1)
produkty_huligan.position.set(-4.8, 1, 0.6)
produkty_huligan.scale.set(5.2, 2, 1.8)
produkty.add(produkty_huligan)
// Ковровый центр
const produkty_kovr_centr = new THREE.Mesh(geometry, material1)
produkty_kovr_centr.position.set(-4.8, 1, 3.25)
produkty_kovr_centr.scale.set(5.2, 2, 3.7)
produkty.add(produkty_kovr_centr)
// Пусто 29
const produkty_pusto29 = new THREE.Mesh(geometry, material1)
produkty_pusto29.position.set(-4.8, 1, 5.74)
produkty_pusto29.scale.set(5.2, 2, 1.32)
produkty.add(produkty_pusto29)
const produkty_pusto29_1 = new THREE.Mesh(geometry, material1)
produkty_pusto29_1.position.set(-5.4, 1, 6.46)
produkty_pusto29_1.scale.set(4, 2, 2.76)
produkty.add(produkty_pusto29_1)
const produkty_pusto29_2 = new THREE.Mesh(geometry5, material1)
produkty_pusto29_2.position.set(-2.8, 1, 7.12)
produkty_pusto29_2.scale.set(1.039, 1.732, -1.247)
produkty.add(produkty_pusto29_2)
// Чижик
const produkty_chigik = new THREE.Mesh(geometry, material1)
produkty_chigik.position.set(22.1, 1, 33.19)
produkty_chigik.scale.set(10.6, 2, 5.92)
produkty.add(produkty_chigik)
const produkty_chigik1 = new THREE.Mesh(geometry, material1)
produkty_chigik1.position.set(20.45, 1, 37.21)
produkty_chigik1.scale.set(7.3, 2, 3.84)
produkty.add(produkty_chigik1)
// Склад ВкуссВил
const produkty_vkussvil = new THREE.Mesh(geometry, material1)
produkty_vkussvil.position.set(-0.46, 1, 32.24)
produkty_vkussvil.scale.set(24.58, 2, 6.1)
produkty.add(produkty_vkussvil)

// Развлечения
// Скалалэнд
const skalalend = new THREE.Mesh(geometry, material1)
skalalend.position.set(-17.14, 1, -30.08)
skalalend.scale.set(17.56, 2, 6.63)
razvlechenie.add(skalalend)
const skalalend1 = new THREE.Mesh(geometry, material1)
skalalend1.position.set(-17.35, 1, -25.275)
skalalend1.scale.set(8.7, 2, 3.9)
razvlechenie.add(skalalend1)
const skalalend2 = new THREE.Mesh(geometry, material1)
skalalend2.position.set(-23.72, 1, -26.14)
skalalend2.scale.set(4.4, 2, 3.46)
razvlechenie.add(skalalend2)
const skalalend3 = new THREE.Mesh(geometry, material1)
skalalend3.position.set(-23.487, 1, -25.08)
skalalend3.scale.set(4.355, 2, 2.5)
skalalend3.rotation.y = Math.PI/1.088
razvlechenie.add(skalalend3)
// Warpoint
const warpoint = new THREE.Mesh(geometry, material1)
warpoint.position.set(-29.67, 1, -5.22)
warpoint.scale.set(7.46, 2, 6.55)
razvlechenie.add(warpoint)
const warpoint1 = new THREE.Mesh(geometry, material1)
warpoint1.position.set(-28.06, 1, -12.51)
warpoint1.scale.set(4.21, 2, 8.4)
razvlechenie.add(warpoint1)
const warpoint2 = new THREE.Mesh(geometry, material1)
warpoint2.position.set(-24.95, 1, -15.75)
warpoint2.scale.set(2.09, 2, 8.73)
razvlechenie.add(warpoint2)
const warpoint3 = new THREE.Mesh(geometry, material1)
warpoint3.position.set(-33.33, 1, -7.69)
warpoint3.scale.set(2.6, 2, 1.6)
razvlechenie.add(warpoint3)
const warpoint4 = new THREE.Mesh(geometry5, material1)
warpoint4.position.set(-28.079, 1, -18.412)
warpoint4.scale.set(2.95, 1.732, 3.62)
warpoint4.rotation.y = Math.PI/2
razvlechenie.add(warpoint4)
const warpoint5 = new THREE.Mesh(geometry, material1)
warpoint5.position.set(-33.132, 1, -6.618)
warpoint5.scale.set(2.3, 2, 2)
warpoint5.rotation.y = Math.PI/1.4
razvlechenie.add(warpoint5)
// Хали Гали
const razvlechenie_hali_gali = new THREE.Mesh(geometry, material1)
razvlechenie_hali_gali.position.set(-66.64, 1, 32.2)
razvlechenie_hali_gali.scale.set(5.12, 2, 6.26)
razvlechenie.add(razvlechenie_hali_gali)
const razvlechenie_hali_gali1 = new THREE.Mesh(geometry, material1)
razvlechenie_hali_gali1.position.set(-68.29, 1, 33.85)
razvlechenie_hali_gali1.scale.set(8.42, 2, 3.03)
razvlechenie.add(razvlechenie_hali_gali1)


// Салоны связи
// Билайн
const beelain = new THREE.Mesh(geometry, material1)
beelain.position.set(41.7, 1, 15.13)
beelain.scale.set(2.15, 2, 3.91)
svyaz.add(beelain)
// МТС
const mts = new THREE.Mesh(geometry, material1)
mts.position.set(58.3, 1, 15.13)
mts.scale.set(1.6, 2, 3.91)
svyaz.add(mts)
// мтс 
const svyaz_mts1 = new THREE.Mesh(geometry5, material1)
svyaz_mts1.position.set(75, 1, -17.26)
svyaz_mts1.scale.set(2.5, 1.74, 2.5)
svyaz.add(svyaz_mts1)
// Мегафон
const megafon = new THREE.Mesh(geometry, material1)
megafon.position.set(39.05, 1, 18.5)
megafon.scale.set(7.4, 2, 2.6)
svyaz.add(megafon)
// Tele2
const svyaz_tele2 = new THREE.Mesh(geometry, material1)
svyaz_tele2.position.set(75, 1, 6.74)
svyaz_tele2.scale.set(2.8, 2, 1.68)
svyaz.add(svyaz_tele2)
const svyaz_tele21 = new THREE.Mesh(geometry, material1)
svyaz_tele21.position.set(74.72, 1, 7.82)
svyaz_tele21.scale.set(2.24, 2, 0.5)
svyaz.add(svyaz_tele21)
const svyaz_tele22 = new THREE.Mesh(geometry5, material1)
svyaz_tele22.position.set(76.12, 1, 7.824)
svyaz_tele22.scale.set(0.425, 1.732, 0.486)
svyaz_tele22.rotation.y = -Math.PI/2
svyaz.add(svyaz_tele22)
// t2 вместо Corona Store
const svyaz_corona_store1 = new THREE.Mesh(geometry5, material1)
svyaz_corona_store1.position.set(36.765, 0.998, 14.45)
svyaz_corona_store1.scale.set(2.25, 1.735, 2.53)
svyaz_corona_store1.rotation.y = Math.PI/2
svyaz.add(svyaz_corona_store1)
const svyaz_corona_store2 = new THREE.Mesh(geometry, material1)
svyaz_corona_store2.position.set(36.766, 1, 16.419)
svyaz_corona_store2.scale.set(2.93, 2, 1.34)
svyaz.add(svyaz_corona_store2)
// On-связь
const svyaz_svyaz = new THREE.Mesh(geometry, material1)
svyaz_svyaz.position.set(27.75, 1, 25.65)
svyaz_svyaz.scale.set(2.58, 2, 2.63)
svyaz.add(svyaz_svyaz)


// Специализированные магазины
// Фамилия
const specmag_familiya1 = new THREE.Mesh(geometry, material1)
specmag_familiya1.position.set(-15.8, 1, 23.85)
specmag_familiya1.scale.set(5.8, 2, 10.6)
specmag.add(specmag_familiya1)
const specmag_familiya2 = new THREE.Mesh(geometry, material1)
specmag_familiya2.position.set(-22.1, 1, 13.75)
specmag_familiya2.scale.set(7.3, 2, 5.8)
specmag.add(specmag_familiya2)
const specmag_familiya3 = new THREE.Mesh(geometry, material1)
specmag_familiya3.position.set(-24.3, 1, 22.9)
specmag_familiya3.scale.set(11.65, 2, 12.5)
specmag.add(specmag_familiya3)
// Пряжа 
const pryaga = new THREE.Mesh(geometry, material1)
pryaga.position.set(2.62, 1, 1.05)
pryaga.scale.set(3.4, 2, 1.05)
specmag.add(pryaga)
// Fix Price
const specmag_fix_price = new THREE.Mesh(geometry, material1)
specmag_fix_price.position.set(45.24, 1, 32.85)
specmag_fix_price.scale.set(3.65, 2, 5.52)
specmag.add(specmag_fix_price)
// Sweet Cat
const specmag_sweet_cat = new THREE.Mesh(geometry, material1)
specmag_sweet_cat.position.set(25.4, 1, 21.1)
specmag_sweet_cat.scale.set(7.3, 2, 2.2)
specmag.add(specmag_sweet_cat)
// Читай город
const specmag_chitay_gorod = new THREE.Mesh(geometry, material1)
specmag_chitay_gorod.position.set(21.58, 1, 23.98)
specmag_chitay_gorod.scale.set(9.6, 2, 3.4)
specmag.add(specmag_chitay_gorod)
const specmag_chitay_gorod1 = new THREE.Mesh(geometry, material1)
specmag_chitay_gorod1.position.set(27.7, 1, 23.27)
specmag_chitay_gorod1.scale.set(2.7, 2, 2)
specmag.add(specmag_chitay_gorod1)
// Весёленький ассортимент
const specmag_vesel_assortiment = new THREE.Mesh(geometry, material1)
specmag_vesel_assortiment.position.set(2.62, 1, 5.54)
specmag_vesel_assortiment.scale.set(3.4, 2, 1.18)
specmag.add(specmag_vesel_assortiment)
const specmag_vesel_assortiment1 = new THREE.Mesh(geometry, material1)
specmag_vesel_assortiment1.position.set(3.31, 1, 6.91)
specmag_vesel_assortiment1.scale.set(2.02, 2, 1.56)
specmag.add(specmag_vesel_assortiment1)
const specmag_vesel_assortiment2 = new THREE.Mesh(geometry5, material1)
specmag_vesel_assortiment2.position.set(1.61, 1, 6.91)
specmag_vesel_assortiment2.scale.set(-1.195, 1.732, -1.351)
specmag.add(specmag_vesel_assortiment2)
// Живой мир
const specmag_givoy_mir = new THREE.Mesh(geometry, material1)
specmag_givoy_mir.position.set(-53.1, 1, 8.56)
specmag_givoy_mir.scale.set(2.3, 2, 6.9)
specmag.add(specmag_givoy_mir)
// ВсеИнструменты.ру
const specmag_specmaginstrumenty = new THREE.Mesh(geometry, material1)
specmag_specmaginstrumenty.position.set(13.85, 1, 37.25)
specmag_specmaginstrumenty.scale.set(3.92, 2, 3.784)
specmag.add(specmag_specmaginstrumenty)
// Дом посуды
const specmag_dom_posudy = new THREE.Mesh(geometry, material1)
specmag_dom_posudy.position.set(-66.06, 1, 23.68)
specmag_dom_posudy.scale.set(3.96, 2, 3)
specmag.add(specmag_dom_posudy)
const specmag_dom_posudy1 = new THREE.Mesh(geometry5, material1)
specmag_dom_posudy1.position.set(-68.94, 1, 23.68)
specmag_dom_posudy1.scale.set(-1.559, 1.732, 2.598)
specmag.add(specmag_dom_posudy1)
// Хорошие новости
const specmag_horoshie_novosti = new THREE.Mesh(geometry, material1)
specmag_horoshie_novosti.position.set(-80.15, 1, 31.46)
specmag_horoshie_novosti.scale.set(2.58, 2, 1.32)
specmag.add(specmag_horoshie_novosti)
// Церковная лавка
const specmag_lavka = new THREE.Mesh(geometry, material1)
specmag_lavka.position.set(-83.15, 1, 31.46)
specmag_lavka.scale.set(2.58, 2, 1.32)
specmag.add(specmag_lavka)
// S. Holmes
const specmag_s_holmes = new THREE.Mesh(geometry, material1)
specmag_s_holmes.position.set(84.63, 1, 26.11)
specmag_s_holmes.scale.set(1, 2, 1.06)
specmag.add(specmag_s_holmes)
const specmag_s_holmes1 = new THREE.Mesh(geometry5, material1)
specmag_s_holmes1.position.set(84.63, 1, 25.05)
specmag_s_holmes1.scale.set(0.866, 1.732, 0.918)
specmag.add(specmag_s_holmes1)
// Tobacconist
const specmag_tobacconist = new THREE.Mesh(geometry, material1)
specmag_tobacconist.position.set(50.34, 1, 8.94)
specmag_tobacconist.scale.set(1.31, 2, 2.7)
specmag.add(specmag_tobacconist)
// Heart of Vape
const specmag_heart_of_vape = new THREE.Mesh(geometry, material1)
specmag_heart_of_vape.position.set(39.33, 1, 31.31)
specmag_heart_of_vape.scale.set(7.96, 2, 2.48)
specmag.add(specmag_heart_of_vape)
// Сфера дыма
const specmag_sfera_dyma = new THREE.Mesh(geometry, material1)
specmag_sfera_dyma.position.set(-60.88, 1, 10.1)
specmag_sfera_dyma.scale.set(4.26, 2, 3.87)
specmag.add(specmag_sfera_dyma)
const specmag_sfera_dyma1 = new THREE.Mesh(geometry5, material1)
specmag_sfera_dyma1.position.set(-63.51, 1, 10.1)
specmag_sfera_dyma1.scale.set(-0.866, 1.732, 3.351)
specmag.add(specmag_sfera_dyma1)
// DNS Технопоинт
const specmag_dnstehno = new THREE.Mesh(geometry, material1)
specmag_dnstehno.position.set(7.34, 1, 14.7)
specmag_dnstehno.scale.set(5.4, 2, 7.8)
specmag.add(specmag_dnstehno)
const specmaga_dnstehno_2 = new THREE.Mesh(geometry, material1)
specmaga_dnstehno_2.position.set(13.28, 1, 22.15)
specmaga_dnstehno_2.scale.set(6.74, 2, 13.82)
specmag.add(specmaga_dnstehno_2)
const specmaga_dnstehno_1 = new THREE.Mesh(geometry, material1)
specmaga_dnstehno_1.position.set(11.86, 1, 22.02)
specmaga_dnstehno_1.scale.set(9.16, 2, 7.12)
specmag.add(specmaga_dnstehno_1)
const specmaga_dnstehno_3 = new THREE.Mesh(geometry, material1)
specmaga_dnstehno_3.position.set(13.14, 1, 27.26)
specmaga_dnstehno_3.scale.set(7, 2, 3.68)
specmag.add(specmaga_dnstehno_3)
// Ковры
const specmag_kovry_ = new THREE.Mesh(geometry, material1)
specmag_kovry_.position.set(25.56, 1, -16.62)
specmag_kovry_.scale.set(2.18, 2, 6.66)
specmag.add(specmag_kovry_)
const specmag_kovry_1 = new THREE.Mesh(geometry5, material1)
specmag_kovry_1.position.set(23.23, 1, -16.62)
specmag_kovry_1.scale.set(-2.148, 1.732, 5.768)
specmag.add(specmag_kovry_1)
// Фермерские продукты
const specmag_ferma = new THREE.Mesh(geometry, material1)
specmag_ferma.position.set(-82.86, 1, 44)
specmag_ferma.scale.set(3, 2, 6)
specmag.add(specmag_ferma)
// Modi
const specmag_modi = new THREE.Mesh(geometry, material1)
specmag_modi.position.set(25.4, 1, 18.8)
specmag_modi.scale.set(7.3, 2, 2.2)
specmag.add(specmag_modi)
// Хулиган
const specmag_huligan_ = new THREE.Mesh(geometry, material1)
specmag_huligan_.position.set(14.88, 1, -8.06)
specmag_huligan_.scale.set(6.04, 2, 2.12)
specmag.add(specmag_huligan_)
// остров Славянский дом
const specmag_slavdom = new THREE.Mesh(geometry, material1)
specmag_slavdom.position.set(29.9, 1, 12)
specmag_slavdom.scale.set(1.6, 2, 1.5)
specmag.add(specmag_slavdom)


// Спортивные товары
// Дом одежда обувь
const sport_dom_odegda = new THREE.Mesh(geometry, material1)
sport_dom_odegda.position.set(-50.37, 1, 24.73)
sport_dom_odegda.scale.set(27, 2, 12.44)
sport.add(sport_dom_odegda)
const sport_dom_odegda1 = new THREE.Mesh(geometry, material1)
sport_dom_odegda1.position.set(-51.42, 1, 16.68)
sport_dom_odegda1.scale.set(11.44, 2, 3.85)
sport.add(sport_dom_odegda1)
const sport_dom_odegda2 = new THREE.Mesh(geometry, material1)
sport_dom_odegda2.position.set(-57.16, 1, 26.4)
sport_dom_odegda2.scale.set(13.72, 2, 17.84)
sport.add(sport_dom_odegda2)
const sport_dom_odegda3 = new THREE.Mesh(geometry, material1)
sport_dom_odegda3.position.set(-40.75, 1, 26.92)
sport_dom_odegda3.scale.set(8.12, 2, 16.78)
sport.add(sport_dom_odegda3)
// Твой байк
const sport_tvoy_bayk = new THREE.Mesh(geometry, material1)
sport_tvoy_bayk.position.set(58.47, 1, 33.25)
sport_tvoy_bayk.scale.set(5, 2, 4.65)
sport.add(sport_tvoy_bayk)
// Masis
const sport_masis = new THREE.Mesh(geometry, material1)
sport_masis.position.set(-39.39, 1, 16.58)
sport_masis.scale.set(1.54, 2, 3.65)
sport.add(sport_masis)


// Товары для детей
// Стиляги
const dlyadetey_stilyagi = new THREE.Mesh(geometry, material1)
dlyadetey_stilyagi.position.set(-32.5, 1, 5.86)
dlyadetey_stilyagi.scale.set(4.15, 2, 1.36)
dlyadetey.add(dlyadetey_stilyagi)
const dlyadetey_stilyagi_1 = new THREE.Mesh(geometry, material1)
dlyadetey_stilyagi_1.position.set(-31.94, 1, 6.56)
dlyadetey_stilyagi_1.scale.set(3.03, 2, 2.72)
dlyadetey.add(dlyadetey_stilyagi_1)
const dlyadetey_stilyagi_2 = new THREE.Mesh(geometry5, material1)
dlyadetey_stilyagi_2.position.set(-34.015, 1, 7.229)
dlyadetey_stilyagi_2.scale.set(-0.97, 1.732, -1.195)
dlyadetey.add(dlyadetey_stilyagi_2)
// Фамилия
const dlyadetey_familiya1 = new THREE.Mesh(geometry, material1)
dlyadetey_familiya1.position.set(-15.8, 1, 23.85)
dlyadetey_familiya1.scale.set(5.8, 2, 10.6)
dlyadetey.add(dlyadetey_familiya1)
const dlyadetey_familiya2 = new THREE.Mesh(geometry, material1)
dlyadetey_familiya2.position.set(-22.1, 1, 13.75)
dlyadetey_familiya2.scale.set(7.3, 2, 5.8)
dlyadetey.add(dlyadetey_familiya2)
const dlyadetey_familiya3 = new THREE.Mesh(geometry, material1)
dlyadetey_familiya3.position.set(-24.3, 1, 22.9)
dlyadetey_familiya3.scale.set(11.65, 2, 12.5)
dlyadetey.add(dlyadetey_familiya3)
// Дом одежда обувь
const dlyadetey_dom_odegda = new THREE.Mesh(geometry, material1)
dlyadetey_dom_odegda.position.set(-50.37, 1, 24.73)
dlyadetey_dom_odegda.scale.set(27, 2, 12.44)
dlyadetey.add(dlyadetey_dom_odegda)
const dlyadetey_dom_odegda1 = new THREE.Mesh(geometry, material1)
dlyadetey_dom_odegda1.position.set(-51.42, 1, 16.68)
dlyadetey_dom_odegda1.scale.set(11.44, 2, 3.85)
dlyadetey.add(dlyadetey_dom_odegda1)
const dlyadetey_dom_odegda2 = new THREE.Mesh(geometry, material1)
dlyadetey_dom_odegda2.position.set(-57.16, 1, 26.4)
dlyadetey_dom_odegda2.scale.set(13.72, 2, 17.84)
dlyadetey.add(dlyadetey_dom_odegda2)
const dlyadetey_dom_odegda3 = new THREE.Mesh(geometry, material1)
dlyadetey_dom_odegda3.position.set(-40.75, 1, 26.92)
dlyadetey_dom_odegda3.scale.set(8.12, 2, 16.78)
dlyadetey.add(dlyadetey_dom_odegda3)
// Совёнок
const dlyadetey_sovenok = new THREE.Mesh(geometry, material1)
dlyadetey_sovenok.position.set(59.12, 1, 2.51)
dlyadetey_sovenok.scale.set(5.93, 2, 2.68)
dlyadetey.add(dlyadetey_sovenok)
// Кари гипер
const dlyadetey_kari_giper = new THREE.Mesh(geometry, material1)
dlyadetey_kari_giper.position.set(30.55, 1, -8.32)
dlyadetey_kari_giper.scale.set(7.6, 2, 23.25)
dlyadetey.add(dlyadetey_kari_giper)
const dlyadetey_kari_giper1 = new THREE.Mesh(geometry, material1)
dlyadetey_kari_giper1.position.set(33.12, 1, 1.15)
dlyadetey_kari_giper1.scale.set(4.22, 2, 13.6)
dlyadetey.add(dlyadetey_kari_giper1)
// Kapika
const dlyadetey_kapika = new THREE.Mesh(geometry, material1)
dlyadetey_kapika.position.set(-11.5, 1, 5.25)
dlyadetey_kapika.scale.set(2.8, 2, 5.2)
dlyadetey.add(dlyadetey_kapika)
// Котофей
const dlyadetey_kotofey = new THREE.Mesh(geometry, material1)
dlyadetey_kotofey.position.set(-10.6, 1, 13)
dlyadetey_kotofey.scale.set(2.2, 2, 4.3)
dlyadetey.add(dlyadetey_kotofey)
// Gee Jay
const dlyadetey_gee_jay = new THREE.Mesh(geometry, material1)
dlyadetey_gee_jay.position.set(-30.48, 1, 13.7)
dlyadetey_gee_jay.scale.set(4.43, 2, 5.7)
dlyadetey.add(dlyadetey_gee_jay)
const dlyadetey_gee_jay1 = new THREE.Mesh(geometry, material1)
dlyadetey_gee_jay1.position.set(-31.5, 1, 21.4)
dlyadetey_gee_jay1.scale.set(2.38, 2, 9.7)
dlyadetey.add(dlyadetey_gee_jay1)
// Колясочка37
const dlyadetey_kolyasochka37 = new THREE.Mesh(geometry, material1)
dlyadetey_kolyasochka37.position.set(-65.43, 1, 20.88)
dlyadetey_kolyasochka37.scale.set(2.7, 2, 2.46)
dlyadetey.add(dlyadetey_kolyasochka37)
const dlyadetey_kolyasochka37_1 = new THREE.Mesh(geometry5, material1)
dlyadetey_kolyasochka37_1.position.set(-67.41, 1, 20.88)
dlyadetey_kolyasochka37_1.scale.set(-1.091, 1.732, 2.13)
dlyadetey.add(dlyadetey_kolyasochka37_1)
// Умка
const dlyadetey_umka = new THREE.Mesh(geometry, material1)
dlyadetey_umka.position.set(-64.44, 1, 16.07)
dlyadetey_umka.scale.set(0.76, 2, 2.58)
dlyadetey.add(dlyadetey_umka)
const dlyadetey_umka1 = new THREE.Mesh(geometry5, material1)
dlyadetey_umka1.position.set(-65.27, 1, 16.07)
dlyadetey_umka1.scale.set(-0.779, 1.732, 2.234)
dlyadetey.add(dlyadetey_umka1)
// Детский мир
const dlyadetey_detskiy_mir = new THREE.Mesh(geometry, material1)
dlyadetey_detskiy_mir.position.set(-83.76, 1, 11.47)
dlyadetey_detskiy_mir.scale.set(10.96, 2, 8.6)
dlyadetey.add(dlyadetey_detskiy_mir)
const dlyadetey_detskiy_mir1 = new THREE.Mesh(geometry, material1)
dlyadetey_detskiy_mir1.position.set(-81.45, 1, 17.69)
dlyadetey_detskiy_mir1.scale.set(6.34, 2, 21.04)
dlyadetey.add(dlyadetey_detskiy_mir1)
const dlyadetey_detskiy_mir2 = new THREE.Mesh(geometry, material1)
dlyadetey_detskiy_mir2.position.set(-80.8, 1, 28.57)
dlyadetey_detskiy_mir2.scale.set(5.04, 2, 0.72)
dlyadetey.add(dlyadetey_detskiy_mir2)
const dlyadetey_detskiy_mir3 = new THREE.Mesh(geometry5, material1)
dlyadetey_detskiy_mir3.position.set(-83.97, 1, 28.57)
dlyadetey_detskiy_mir3.scale.set(-1.126, 1.732, -0.624)
dlyadetey.add(dlyadetey_detskiy_mir3)
const dlyadetey_detskiy_mir4 = new THREE.Mesh(geometry5, material1)
dlyadetey_detskiy_mir4.position.set(-79.54, 1, 29.13)
dlyadetey_detskiy_mir4.scale.set(2.182, 1.732, -0.347)
dlyadetey.add(dlyadetey_detskiy_mir4)
const dlyadetey_detskiy_mir5 = new THREE.Mesh(geometry5, material1)
dlyadetey_detskiy_mir5.position.set(-82.06, 1, 29.13)
dlyadetey_detskiy_mir5.scale.set(-2.182, 1.732, -0.347)
dlyadetey.add(dlyadetey_detskiy_mir5)

// Товары для животных
// Фамилия
const dlyagivotnyh_familiya1 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_familiya1.position.set(-15.8, 1, 23.85)
dlyagivotnyh_familiya1.scale.set(5.8, 2, 10.6)
dlyagivotnyh.add(dlyagivotnyh_familiya1)
const dlyagivotnyh_familiya2 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_familiya2.position.set(-22.1, 1, 13.75)
dlyagivotnyh_familiya2.scale.set(7.3, 2, 5.8)
dlyagivotnyh.add(dlyagivotnyh_familiya2)
const dlyagivotnyh_familiya3 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_familiya3.position.set(-24.3, 1, 22.9)
dlyagivotnyh_familiya3.scale.set(11.65, 2, 12.5)
dlyagivotnyh.add(dlyagivotnyh_familiya3)
// Четыре лапы
const dlyagivotnyh_chetyre_lapy = new THREE.Mesh(geometry, material1)
dlyagivotnyh_chetyre_lapy.position.set(99.05, 1, 31.35)
dlyagivotnyh_chetyre_lapy.scale.set(7.8, 2, 5.3)
dlyagivotnyh.add(dlyagivotnyh_chetyre_lapy)
const dlyagivotnyh_chetyre_lapy1 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_chetyre_lapy1.position.set(100.05, 1, 36)
dlyagivotnyh_chetyre_lapy1.scale.set(5.78, 2, 4)
dlyagivotnyh.add(dlyagivotnyh_chetyre_lapy1)
// Живой мир
const dlyagivotnyh_givoy_mir = new THREE.Mesh(geometry, material1)
dlyagivotnyh_givoy_mir.position.set(-53.1, 1, 8.56)
dlyagivotnyh_givoy_mir.scale.set(2.3, 2, 6.9)
dlyagivotnyh.add(dlyagivotnyh_givoy_mir)
// Ещё
const dlyagivotnyh_esche = new THREE.Mesh(geometry, material1)
dlyagivotnyh_esche.position.set(-4.8, 1, -10.25)
dlyagivotnyh_esche.scale.set(5.2, 2, 2.1)
dlyagivotnyh.add(dlyagivotnyh_esche)
const dlyagivotnyh_pusto23 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_pusto23.position.set(-4.8, 1, -8.06)
dlyagivotnyh_pusto23.scale.set(5.2, 2, 2.32)
dlyagivotnyh.add(dlyagivotnyh_pusto23)
const dlyagivotnyh_pusto31 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_pusto31.position.set(-4.8, 1, -6.62)
dlyagivotnyh_pusto31.scale.set(5.2, 2, 0.6)
dlyagivotnyh.add(dlyagivotnyh_pusto31)
const dlyagivotnyh_pusto31_1 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_pusto31_1.position.set(-5.44, 1, -5.72)
dlyagivotnyh_pusto31_1.scale.set(3.92, 2, 2.4)
dlyagivotnyh.add(dlyagivotnyh_pusto31_1)
const dlyagivotnyh_pusto31_2 = new THREE.Mesh(geometry5, material1)
dlyagivotnyh_pusto31_2.position.set(-3.16, 1, -5.42)
dlyagivotnyh_pusto31_2.scale.set(0.554, 1.732, -1.559)
dlyagivotnyh.add(dlyagivotnyh_pusto31_2)
const dlyagivotnyh_pusto31_3 = new THREE.Mesh(geometry5, material1)
dlyagivotnyh_pusto31_3.position.set(-2.84, 1, -5.87)
dlyagivotnyh_pusto31_3.scale.set(1.108, 1.732, -0.779)
dlyagivotnyh.add(dlyagivotnyh_pusto31_3)
const dlyagivotnyh_pusto30 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_pusto30.position.set(-5.44, 1, -3.45)
dlyagivotnyh_pusto30.scale.set(3.92, 2, 2.24)
dlyagivotnyh.add(dlyagivotnyh_pusto30)
const dlyagivotnyh_mm_dekor = new THREE.Mesh(geometry, material1)
dlyagivotnyh_mm_dekor.position.set(-4.8, 1, -0.53)
dlyagivotnyh_mm_dekor.scale.set(5.2, 2, 0.5)
dlyagivotnyh.add(dlyagivotnyh_mm_dekor)
const dlyagivotnyh_mm_dekor1 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_mm_dekor1.position.set(-5.44, 1, -1.32)
dlyagivotnyh_mm_dekor1.scale.set(3.92, 2, 2.08)
dlyagivotnyh.add(dlyagivotnyh_mm_dekor1)
const dlyagivotnyh_mm_dekor2 = new THREE.Mesh(geometry5, material1)
dlyagivotnyh_mm_dekor2.position.set(-3.16, 1, -1.57)
dlyagivotnyh_mm_dekor2.scale.set(0.554, 1.732, 1.368)
dlyagivotnyh.add(dlyagivotnyh_mm_dekor2)
const dlyagivotnyh_mm_dekor3 = new THREE.Mesh(geometry5, material1)
dlyagivotnyh_mm_dekor3.position.set(-2.84, 1, -1.175)
dlyagivotnyh_mm_dekor3.scale.set(1.108, 1.732, 0.684)
dlyagivotnyh.add(dlyagivotnyh_mm_dekor3)
const dlyagivotnyh_huligan = new THREE.Mesh(geometry, material1)
dlyagivotnyh_huligan.position.set(-4.8, 1, 0.6)
dlyagivotnyh_huligan.scale.set(5.2, 2, 1.8)
dlyagivotnyh.add(dlyagivotnyh_huligan)
const dlyagivotnyh_kovr_centr = new THREE.Mesh(geometry, material1)
dlyagivotnyh_kovr_centr.position.set(-4.8, 1, 3.25)
dlyagivotnyh_kovr_centr.scale.set(5.2, 2, 3.7)
dlyagivotnyh.add(dlyagivotnyh_kovr_centr)
const dlyagivotnyh_pusto29 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_pusto29.position.set(-4.8, 1, 5.74)
dlyagivotnyh_pusto29.scale.set(5.2, 2, 1.32)
dlyagivotnyh.add(dlyagivotnyh_pusto29)
const dlyagivotnyh_pusto29_1 = new THREE.Mesh(geometry, material1)
dlyagivotnyh_pusto29_1.position.set(-5.4, 1, 6.46)
dlyagivotnyh_pusto29_1.scale.set(4, 2, 2.76)
dlyagivotnyh.add(dlyagivotnyh_pusto29_1)
const dlyagivotnyh_pusto29_2 = new THREE.Mesh(geometry5, material1)
dlyagivotnyh_pusto29_2.position.set(-2.8, 1, 7.12)
dlyagivotnyh_pusto29_2.scale.set(1.039, 1.732, -1.247)
dlyagivotnyh.add(dlyagivotnyh_pusto29_2)
// Зоозавр
const dlyagivotnyh_zoozavr = new THREE.Mesh(geometry, material1)
dlyagivotnyh_zoozavr.position.set(6.45, 1, -24.5)
dlyagivotnyh_zoozavr.scale.set(3.27, 2, 2.2)
dlyagivotnyh.add(dlyagivotnyh_zoozavr)


// Товары для творчества и рукоделия
// Леонардо
const leonardo = new THREE.Mesh(geometry, material1)
leonardo.position.set(19.2, 1, 16.5)
leonardo.scale.set(4.9, 2, 11.4)
tvorchestvo.add(leonardo)
// Читай город
const tvorchestvo_chitay_gorod = new THREE.Mesh(geometry, material1)
tvorchestvo_chitay_gorod.position.set(21.58, 1, 23.98)
tvorchestvo_chitay_gorod.scale.set(9.6, 2, 3.4)
tvorchestvo.add(tvorchestvo_chitay_gorod)
const tvorchestvo_chitay_gorod1 = new THREE.Mesh(geometry, material1)
tvorchestvo_chitay_gorod1.position.set(27.7, 1, 23.27)
tvorchestvo_chitay_gorod1.scale.set(2.7, 2, 2)
tvorchestvo.add(tvorchestvo_chitay_gorod1)
// КанцПарк
const tvorchestvo_kancpark = new THREE.Mesh(geometry, material1)
tvorchestvo_kancpark.position.set(83.92, 1, 17.92)
tvorchestvo_kancpark.scale.set(4.1, 2, 1.54)
tvorchestvo.add(tvorchestvo_kancpark)
const tvorchestvo_kancpark1 = new THREE.Mesh(geometry5, material1)
tvorchestvo_kancpark1.position.set(83.92, 1, 20.31)
tvorchestvo_kancpark1.scale.set(-3.551, 1.732, -2.806)
tvorchestvo.add(tvorchestvo_kancpark1)


// Точки общепита
// Суши мания
const obschepit_sushimania = new THREE.Mesh(geometry, material1)
obschepit_sushimania.position.set(93.13, 1, 32.18)
obschepit_sushimania.scale.set(3.78, 2, 3.64)
obschepit.add(obschepit_sushimania)
// Rostics
const obschepit_rostics = new THREE.Mesh(geometry, material1)
obschepit_rostics.position.set(38.8, 1, 36.94)
obschepit_rostics.scale.set(5.48, 2, 4.54)
obschepit.add(obschepit_rostics)
// Хали Гали
const obschepit_hali_gali = new THREE.Mesh(geometry, material1)
obschepit_hali_gali.position.set(-66.64, 1, 32.2)
obschepit_hali_gali.scale.set(5.12, 2, 6.26)
obschepit.add(obschepit_hali_gali)
const obschepit_hali_gali1 = new THREE.Mesh(geometry, material1)
obschepit_hali_gali1.position.set(-68.29, 1, 33.85)
obschepit_hali_gali1.scale.set(8.42, 2, 3.03)
obschepit.add(obschepit_hali_gali1)
// Bazar
const obschepit_bazar = new THREE.Mesh(geometry, material1)
obschepit_bazar.position.set(-94.61, 1, 28.71)
obschepit_bazar.scale.set(6.66, 2, 6.84)
obschepit.add(obschepit_bazar)
const obschepit_bazar1 = new THREE.Mesh(geometry, material1)
obschepit_bazar1.position.set(-92.5, 1, 31.13)
obschepit_bazar1.scale.set(10.88, 2, 2)
obschepit.add(obschepit_bazar1)
const obschepit_bazar2 = new THREE.Mesh(geometry5, material1)
obschepit_bazar2.position.set(-89.17, 1, 27.71)
obschepit_bazar2.scale.set(3.655, 1.732, 4.191)
obschepit.add(obschepit_bazar2)
// Узбегим
const obschepit_uzbegim = new THREE.Mesh(geometry, material1)
obschepit_uzbegim.position.set(49.03, 1, 34.78)
obschepit_uzbegim.scale.set(3.8, 2, 1.66)
obschepit.add(obschepit_uzbegim)

// Услуги
// lavita
const odegda_lavita = new THREE.Mesh(geometry, material1)
odegda_lavita.position.set(-32.45, 1, -11.55)
odegda_lavita.scale.set(4.3, 2, 1.9)
odegda.add(odegda_lavita)
// РемКомплект
const uslugi_remkomplekt = new THREE.Mesh(geometry, material1)
uslugi_remkomplekt.position.set(-73.35, 1, 33.85)
uslugi_remkomplekt.scale.set(1.55, 2, 3.03)
uslugi.add(uslugi_remkomplekt)
// Картридж
const kartridg = new THREE.Mesh(geometry, material1)
kartridg.position.set(-58.85, 1, 16.07)
kartridg.scale.set(3.2, 2, 2.58)
uslugi.add(kartridg)
// Стильнные шторы
const uslugi_stil_shtory = new THREE.Mesh(geometry, material1)
uslugi_stil_shtory.position.set(60.62, 1, 4.91)
uslugi_stil_shtory.scale.set(2.93, 2, 2)
uslugi.add(uslugi_stil_shtory)
// Время стрижки
const uslugi_vremya_strigki = new THREE.Mesh(geometry, material1)
uslugi_vremya_strigki.position.set(69.65, 1, 9.28)
uslugi_vremya_strigki.scale.set(1.8, 2, 1.9)
uslugi.add(uslugi_vremya_strigki)
// Johnsons
const uslugi_johnsons = new THREE.Mesh(geometry, material1)
uslugi_johnsons.position.set(75, 1, -14.5)
uslugi_johnsons.scale.set(2.8, 2, 2.45)
uslugi.add(uslugi_johnsons)
// Ozon
const uslugi_ozon = new THREE.Mesh(geometry5, material1)
uslugi_ozon.position.set(80.77, 1, 17.92)
uslugi_ozon.scale.set(-1.767, 1.732, -1.334)
uslugi.add(uslugi_ozon)
// Антураж
const uslugi_anturag = new THREE.Mesh(geometry, material1)
uslugi_anturag.position.set(-31.51, 1, -13.71)
uslugi_anturag.scale.set(2.42, 2, 2.26)
uslugi.add(uslugi_anturag)
const uslugi_anturag1 = new THREE.Mesh(geometry5, material1)
uslugi_anturag1.position.set(-33.66, 1, -13.71)
uslugi_anturag1.scale.set(-1.628, 1.732, 1.957)
uslugi.add(uslugi_anturag1)
// Студия лак
const uslugi_studia_lak = new THREE.Mesh(geometry, material1)
uslugi_studia_lak.position.set(-32.45, 1, -9.55)
uslugi_studia_lak.scale.set(4.3, 2, 1.9)
uslugi.add(uslugi_studia_lak)
// Cyber Service
const uslugi_cyber_service = new THREE.Mesh(geometry, material1)
uslugi_cyber_service.position.set(-62.27, 1, 16.07)
uslugi_cyber_service.scale.set(3.4, 2, 2.58)
uslugi.add(uslugi_cyber_service)
// Бизнес-Лэнд
const uslugi_biznes_lend = new THREE.Mesh(geometry, material1)
uslugi_biznes_lend.position.set(-47.57, 1, 33.18)
uslugi_biznes_lend.scale.set(5.31, 2, 4.3)
uslugi.add(uslugi_biznes_lend)
// Оперативка
const uslugi_operativka = new THREE.Mesh(geometry, material1)
uslugi_operativka.position.set(-44.53, 1, 16.58)
uslugi_operativka.scale.set(2.22, 2, 3.65)
uslugi.add(uslugi_operativka)
// Мерердиан-1
const uslugi_meredian1 = new THREE.Mesh(geometry, material1)
uslugi_meredian1.position.set(-17.55, 1, 32.24)
uslugi_meredian1.scale.set(9.43, 2, 6.1)
uslugi.add(uslugi_meredian1)
// Ивпринт
const uslugi_ivprint = new THREE.Mesh(geometry, material1)
uslugi_ivprint.position.set(-64.93, 1, 18.52)
uslugi_ivprint.scale.set(1.7, 2, 2.12)
uslugi.add(uslugi_ivprint)
const uslugi_ivprint1 = new THREE.Mesh(geometry5, material1)
uslugi_ivprint1.position.set(-66.25, 1, 18.52)
uslugi_ivprint1.scale.set(-0.814, 1.732, 1.836)
uslugi.add(uslugi_ivprint1)
// Moloko
const uslugi_moloko = new THREE.Mesh(geometry, material1)
uslugi_moloko.position.set(-71.7, 1, 31.27)
uslugi_moloko.scale.set(4.86, 2, 1.98)
uslugi.add(uslugi_moloko)
// Padel Place теннисный корт Пусто 125
const uslugi_pusto125 = new THREE.Mesh(geometry, material1)
uslugi_pusto125.position.set(-77.15, 1, 17.44)
uslugi_pusto125.scale.set(2.12, 2, 20.54)
uslugi.add(uslugi_pusto125)
const uslugi_pusto125_1 = new THREE.Mesh(geometry5, material1)
uslugi_pusto125_1.position.set(-77.15, 1, 28.31)
uslugi_pusto125_1.scale.set(1.836, 1.732, -1.04)
uslugi.add(uslugi_pusto125_1)
const uslugi_pusto125_2 = new THREE.Mesh(geometry, material1)
uslugi_pusto125_2.position.set(-73.35, 1, 14.75)
uslugi_pusto125_2.scale.set(5.48, 2, 12.64)
uslugi.add(uslugi_pusto125_2)
const uslugi_pusto125_3 = new THREE.Mesh(geometry, material1)
uslugi_pusto125_3.position.set(-74.75, 1, 16.91)
uslugi_pusto125_3.scale.set(2.68, 2, 16.96)
uslugi.add(uslugi_pusto125_3)
const uslugi_pusto125_4 = new THREE.Mesh(geometry5, material1)
uslugi_pusto125_4.position.set(-74.75, 1, 26.55)
uslugi_pusto125_4.scale.set(2.321, 1.732, -2.01)
uslugi.add(uslugi_pusto125_4)
const uslugi_pusto125_5 = new THREE.Mesh(geometry5, material1)
uslugi_pusto125_5.position.set(-72.01, 1, 23.23)
uslugi_pusto125_5.scale.set(2.425, 1.732, -3.7414)
uslugi.add(uslugi_pusto125_5)
const uslugi_pusto125_6 = new THREE.Mesh(geometry, material1)
uslugi_pusto125_6.position.set(-69.88, 1, 14.98)
uslugi_pusto125_6.scale.set(1.46, 2, -6.1)
uslugi.add(uslugi_pusto125_6)
const uslugi_pusto125_7 = new THREE.Mesh(geometry5, material1)
uslugi_pusto125_7.position.set(-69.88, 1, 19.55)
uslugi_pusto125_7.scale.set(1.264, 1.732, -2.633)
uslugi.add(uslugi_pusto125_7)
const uslugi_pusto125_8 = new THREE.Mesh(geometry5, material1)
uslugi_pusto125_8.position.set(-68.095, 1, 14.98)
uslugi_pusto125_8.scale.set(1.827, 1.732, -5.283)
uslugi.add(uslugi_pusto125_8)

const uslugi_pusto126 = new THREE.Mesh(geometry, material1)
uslugi_pusto126.position.set(-68.76, 1, 10.14)
uslugi_pusto126.scale.set(3.5, 2, 3.42)
uslugi.add(uslugi_pusto126)
const uslugi_pusto126_1 = new THREE.Mesh(geometry5, material1)
uslugi_pusto126_1.position.set(-66.51, 1, 10.14)
uslugi_pusto126_1.scale.set(0.866, 1.732, -2.962)
uslugi.add(uslugi_pusto126_1)

const uslugi_pusto124_2 = new THREE.Mesh(geometry, material1)
uslugi_pusto124_2.position.set(-72.15, 1, 9.6)
uslugi_pusto124_2.scale.set(10.18, 2, 4.9)
uslugi.add(uslugi_pusto124_2)
// Пусто 127
const uslugi_pusto127 = new THREE.Mesh(geometry, material1)
uslugi_pusto127.position.set(-69.57, 1, 6.69)
uslugi_pusto127.scale.set(6.4, 2, 3.72)
uslugi.add(uslugi_pusto127)
const uslugi_pusto127_1 = new THREE.Mesh(geometry, material1)
uslugi_pusto127_1.position.set(-66.19, 1, 7.15)
uslugi_pusto127_1.scale.set(0.36, 2, 2.6)
uslugi.add(uslugi_pusto127_1)
const uslugi_pusto127_2 = new THREE.Mesh(geometry5, material1)
uslugi_pusto127_2.position.set(-65.73, 1, 7.1)
uslugi_pusto127_2.scale.set(0.485, 1.732, -2.165)
uslugi.add(uslugi_pusto127_2)
const uslugi_pusto127_3 = new THREE.Mesh(geometry5, material1)
uslugi_pusto127_3.position.set(-65.91, 1, 5.34)
uslugi_pusto127_3.scale.set(0.797, 1.732, 0.883)
uslugi.add(uslugi_pusto127_3)
// Студия воздушной гимнастики
const uslugi_studvozdgimnast = new THREE.Mesh(geometry, material1)
uslugi_studvozdgimnast.position.set(-55.34, 1, 8.56)
uslugi_studvozdgimnast.scale.set(1.98, 2, 6.9)
uslugi.add(uslugi_studvozdgimnast)
// On-связь
const uslugi_svyaz = new THREE.Mesh(geometry, material1)
uslugi_svyaz.position.set(27.75, 1, 25.65)
uslugi_svyaz.scale.set(2.58, 2, 2.63)
uslugi.add(uslugi_svyaz)
// Химчистка Диана
const uslugi_himdiana = new THREE.Mesh(geometry5, material1)
uslugi_himdiana.position.set(67.55, 1, -22.65)
uslugi_himdiana.scale.set(-1.23, 1.732, -1.3)
uslugi.add(uslugi_himdiana)
// Ломбард
const uslugi_lombard = new THREE.Mesh(geometry, material1)
uslugi_lombard.position.set(71.645, 1, -22.61)
uslugi_lombard.scale.set(1.35, 2, 1.6)
uslugi.add(uslugi_lombard)
const uslugi_lombard1 = new THREE.Mesh(geometry5, material1)
uslugi_lombard1.position.set(73.0, 1, -22.6)
uslugi_lombard1.scale.set(1.2, 1.732, -1.4)
uslugi.add(uslugi_lombard1)
// Туристическое агентство
const uslugi_turagent = new THREE.Mesh(geometry, material1)
uslugi_turagent.position.set(-85.98, 1, 31.94)
uslugi_turagent.scale.set(2, 2, 0.38)
uslugi.add(uslugi_turagent)
const uslugi_turagent_1 = new THREE.Mesh(geometry5, material1)
uslugi_turagent_1.position.set(-85.98, 1, 30.98)
uslugi_turagent_1.scale.set(1.732, 1.732, 1.334)
uslugi.add(uslugi_turagent_1)
// Салон красоты @M&M@
const uslugi_krasota = new THREE.Mesh(geometry, material1)
uslugi_krasota.position.set(0.36, 1, -35.05)
uslugi_krasota.scale.set(4.52, 2, 2.04)
uslugi.add(uslugi_krasota)
// Офис Такси
const uslugi_taxi = new THREE.Mesh(geometry, material1)
uslugi_taxi.position.set(3.65, 1, -26.9)
uslugi_taxi.scale.set(2.1, 2, 1.6)
uslugi.add(uslugi_taxi)
uslugi.add(uslugi_taxi)
// Стирка.com
const uslugi_stirka = new THREE.Mesh(geometry, material1)
uslugi_stirka.position.set(3.65, 1, -28.77)
uslugi_stirka.scale.set(2.1, 2, 1.98)
uslugi.add(uslugi_stirka)
// Логопед
const uslugi_logoped = new THREE.Mesh(geometry, material1)
uslugi_logoped.position.set(3.65, 1, -30.7)
uslugi_logoped.scale.set(2.1, 2, 1.72)
uslugi.add(uslugi_logoped)

// Ювелирные салоны, часы
// Diamant
const diamant = new THREE.Mesh(geometry, material1)
diamant.position.set(54.36, 1, 15.13)
diamant.scale.set(1.91, 2, 3.91)
uvelir.add(diamant)
// 585 Золотой
const uvelir_585_zolotoy = new THREE.Mesh(geometry, material1)
uvelir_585_zolotoy.position.set(37.64, 1, 23.35)
uvelir_585_zolotoy.scale.set(4.5, 2, 2.4)
uvelir.add(uvelir_585_zolotoy)
// Эстет
const estet = new THREE.Mesh(geometry, material1)
estet.position.set(39.05, 1, 20.96)
estet.scale.set(7.4, 2, 2.18)
uvelir.add(estet)
const estet1 = new THREE.Mesh(geometry, material1)
estet1.position.set(41.37, 1, 22.64)
estet1.scale.set(2.75, 2, 1.2)
uvelir.add(estet1)
// Sunlight
const uvelir_sunlight = new THREE.Mesh(geometry, material1)
uvelir_sunlight.position.set(44.81, 1, 8.78)
uvelir_sunlight.scale.set(5.2, 2, 3.02)
uvelir.add(uvelir_sunlight)
const uvelir_sunlight1 = new THREE.Mesh(geometry, material1)
uvelir_sunlight1.position.set(44.27, 1, 9.51)
uvelir_sunlight1.scale.set(6.28, 2, 1.56)
uvelir.add(uvelir_sunlight1)
const uvelir_sunlight2 = new THREE.Mesh(geometry5, material1)
uvelir_sunlight2.position.set(41.67, 1, 8)
uvelir_sunlight2.scale.set(-0.935, 1.732, 1.264)
uvelir.add(uvelir_sunlight2)
// Украсим
const uvelir_ukrasim = new THREE.Mesh(geometry, material1)
uvelir_ukrasim.position.set(26.35, 1, 5.67)
uvelir_ukrasim.scale.set(0.7, 2, 4.56)
uvelir.add(uvelir_ukrasim)
const uvelir_ukrasim1 = new THREE.Mesh(geometry5, material1)
uvelir_ukrasim1.position.set(24.52, 1, 5.67)
uvelir_ukrasim1.scale.set(-2.563, 1.732, -3.949)
uvelir.add(uvelir_ukrasim1)
// остров Соколов
const uvelir_ostrov_sokolov = new THREE.Mesh(geometry, material1)
uvelir_ostrov_sokolov.position.set(32.7, 1, 19.5)
uvelir_ostrov_sokolov.scale.set(1.75, 2, 3.5)
uvelir.add(uvelir_ostrov_sokolov)

// Образовательные кружки, секции
// модельная школа Индиго
const obraz_indigo = new THREE.Mesh(geometry, material1)
obraz_indigo.position.set(-10.54, 1, -28.35)
obraz_indigo.scale.set(4.5, 2, 10.14)
obraz.add(obraz_indigo)
// Логопед
const obraz_logoped = new THREE.Mesh(geometry, material1)
obraz_logoped.position.set(3.65, 1, -30.7)
obraz_logoped.scale.set(2.1, 2, 1.72)
obraz.add(obraz_logoped)
// Футболис
const obraz_futbolis = new THREE.Mesh(geometry, material1)
obraz_futbolis.position.set(-1, 1, -30.6)
obraz_futbolis.scale.set(1.8, 2, 6.7)
obraz.add(obraz_futbolis)


group.add(apteki)
group.add(gipermarket)
group.add(accessory)
group.add(mugodegda)
group.add(genodegda)
group.add(belie)
group.add(kosmetika)
group.add(tehnika)
group.add(mebel)
group.add(odegda)
group.add(obuv)
group.add(produkty)
group.add(razvlechenie)
group.add(svyaz)
group.add(specmag)
group.add(sport)
group.add(dlyadetey)
group.add(dlyagivotnyh)
group.add(tvorchestvo)
group.add(obschepit)
group.add(uslugi)
group.add(uvelir)
group.add(obraz)
group.add(vse)
scene.add(group)

const raycaster = new THREE.Raycaster()
/**
 * Light - Свет
 */
const light = new THREE.DirectionalLight(0xffffff, 0.7)
light.position.set(0,50,10)
light.scale.set(1,1,1)
scene.add(light)
const light_l = new THREE.DirectionalLight(0xffffff, 1)
light_l.position.set(-50,10,-10)
light_l.scale.set(1,1,1)
scene.add(light_l)
const light_r = new THREE.DirectionalLight(0xffffff, 1)
light_r.position.set(50,10,-10)
light_r.scale.set(1,1,1)
scene.add(light_r)

// const pointLightHelper = new THREE.PointLightHelper( light );
// scene.add( pointLightHelper )

/**
 * Sizes Изменения по рамеру окна
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 300)
camera.position.set(0, 120, 70)
scene.add(camera)

// контроль камеры
const controls = new MapControls(camera, canvas)
controls.enableDamping = false
// controls.enablePan = false
controls.minDistance = 10
controls.maxDistance = 200
controls.maxPolarAngle = Math.PI / 2
controls.minPolarAngle = 0.01
controls.maxPolarAngle = 1.5
controls.autoRotate = false
controls.target = new THREE.Vector3(0, 1, 0)
controls.update()

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({ canvas: canvas })
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const gui = new dat.GUI({ width: 220 })
window.addEventListener('keydown', (event) =>
{
    if(event.key === 'h')
    {
        if(gui._hidden)
            gui.show()
        else
            gui.hide()
    }
})
const guimag = gui.addFolder("Выбор магазинов")
guimag.add(apteki, 'visible').name("Аптеки и оптика")
guimag.add(odegda, 'visible').name("Верхняя одежда. Меховые салоны.")
guimag.add(gipermarket, 'visible').name("Гипермаркеты")
guimag.add(accessory, 'visible').name("Магазины аксессуаров")
guimag.add(belie, 'visible').name("Магазины белья")
guimag.add(kosmetika, 'visible').name("Магазины косметики")
guimag.add(tehnika, 'visible').name("Магазины техники")
guimag.add(mebel, 'visible').name("Мебель и товары для дома")
guimag.add(genodegda, 'visible').name("Женская одежда")
guimag.add(mugodegda, 'visible').name("Мужская одежда")
guimag.add(obuv, 'visible').name("Обувь")
guimag.add(produkty, 'visible').name("Продукты питания")
guimag.add(razvlechenie, 'visible').name("Развлечения")
guimag.add(svyaz, 'visible').name("Салоны связи")
guimag.add(specmag, 'visible').name("Специализированные магазины")
guimag.add(sport, 'visible').name("Спортивные товары")
guimag.add(dlyadetey, 'visible').name("Товары для детей")
guimag.add(dlyagivotnyh, 'visible').name("Товары для животных")
guimag.add(tvorchestvo, 'visible').name("Товары для творчества и рукоделия")
guimag.add(obschepit, 'visible').name("Точки общепита")
guimag.add(uslugi, 'visible').name("Услуги")
guimag.add(uvelir, 'visible').name("Ювелирные салоны, часы")
guimag.add(obraz, 'visible').name("Образовательные кружки, секции")
/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Render
    renderer.render(scene, camera)
// цвет фона всей сцены 
// scene.background = new THREE.Color( 0xDEFEFF )
scene.background = environmentMap
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()